import React, { useEffect, useState, Fragment, useRef } from "react";
import axios from "axios";
import { uri } from "../../../../help/Api";
import { insh, sto, premiA } from "../../../../Context/InshData";
import { locSto as locStos } from "../../../../Context/Locstor";
import { getLS } from "../../../../utils/useLS";
import { transToPurch, transToSal } from "../../../../Context/Local";
import { inshF } from "../../../../Context/InshFront";
import moment from "moment";
import StopIcon from "@material-ui/icons/Stop";
import PropTypes from "prop-types";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Zoom from "@material-ui/core/Zoom";

import { useHistory, useLocation } from "react-router-dom";
import HomeBcode from "../../../../barcode/HomeBcode";
import dataF from "../../../../Server/dataF.json";
// f d
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import PostAddIcon from "@material-ui/icons/PostAdd";
import Slide from "@material-ui/core/Slide";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import MenuItem from "@material-ui/core/MenuItem";
import CssBaseline from "@material-ui/core/CssBaseline";

// f e
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Chip from "@material-ui/core/Chip";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import Switch from "@material-ui/core/Switch";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

// t
import MaterialTable, { MTableToolbar } from "material-table";
import { TableIcons as tableIcons } from "../../../../Elemnts/TableIcons";
import {
  ArrowDownward,
  Delete,
  MoreVert,
  PersonAddRounded,
  RestaurantMenu,
  Settings,
  Sync,
} from "@material-ui/icons";

// ===================================================== btn load
import clsx from "clsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckIcon from "@material-ui/icons/Check";
// ===================================================== btn load
// o com
// import CustomersDialog from '../../Customers/BackEnd/Tab1/CustomersDialog';
// Container
import Container from "@material-ui/core/Container";

import Hidden from "@material-ui/core/Hidden";
import {
  useStylesUp,
  useStylesHed,
  useStylesAuto,
  useStylesTF,
  useStylesTD,
  useStylesBA,
  useStylesFU,
  useStylesCAB,
  useStylesLbl,
  SaleCheckbox,
  useStylesDSM,
  useStylesDPM,
  StyledMenuItem,
  StyledMenu,
  useStylesSN,
  SaleSwitch,
} from "../../../../St/comps/UseStyle";

import { cellS, headerS, stElemnt } from "../../../../St/comps/cStyle";
import { Mtb } from "../../../../St/comps/vstyle";

import "../../../../St/comps/csStyle.css";
import BackdropScI from "../../../../services/BackdropScI";

import FavCard from "../../Elemnt/FavCard";
import ReConnect from "../../../../Start/ReConnect";
import OutstandingInvoiceModal from "../models/outstanding-invoice-modal";
import { getInveTypeIndex } from "../../../../modules/utils";
import { getDefaultOmla } from "../../../../services/omlat-services";
import CustomersDialog from "../../../Customers/customers/customersDialog";
import { useTranslation } from "react-i18next";
import jsPDF from "jspdf";
import toast, { Toaster } from "react-hot-toast";
import {
  handleDirectPrintTemp2,
  PrintInvoiceDirectly,
} from "../components/printSerivce";
import ExtVoucherDialog from "../components/ExtVoucherDialog";
import DeleteConfirmDialog from "../../../../components/DeleteConfirmDialog";
import PaidWindowForm from "../components/paidwidow/paidwindowform";
import { useLocalStorage } from "react-use";
import { wait } from "@testing-library/react";
import { Box, colors, Typography } from "@material-ui/core";
import { data } from "../../../Dashboard/components/LatestSales/chart";
import InvoiceItemsModals from "../models/InvoiceItemsModel";
import { render } from "react-dom/cjs/react-dom.production.min";
import InvItemsTable from "./invoiceTable";
import SearchInvoicesMains from "../models/search-model/SearchInvMains";
import ItemsDialog from "../../../bascDatas/Tab1/items/AddItems/ItamsDialog";
import InvoiceFooter from "./invoiceFooter";
import CustomerDialogData from "../../../Customers/customers/CustomerDialogData";
import { isSchema } from "yup";
import { t } from "i18next";
import { branch } from "recompose";
import MainInvoiceAppar from "./MainInvoiceAppar";
import MainInvoiceHeader from "./MainInvoiceHeader";
import i18next from "i18next";
import InvoicesExpenses from "./InvoicesExpenses/InvoicesExpenses";
import MainInvoiceDownItems from "./MainInvoiceDownItems";
import { GetItemFromOptions } from "../../../../services/global-services";
import { generateDocument } from "../../../Settings/invoice-settings/invoice-templates/test-template";
import printJS from "print-js";
import ImportExcel from "../../../bascDatas/Tab1/items/ImportExcel/ImportExcel";
import SearchInvoiceScreean from "../models/search-model/SearchInvoiceScreean";
import OutstandingInvoice from "../models/Outstanding/OutstandingInvoice";


//=====================================================================
let nevEve = "always",
  nl = null;

const useStylestolb = makeStyles((theme) => ({
  toolbarWrapper: {
    "& .MuiToolbar-gutters": {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

let LetvalueCurrUnits = null;
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      keepMounted
    >
      {value === index && (
        <Box >
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function MainInvoiceClass(props) {
  const { AutoOptions, isPurches, isStock, isMake, isDialog
  } = props;
  const cl = (c) => {
    console.log(c);
  };
  const hasRun = useRef("paper");

  const [showSc, setShowSc] = useState(true);

  let isKham = AutoOptions?.IsKham?.id;
  const clasup = useStylesUp();
  const clashd = useStylesHed();
  const clasSM = useStylesDSM();
  const clasPM = useStylesDPM();
  const clasBA = useStylesBA();
  const clasFu = useStylesFU();
  const clasCAB = useStylesCAB();
  const clasSN = useStylesSN();
  const clasAo = useStylesAuto();
  const clasTF = useStylesTF();
  const clasTD = useStylesTD();
  const claslbl = useStylesLbl();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const clstoolbar = useStylestolb();
  const [gets, setGets] = useState(insh.tbname);
  const [maxShifts, setMaxShifts] = useState(AutoOptions.maxShift.id);
  const [currentUserName, setCurrentUserName] = useState(AutoOptions.maxShift.name);
  const [invDisc, setInvDisc] = useState(insh.InvDisc);
  const [invsSearchTable, setInvsSearchTable] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [outstandData, setOutstandData] = useState([]);

  const [idata, setIData] = useState(() => {
    return { ...insh.IdataInvs, date: moment(new Date()).format("YYYY-MM-DD") };
  }); //is data in ta
  //is data in ta
  const [allow, setAllow] = useState({ c: false, s: false, it: false, cud: false });
  const [allowPaid, setAllowPaid] = useState({ c: false });
  /* Anemation */
  const [transition, setTransition] = React.useState(undefined);
  function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
  }
  function TransitionRight(props) {
    return <Slide {...props} direction="right" />;
  }
  function TransitionDown(props) {
    return <Slide {...props} direction="down" />;
  }

  const [isOpenSy, setIsOpenSy] = useState(false);

  const handleOpenSy = () => {
    setAllow({ ...allow, s: true });
    setIsOpenSy(!isOpenSy);
  }; // E rsa

  const filter = createFilterOptions();

  //rsa
  const [isOpenCustomer, setIsOpenCustomer] = useState(false);
  const [isOpenCustomerData, setIsOpenCustomerData] = useState(false);


  const [isOpenItems, setIsOpenItems] = useState(false);
  const [openPaidWindows, setOpenPaidWindows] = useState(false);
  const handleOpenCustomerData = () => {
    setAllow({ ...allow, cud: !isOpenCustomerData });
    setIsOpenCustomerData(!isOpenCustomerData);
  }; // E rsa
  const handleOpenCustomer = () => {
    setAllow({ ...allow, c: !isOpenCustomer });
    setIsOpenCustomer(!isOpenCustomer);
  }; // E rsa
  const handleOpenItems = () => {
    setAllow({ ...allow, it: !isOpenItems });
    setIsOpenItems(!isOpenItems);
  }; // E rsa
  // s Dup
  const backHome = () => {
    his.push({ pathname: "/" });
    window.location.reload(false);
  };

  // s DDown
  const [openDw, setOpenDw] = useState(false);

  const handOpenDw = (Transition) => {
    setTransition(() => Transition);
    // getInvs(
    //   dateFrom + " " + timeFrom,
    //   dateTo + " " + timeTo,
    //   null,
    //   sto.User_typei
    // );
    setOpenDw(true);
  };
  const handCloseDw = () => {
    setOpenDw(false);
  };

  const [subInfo, setSubInfo] = useState(insh.InfoSub);
  const [idSearch, setIdSearch] = useState(false);
  const [itemDownLoad, setIsItemDownLoad] = useState(false);


  const [counts, setCounts] = useState({ curr: 0 });
  const [showPaid, setShowPaid] = useLocalStorage("show-paid-window", false);
  /* s DcuD  */
  const [openCuD, setOpenCuD] = React.useState(false);

  const [dialog, setDialog] = React.useState(inshF.dia);
  useEffect(() => {
    window.onbeforeunload = function (e) {
      e.preventDefault();
      return "you can not refresh the page";
    };
  }, []);


  const handleClDia = (prop, state) => setDialog({ ...dialog, [prop]: state });
  const [openDwt, setOpenDwt] = useState(false);

  const handOpenDwt = (Transition) => {
    setTransition(() => Transition);
    getInvst(
      sto.User_typei
    );
    setOpenDwt(true);
  };
  const handCloseDwt = () => {
    setOpenDwt(false);
  };


  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
  const getInvst = async (utype) => {
    let today = moment(new Date()).format("YYYY-MM-DD");
    console.log("the data is", today)
    await axios
      .get(
        uri +
        "InvDatet" +
        `?id=${sto.empi}&&dateF=${today}&&dateT=${today}&&PcIdIvPc=${setting.PrTy_InPr}&&uType=${utype}&&bran=${sto.branchi}`
      )
      .then((res) => {
        cl("===res.data");
        cl(res.data);
        setInvsShowt(res.data);
        setInvsShowFltr(res.data);
      })
      .catch((error) => { });
  };
  /* s DcuD and McuD */
  const handCOpenCu = (Transition) => {
    setBarcodes("");
    // loadGetCountSafe();
    loadGetCountSafeByGroup();
    setTransition(() => Transition);
    setOpenCuD(true);
  };

  /* s PMD */
  const [openPMD, setOpenPMD] = useState(false);
  //const [typePress, setTypePress] = useState("save");
  let typePress = "save";
  let openPay = false;


  const handleClickOpenPMD = (Transition) => {
    setTransition(() => Transition);
    setOpenPMD(true);
  };
  const handleClickOpenPaid = (type) => {
    typePress = type;
    // setValueBankPMD

    setOpenPMD(true);
  };
  const handClosePMD = async (state) => {
    if (state === "cancle") await restPM(state);
    await setOpenPMD(false);
  };
  /* e PMD */

  /* s BCSD */

  const [barcodes, setBarcodes] = useState("");
  const { t: transForm } = useTranslation(["forms"]);
  const _onDetected = async (result) => {
    const res = [];
    const item = currencies[barcodes_eds.indexOf(result)];
    res.push(item.units);

    if (res.length > 0) {
      await BefBarcodedataCurrencie(item.id, item.units);
      setIsBarcode(true);
    }
  };
  /* e BCSD */

  const [lbl, setLbl] = React.useState(insh.Lbl);
  const [switchState, setSwitchState] = React.useState(insh.SwitchState);


  const chashVSnetwork = (valChecked) => {

    if (valChecked == true && valueType.id !== 1) {
      const text = transForm("network").toString();
      setLbl({ ...lbl, chashNetwork: text });
      setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
      setUiElement({ ...uiElement, bank: false });
      setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

      setIData({ ...idata, pay_type: 2, bank: AutoOptions.Banks[0].id });
    } else if (valChecked == false && valueType.id !== 1) {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({ ...uiElement, bank: true, stock: false });
      setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id });
      setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

    } else if (parseFloat(payment.paidup) > 0 && valChecked === true && valueType.id === 1) {
      const text = transForm("network").toString();
      setLbl({ ...lbl, chashNetwork: text });
      setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
      setUiElement({ ...uiElement, bank: false });
      setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
      setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });

    }
    else if (parseFloat(payment.paidup) > 0 && valChecked == false && valueType.id == 1) {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({ ...uiElement, bank: true });
      setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
      setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, stock: AutoOptions.Stocks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });

    }
  };
  const storgeingprem = async (info) => {
    const tb = {
      PermissionApp: true,
      wait: true,
      /*params*/
      parms: {
        iuserid: premiA.user_id,
      },
      autos: {},
    };
    await axios
      .post(uri + "Res", tb)
      .then((res) => {
        localStorage.setItem("premiApp", JSON.stringify(res.data.permisApp));
        setSwitchState({
          ...switchState,
          stayInDCurr: res.data.permisApp.stayInDCurr,
        });
      })
      .catch((error) => { });
  };

  const updatePrem = async (event) => {
    premiA.stayInDCurr = event;
    await axios
      .put(uri + "PermissionApp", premiA)
      .then((res) => {
        storgeingprem(res.data);
      })
      .catch((error) => { });
  };

  const changClick = (prop, ev) => {
    if (prop == "minus") setUiElement({ ...uiElement, [prop]: ev, rate: true });
    else if (prop == "rate")
      setUiElement({ ...uiElement, [prop]: ev, minus: true });
  };

  const changSwitch = (name) => (event) => {
    setSwitchState({ ...switchState, [name]: event.target.checked });

    if (name == "stayInDCurr") updatePrem(event.target.checked);
    else if (name == "cashORnetworksw") chashVSnetwork(event.target.checked);
  };

  const handleCloseCuD = () => {
    setCurrUnit([]);
    setOpenCuD(false);
    setSubInfo(insh.InfoSub);
  };

  const handleCloseCuDWithSWState = () => {
    switchState.stayInDCurr ? setOpenCuD(true) : setOpenCuD(false);
    setSubInfo(insh.InfoSub);
  };

  const changChckedPM = (network, agel, bank, emp, onlyCheked) => {
    onlyCheked === ""
      ? setChecked({
        ...checked,
        network_partck: network,
        agel_partck: agel,
        bank_partck: bank,
        emp_partck: emp,
      })
      : setUiElement({ ...uiElement, [onlyCheked]: false });
  };

  const changAutosPM = (bank, bank2, emp, onlyCheked) => {
    if (onlyCheked === "") {
      if (bank === false) setValueBankPMD(insh.AutoBank);
      if (bank2 === false) setValueBankTransPMD(insh.AutoBank);
      if (emp === false) setValueEmployePMD(insh.Auto);
      setUiElement({
        ...uiElement,
        bankPM: !bank,
        bankPM2: !bank2,
        empPM: !bank,
      });
    } else {
      if (onlyCheked === "bankPM") setValueBankPMD(insh.AutoBank);
      else if (onlyCheked === "bankPM2") setValueBankTransPMD(insh.AutoBank);
      else if (onlyCheked === "empPM") setValueEmployePMD(insh.Auto);
      setUiElement({ ...uiElement, [onlyCheked]: true });
    }
  };

  const restPM = (from) => {
    let ck = { network: true, agel: true, bank: true, emp: true };
    if (from === "rest") {
      if (idata.network_part === "") ck.network = false;
      if (idata.agel_part === "") ck.agel = false;
      if (idata.bank_part === "") ck.bank = false;
      if (idata.emp_part === "") ck.emp = false;
    } else {
      ck.network = false;
      ck.agel = false;
      ck.bank = false;
      ck.emp = false;
    }
    changChckedPM(ck.network, ck.agel, ck.bank, ck.emp, "");
    changAutosPM(ck.network, ck.bank, ck.emp, "");
  };
  const [or, setOr] = useState(insh.Or);
  const [ished, setIshed] = useState(insh.ished);


  const [permiElm, setPermiElm] = useState(insh.permiElm);
  const [permiCuCo, setPrmiCuCo] = useState({});

  const getPrmetions = (resDataElm, permiCuCo) => {
    setPermiElm(resDataElm);
    getAutoPricePays(permiCuCo.TSP);
    if (resDataElm.USP) {
      nevEve = "never";
    }

    setPrmiCuCo(permiCuCo);
  };

  const [uiElement, setUiElement] = useState({});
  const [permistionInv, setPermistionInv] = useState(AutoOptions.permsInvs);


  // >>>>> datas
  const [currencies, setCurrencies] = useState([]);
  const [invsShow, setInvsShow] = useState([]);
  const [invsShowt, setInvsShowt] = useState([]);
  const [exsub, setExSub] = useState(0);
  const [invsShowFltr, setInvsShowFltr] = useState([]);

  const [infoInv, setInfoInv] = useState({ id: "", InvId_Return: "" });

  const [isdata, setIsData] = useState([]); //is data in ta
  const [expenseList, setExpenseList] = React.useState([]);

  const [rowUpdate, setRowUpdate] = useState({}); //is data in ta


  const location = useLocation();

  const [stor, setStor] = useState({}); //is data in ta
  const [storS, setStorS] = useState({}); //is data in ta

  const [favGroups, setFavGroups] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupsSub, setGroupsSub] = useState([]);

  // Auto

  const [auto, setAuto] = useState(insh.auto);

  const [valueType, setValueType] = useState(insh.Auto);

  //TypeInvs
  const [valueTypeFltr, setValueTypeFltr] = useState(insh.Auto);
  //Safes
  const [valueSafes, setValueSafes] = useState(AutoOptions.Safes[0]);
  //Customers
  const [optionsCustomers, setOptionsCustomers] = useState(AutoOptions.Customers);

  const [valueCustomers, setValueCustomers] = useState(AutoOptions.Customers[0]);
  //Salesmen
  const [valueSalesmen, setValueSalesmen] = useState(AutoOptions?.salesuser);
  //Employee
  const [valueEmployePMD, setValueEmployePMD] = useState(insh.Auto);
  //Costcenter
  const [valueCostcenter, setValueCostcenter] = useState(AutoOptions?.centerUser);
  //Stock
  const [valueStock, setValueStock] = useState(AutoOptions.Stocks[0]);
  const [omlaValue, setOmlaValue] = useState(insh.Auto);
  // network
  const [valueBank, setValueBank] = useState(insh.AutoBank);
  // network PMD
  const [valueBankPMD, setValueBankPMD] = useState(insh.AutoBank);
  const [valueBanksPaid, setValueBanksPaid] = useState(insh.AutoBank);

  //Bank Trans PMD
  const [valueBankTransPMD, setValueBankTransPMD] = useState(insh.AutoBank);
  //Units

  const [countCurrBySafe, setCountCurrBySafe] = useState([]);
  const [currenciesToInv, setCurrenciesToInv] = useState([]);
  const [currUnit, setCurrUnit] = useState([]);
  const [currUnitsAll, setCurrUnitsAll] = useState([]);
  // const [optionsCurrUnits, setOptionsCurrUnits] = useState(insh.AutoOp);
  const [optionsCurrUnits, setOptionsCurrUnits] = useState(insh.AutoOp);
  const [optionsCurrUnitsTable, setOptionsCurrUnitsTable] = useState(insh.AutoOp);



  const [valueCurrUnits, setValueCurrUnits] = useState(insh.Auto);
  const [valueItemUnits, setValueItemsUnits] = useState(insh.AutoUits);
  const [valueTableUnits, setValueTableUnits] = useState(insh.AutoUits);
  const [optinsTableUnits, setOptinsTableUnits] = useState([]);



  const [indexUnit, setIndexUnit] = useState(0);
  //PricePay
  const [optionsPricePay, setOptionsPricePay] = useState(insh.AutoOp);
  const [valuePricePay, setValuePricePay] = useState(insh.Auto);
  // edrees changes
  const [itemId, setItemId] = useState("1");
  const [barcodes_eds, setBarcodes_eds] = useState();

  const handleFocus = (e) => e.target.select();
  const getAutoPricePays = (i) => {
    setOptionsPricePay(insh.optionPricePay);
    setValuePricePay(insh.optionPricePay[i]);
  };

  const afterInvExpenses = (rate) => {
    if (rate === "") rate = 0;
    for (let m = 0; m < isdata.length; m++) {
      let percRate = Number(rate);
      isdata[m].expense = ((isdata[m].totJust * percRate) / 100).toFixed(4);
    }
  };

  const addChangds = () => {

    idata.date =
      moment(idata.date).format("YYYY-MM-DD") +
      moment(new Date()).format(" h:mm A");
    idata.InvId_Return = infoInv.InvId_Return;

    if (idata.cust_id == null || idata.cust_id === "") {
      idata.cust_id = valueCustomers.id;
      idata.customer_name = valueCustomers.name;
    }
    if (idata.Due_date != null && idata.Due_date != "") {
      idata.Due_date =
        moment(idata?.Due_date).format("YYYY-MM-DD") +
        moment(new Date()).format(" h:mm A");
    }

    if (expenseList?.length > 0) {
      let sum_tot = expenseList
        ?.reduce((a, v) => (a = a + parseFloat(v?.Expense_value_Bill)), 0)
        .toFixed(2);
      let desc_perc = (
        (sum_tot * 100) /
        parseFloat(idata.tot_purch)
      );
      afterInvExpenses(desc_perc);
    }
  };


  //--------car options-----------------
  const carOptonsValue = {
    CarModel: '',
    CarYear: '',
    CarType: '',
    CarStructure: '',
    CarVactor: '',
    CarColor: '',
    CarPlatNum: '',
    curr: { currency_from: -1, symbol: "الكل" },
  };
  let items = isdata ?? [];

  const [CarItems, setCarItems] = useState(() => {
    return [{ currency_from: -1, symbol: "الكل" }, ...items];
  });
  const [carOptions, setCarOptions] = useState(carOptonsValue);
  const [showCarOptions, setShowCarOptions] = useState(false);
  const onChangeAutoCarData = (newValue) => {
    setCarOptions({ ...carOptions, curr: newValue });
  };
  const onChangeCarData = (propName) => (event) => {
    setCarOptions({
      ...carOptions, [propName]: event.target.value
    });
    setIData({ ...idata, [propName]: event.target.value });
  }
  const onSubmitCar = (data) => {
    setIData({
      ...idata, CarModel: data.CarModel, CarYear: data.CarYear,
      CarType: data.CarType, CarStructure: data.CarStructure, CarVactor: data.CarVactor,
      CarColor: data.CarColor, CarPlatNum: data.CarPlatNum
    });
    // setCarOptions(carOptonsValue);

  };


  //--------car options-----------------


  const fltringCurrencieToinv = async (res, pricePayId, changtaxperc) => {
    console.log("the response data is", res);
    if (setting.PrTy_InPr == "22") res.tax = 0;
    let sORp = 0;
    if (setting.cusType == 1) sORp = res.sale;
    else if (setting.cusType == 2) sORp = res.purch;
    if (changtaxperc == false) {
      res.tax = subInfo.taxperc;
      res.val1 = subInfo.val1;
    }
    if (pricePayId == 2) sORp = res.dPrice;
    else if (pricePayId == 3) sORp = res.jPrice;

    if (checked.autoOrStaticck === false) {
      setSubInfo({
        ...subInfo,
        hdshw: true,
        val1: res.val1,
        is_tab3_curr: res?.is_tab3_curr,
        id: res.id,
        minPrice: res.mPrice,
        Price: sORp,
        /*PricePu:res.purch,*/ barcode: res.barcode,
        symbol: res.symbol,
        type: res.type,
        perc: res.perc,
        taxperc: res.tax,
        totJust: (sORp * res.val1).toFixed(2),
        discount: "",
        DiscPers: "",
        taxval: ((sORp * res.tax) / 100).toFixed(2),
      });
    } else {
      subInfo.hdshw = true;
      subInfo.val1 = res.val1;
      subInfo.id = res.id;
      subInfo.Price = sORp;
      subInfo.minPrice = res.mPrice;
      subInfo.barcode = res.barcode;
      subInfo.symbol = res.symbol;
      subInfo.perc = res.perc;
      subInfo.taxperc = res.tax;
      subInfo.totJust = (sORp * res.val1).toFixed(2);
      subInfo.discount = "";
      subInfo.DiscPers = "";
      subInfo.type = res.type;
      subInfo.taxval = ((sORp * res.tax) / 100).toFixed(2);
      subInfo.is_tab3_curr = res.is_tab3_curr;
    }
  };
  const changCurrencieToinv = async (valuePrice, changtaxperc) => {
    const res = [];
    currUnit.map((x) => {
      if (x.barcode == subInfo.barcode) res.push(x);
    });
    let sORp = 0;

    if (setting.cusType === 1) sORp = res[0].sale;
    else if (setting.cusType === 2) sORp = res[0].purch;

    if (changtaxperc === false) {
      res[0].tax = subInfo.taxperc;
      res[0].val1 = subInfo.val1;
    }
    if (valuePrice === 2) sORp = res[0].dPrice;
    else if (valuePrice === 3) sORp = res[0].jPrice;

    setSubInfo({
      ...subInfo,
      hdshw: true,
      val1: res[0].val1,
      id: res[0].id,
      minPrice: res[0].mPrice,
      Price: sORp,
      /*PricePu:res[0].purch,*/ barcode: res[0].barcode,
      symbol: res[0].symbol,
      perc: res[0].perc,
      taxperc: res[0].tax,
      totJust: sORp * res[0].val1,
      discount: "",
      DiscPers: "",
      taxval: (sORp * res[0].tax) / 100,
    });
    // }).catch(error => {  })
  };

  const getSubGroups = async (id) => {
    // alert(id)
    const res = [];
    locStos.groupsSub.map((x) => {
      if (x.i == id) res.push(x);
    });
    setGroupsSub(res);
  };

  const reLoadLastInv = async () => {
    const tb = {
      other: true,
      parms: {
        sProcTypeInvProc: setting.PrTy_InPr,
        branch: sto.branchi,
        tname: "invs",
      },
      autos: {},
    };
    await axios
      .post(uri + "Res", tb)
      .then((res) => {
        setInfoInv({ id: res.data.other.lastid, InvId_Return: "" });
      })
      .catch((error) => { });
  };

  const loadSto = async (cusType) => {
    const locSto = getLS("sto", {});
    setGets(locSto);
    console.log("the log sto is", locSto);
    // eds changed
    setBarcodes_eds(locSto.Currencies.map((c) => c.barcode));
    /* go Func we need check Condsh */
    let valCust = cusType == 1 ? locSto.CustomersA[0] : locSto.CustomersM[0];

    loadIdata(AutoOptions.Customers[0], AutoOptions.types, AutoOptions?.Banks);

    // const safe = getSafeDefault(locSto.permisApp.user_id, locSto.Users);
    setPermistionInv(AutoOptions.permsInvs);

    setValueSafes(AutoOptions.Safes[0]);
    setValueStock(AutoOptions.Stocks[0]);
    const defOmla = getDefaultOmla(locSto.omlats);
    setOmlaValue(defOmla);
    // setOptionsCustomers(cusType == 1 ? locSto.CustomersA : locSto.CustomersM);

    setOptionsCustomers(AutoOptions.Customers);

    setValueCustomers(AutoOptions.Customers[0]);
    setCurrencies(AutoOptions.Items);

    setcuRows(
      AutoOptions.Items?.map((c) => {
        return { ...c, sale_price: c.sale_price * defOmla.exchange };
      })
    );
    setGroups(AutoOptions.groups);
    setFavGroups(locSto.CurrenciesFav);
    setCurrenciesToInv(locSto.CurrenciesToInv);
    const inveTypeIndex = getInveTypeIndex(valCust.Cust_inv_type);

    //setValueType(locSto.types[inveTypeIndex]);
    setValueTypeFltr(locSto.typesFltr[0]);
    getCustInvType(AutoOptions.Customers[0]);
  };

  const loadGet = async (branch, pTpI, empid, formid, invType) => {
    setInfoInv({ ...infoInv, id: AutoOptions.other?.lastid });
    getPrmetions(AutoOptions.permisElm, AutoOptions.permiCuCo);
    setShowSc(AutoOptions.wait?.state);
  };
  const GetConvertingInv = async (formid, PrType) => {
    const tb = {
      other: true,
      PermissionsInvs: true,
      PermissionsElemnts: true,
      PermissionsCuCo: true,
      parms: {
        sProcTypeInvProc: PrType,
        branch: sto.branchi,
        tname: "invs",
        iempid: sto.empi,
        iformid: formid,
        iformidCuCo: dataF[3].id /* for curr and yashml */,
      },
      autos: {},
    };
    await axios
      .post(uri + "GetD", tb)
      .then((res) => {
        setInfoInv({ ...infoInv, id: res?.data?.other?.lastid });
        setPermistionInv(res.data.permsInvs);
        getPrmetions(res.data.permisElm, res.data.permiCuCo);
        //  setShowSc(res.data?.wait.state);
      })
      .catch((error) => { });
  };
  const reLoadCust = async (newCustData) => {
    if (newCustData != null) {
      let newCust = {
        id: newCustData.id,
        name: newCustData.name,
        Cust_inv_type: newCustData.Cust_inv_type,
        acc_no: newCustData.acc_no,
        salesmen: newCustData.salesmen,
        CustandSup: newCustData.CustandSup,
        maxdepit: newCustData.maxdepit,
        discount: newCustData?.cust_DiscValue ?? 0,
        disc_perc: newCustData?.cust_PresValue ?? 0,
      };
      setOptionsCustomers([newCust, ...optionsCustomers]);
      setValueCustomers(newCust);
      changAutoCustomers(newCust);
    }
  };
  const reUpdateCust = (updateData) => {
    if (updateData != null) {
      var otherOptions = optionsCustomers.filter((obj) => obj.id != updateData.id);
      let newCust = {
        id: updateData.id, name: updateData.name,
        Cust_inv_type: updateData.Cust_inv_type,
        acc_no: updateData.acc_no,
        salesmen: updateData.salesmen,
        CustandSup: updateData.CustandSup,
        maxdepit: updateData.maxdepit,
        discount: updateData?.cust_DiscValue ?? 0,
        disc_perc: updateData?.cust_PresValue ?? 0,
      };
      setOptionsCustomers([newCust, ...otherOptions]);
      setValueCustomers(newCust);
      changAutoCustomers(newCust);
    }
    console.log("the oldCurr is ", updateData);
  };



  const loadGetCountSafeByGroup = async () => {
    const urlts =
      uri +
      `TaswyaBasicData/countCurrBySafe?safe=${valueSafes.id}
      &&branch=${sto.branchi}`;
    await axios
      .get(urlts)
      .then((res) => {
        setCountCurrBySafe(res.data);
        if (!permiElm.hasOwnProperty("SIM"))
          setPermiElm({ ...permiElm, SIM: true });
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const reGet = async (takei, igroupid, sSearch) => {
    if (sSearch != "" || igroupid != -1 || takei == -2) {
      takei != -1
        ? setAuto({ ...auto, group: "", groupSub: "" })
        : setSearchedCurrShow(sSearch);
      const tb = {
        Currencies: true, // wait:true,
        parms: {
          scurrenciestype: "I",
          iempid: sto.empi,
          safe: valueSafes.id,
          currShow: "M",
          currType: stor.invsType > 2 ? -1 : 2,
          igroupid: igroupid,
          takei: -1,
          sSearch: sSearch,
        },
        autos: {},
      };
      await axios
        .post(uri + "Res", tb)
        .then((res) => {
          setcuRows(res.data.Currencies);
        })
        .catch((error) => {
          /*console.log('no');*/
        });
    }
  };

  const [setting, setSetting] = useState({});
  const [style, setStyle] = useState({});

  const loadInsh = async () => {
    setSetting(location.state.setting);
    setStor(location.state.stor);
    loadGet(
      location.state.idata.branch,
      location.state.setting.PrTy_InPr,
      location.state.idata.create_user,
      location.state.setting.iformid,
      location.state.stor.invsType
    );
    loadSto(location.state.setting.cusType);
    setStorS(location.state.setting.stors);

    setStyle(location.state.style);

  };
  const loadInshDialog = async () => {
    setSetting(props.settingInv);
    setStor(props.invStor);
    loadGet(
      props.invData.branch,
      props.invData.ProcType_InvProc,
      props.invData.create_user,
      props.formid,
      props.invsType,
    );
    // loadSto(props.cusType);
    setStyle(props.invStyle);
    setStorS(props.settingInv.stors);
    const locSto = getLS("sto", {});
    setGets(locSto);
  };

  let setupReload = function () {
    // for update date in midnight
    const timeUntilMidnight = moment()
      .endOf("day")
      .add(10, "ms")
      .diff(moment(), "ms");
    return setTimeout(function () {
      setIData({ ...idata, trans_no: AutoOptions.maxShift?.id, date: moment(new Date()).format("YYYY-MM-DD") });

      setupReload();
    }, timeUntilMidnight);
  };

  /* =============================== */
  useEffect(() => {
    // loadInsh();
    // setupReload();

    if (props.isDialog == false) {
      loadInsh();
      setupReload();
    } else {
      loadInshDialog();
    }
  }, []);

  /* =============================== */

  const toDoIdata = (prop, value) => {
    setIData({ ...idata, [prop]: value });
  };
  const reInshAuto = (id, name) => {
    if (id == null && name == "") return insh.Auto;
    else return { id: id, name: name };
  };

  const loadIdata = (valCust, locStoTypes, Banks) => {
    let locR = getLS("DataRem", {});
    const inveTypeIndex = getInveTypeIndex(valCust.Cust_inv_type);

    setIData({
      ...location.state.idata,
      branch: locR.branchi,
      sales_emp: locR.empi,
      create_user: locR.idi,
      customer_name: valCust.name,
      cust_id: valCust.id,
      inv_type: AutoOptions.types[0].id,
      trans_no: AutoOptions.maxShift.id,
      date: moment(new Date()).format("YYYY-MM-DD"),
    });
    // eds change
  };

  const getCustInvType = (valCust) => {
    setUiElement(insh.UiElement);

    let kind_inv = 2;
    let locR = getLS("DataRem", {});

    const locSto = getLS("sto", {});



    if (AutoOptions.Customers[0].Cust_inv_type != null) {
      if (AutoOptions.Customers[0].Cust_inv_type == 0 || AutoOptions.Customers[0].Cust_inv_type == 2) {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: false,
          bank: true,
        });
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);

        setPayment({ ...payment, paidup: 0, stay: 0 });

        setValueStock(AutoOptions.Stocks[0]);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });
        setIData({
          ...location.state.idata,
          inv_type: 2,
          pay_type: 1,
          bank: 0,
          cust_id: valCust.id,
          stock: AutoOptions.Stocks[0].id,
          customer_name: valCust.name,
          branch: sto.branchi,
          sales_emp: sto.empi,
          create_user: sto.idi,
          date: moment(new Date()).format("YYYY-MM-DD")
        });
        //setOptionsBank(insh.AutoBankOp);
        setValueType(AutoOptions.types[1]);


      } else if (AutoOptions.Customers[0].Cust_inv_type === 1) {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: true,
          bank: true,
        });
        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);
        setIData({
          ...location.state.idata,
          inv_type: 1, pay_type: -1, bank: -1,
          cust_id: valCust.id,
          customer_name: valCust.name,
          branch: sto.branchi,
          sales_emp: sto.empi,
          create_user: sto.idi,
          date: moment(new Date()).format("YYYY-MM-DD")
        });
        setValueType(AutoOptions.types[0]);

      }
      else if (AutoOptions.Customers[0].Cust_inv_type === 3 || AutoOptions.Customers[0].Cust_inv_type === 4) {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: false,
          bank: false,
        });
        setValueStock(AutoOptions.Stocks[0]);
        setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
        setPayment({ ...payment, paidup: 0, stay: 0 });
        setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: 0 });
        setSwitchState({ ...switchState, cashORnetworksw: true });
        const text = transForm("network").toString();
        setLbl({ ...lbl, chashNetwork: text });


        setIData({
          ...location.state.idata,
          inv_type: 2,
          pay_type: 2,
          branch: sto.branchi,
          sales_emp: sto.empi,
          create_user: sto.idi,
          bank: AutoOptions.Banks[0].id,
          cust_id: AutoOptions.Customers[0].id,
          customer_name: valCust.name, date: moment(new Date()).format("YYYY-MM-DD")
        });
        setValueType(AutoOptions.types[1]); //getAutobanks(0);
      }
    } else {
      setValueStock(AutoOptions.Stocks[0]); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({
        ...uiElement,
        stock: false,
        payMethod: false,
        bank: true,
      });
      setSwitchState({ ...switchState, cashORnetworksw: false });
      setIData({
        ...location.state.idata, inv_type: 2,
        branch: locR.branchi,
        stock: AutoOptions.Stocks[0].id,
        sales_emp: sto.empi,
        create_user: locR.idi,
        pay_type: 1, bank: 0, cust_id: valCust.id,
        customer_name: valCust.name, date: moment(new Date()).format("YYYY-MM-DD")
      });

      setValueType(AutoOptions.types[1]);

    }
  }




  const changAutoType = (newValue) => {

    console.log(newValue);
    setSwitchState({ ...switchState, cashORnetworksw: false });
    setLbl({ ...lbl, chashNetwork: transForm("cash") });
    setValueType(newValue);

    let invT = newValue.id;
    if (newValue.id === 2) {
      if (switchState.cashORnetworksw === false) {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: false,
          bank: true,
        });

        setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
        setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

        const reet = reInshAuto(0, "");
        setValueBank(reet);
        setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });

        setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id, cust_id: valueCustomers.id, customer_name: valueCustomers.name, inv_type: invT });
      }
      else if (switchState.cashORnetworksw == true) {
        setUiElement({ ...uiElement, bank: false });
        setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
        setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: idata.netAmount });

        setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
        setSwitchState({ ...switchState, cashORnetworksw: true });
        setLbl({ ...lbl, chashNetwork: transForm("network") });
        setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
        setIData({
          ...idata,
          pay_type: 2,
          bank: AutoOptions.Banks[0].id,
          cust_id: valueCustomers.id, customer_name: valueCustomers.name,
          inv_type: invT,
        });
      } else {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: false,
          bank: true,
        });

        setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
        setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

        const reet = reInshAuto(0, "");
        setValueBank(reet);
        setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });

        setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id, cust_id: valueCustomers.id, customer_name: valueCustomers.name, inv_type: invT });
      }
    }
    else if (newValue.id === 1) {
      if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) > 0) {
        if (switchState.cashORnetworksw === false) {
          setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

          setIData({
            ...idata,
            pay_type: -1,
            bank: -1,
            stock: AutoOptions.Stocks[0].id,
            cash_part: payment.paidup,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: 0,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            cust_id: valueCustomers.id, customer_name: valueCustomers.name
          });
        }
        else if (switchState.cashORnetworksw === true) {
          remains.cashPart = 0;
          remains.agelPart = payment.stay;
          remains.networkPart = payment.paidup;
          remains.bankPart = 0;
          setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
          setIData({
            ...idata,
            pay_type: -1,
            bank: valueBank.id,
            cash_part: 0,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: payment.paidup,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            inv_type: invT,
            cust_id: valueCustomers.id, customer_name: valueCustomers.name
          });

        } else {
          setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
          setIData({
            ...idata,
            pay_type: -1,
            bank: -1,
            stock: AutoOptions.Stocks[0].id,
            cash_part: payment.paidup,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: 0,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            cust_id: valueCustomers.id, customer_name: valueCustomers.name
          });
        }

      } else if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) === 0) {
        setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
        setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

        setRemains({ ...remains, cashPart: 0, agelPart: idata.netAmount, bankPart: 0, networkPart: 0 });


        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);
        setIData({
          ...idata,
          pay_type: -1,
          bank: -1,
          Remaining: idata.netAmount,
          Pay_mouny: 0,
          agel_part: idata.netAmount,
          inv_type: invT,
        });
      }
      else {
        setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
        setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

        setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);
        setIData({
          ...idata, pay_type: -1, bank: -1, inv_type: invT
          , agel_part: payment.stay, Remaining: payment.stay,
          cash_part: payment.paidup
        });

      }
    }
    console.log(" the inv_type is", invT);
  };


  const changAutoss = async (e, prop) => {
    switch (prop) {
      case "group":
        await reGet(-1, e, "");
        setAuto({ ...auto, [prop]: e, groupSub: "" });
        getSubGroups(e);
        break;
      case "groupSub":
        reGet(-1, e, "");
      default:
        setAuto({ ...auto, [prop]: e });
    }
  };



  const changAutoCustomers = async (newValue) => {

    console.log(newValue);
    setSwitchState({ ...switchState, cashORnetworksw: false });
    setLbl({ ...lbl, chashNetwork: transForm("cash") });

    let invT = null;
    let checkDesc = null;
    setValueCustomers(newValue);
    newValue.Cust_inv_type == 1
      ? setValueType(AutoOptions.types[0])
      : setValueType(AutoOptions.types[1]);
    newValue.Cust_inv_type == 1
      ? (invT = AutoOptions.types[0].id)
      : (invT = AutoOptions.types[1].id);

    if (invT === 2) {

      if (newValue.Cust_inv_type != null) {
        if (newValue.Cust_inv_type == 0 || newValue.Cust_inv_type == 2 || newValue.Cust_inv_type == 5) {
          setUiElement({
            ...uiElement,
            stock: false,
            payMethod: false,
            bank: true,
          });
          remains.cashPart = idata.netAmount;
          remains.agelPart = 0;
          remains.networkPart = 0;
          remains.bankPart = 0;

          payment.paidup = idata.netAmount;
          payment.stay = 0;

          idata.pay_type = 1;
          idata.bank = 0;
          idata.inv_type = invT;
          idata.customer_name = newValue.name;
          idata.cust_id = newValue.id;
          idata.cash_part = idata.netAmount;
          idata.agel_part = 0;
          idata.bank_part = 0;
          idata.network_part = 0;
          idata.Remaining = 0;
          idata.Pay_mouny = idata.netAmount;
          setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
          setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });


          const reet = reInshAuto(0, "");
          setValueBank(reet);
          setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
          setSwitchState({ ...switchState, cashORnetworksw: false });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });



          setIData({
            ...idata,
            pay_type: 1,
            bank: 0,
            inv_type: invT,
            customer_name: newValue.name,
            cust_id: newValue.id,
          });
          checkDesc = 1;
        }
        else if (newValue.Cust_inv_type == 3 || newValue.Cust_inv_type == 4) {

          const text = transForm("network").toString();
          setLbl({ ...lbl, chashNetwork: text });
          setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
          setUiElement({ ...uiElement, bank: false });
          setSwitchState({ ...switchState, cashORnetworksw: true });
          setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: idata.netAmount });
          setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
          setIData({
            ...idata,
            pay_type: 2,
            bank: AutoOptions.Banks[0].id,
            inv_type: invT,
            customer_name: newValue.name,
            cust_id: newValue.id,
          });
          remains.cashPart = 0;
          remains.agelPart = 0;
          remains.networkPart = idata.netAmount;
          remains.bankPart = 0;

          payment.paidup = idata.netAmount;
          payment.stay = 0;

          idata.bank = AutoOptions.Banks[0].id;
          idata.pay_type = 2;
          idata.bank = 0;
          idata.inv_type = invT;
          idata.customer_name = newValue.name;
          idata.cust_id = newValue.id;
          idata.agel_part = 0;
          idata.bank_part = 0;
          idata.network_part = 0;
          idata.Remaining = 0;
          idata.Pay_mouny = idata.netAmount;
          idata.cash_part = 0;
          idata.network_part = idata.netAmount;
          checkDesc = 1;
        }
      }
      else {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: false,
          bank: true,
        });
        remains.cashPart = idata.netAmount;
        remains.agelPart = 0;
        remains.networkPart = 0;
        remains.bankPart = 0;

        payment.paidup = idata.netAmount;
        payment.stay = 0;

        idata.bank = AutoOptions.Banks[0].id;
        idata.pay_type = 2;
        idata.bank = 0;
        idata.inv_type = invT;
        idata.customer_name = newValue.name;
        idata.cust_id = newValue.id;
        idata.agel_part = 0;
        idata.bank_part = 0;
        idata.network_part = 0;
        idata.Remaining = 0;
        idata.Pay_mouny = idata.netAmount;
        idata.cash_part = idata.netAmount;
        idata.network_part = 0;
        setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
        setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

        const reet = reInshAuto(0, "");
        setValueBank(reet);
        setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });

        setIData({
          ...idata,
          pay_type: 1,
          bank: 0,
          inv_type: invT,
          customer_name: newValue.name,
          cust_id: newValue.id,
        });
        checkDesc = 1;

      }
    }
    else if (invT === 1) {

      if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) > 0) {
        if (switchState.cashORnetworksw === false) {
          payment.paidup = payment.paidup;
          payment.stay = payment.stay;

          remains.cashPart = payment.paidup;
          remains.agelPart = payment.stay;
          remains.networkPart = 0;
          remains.bankPart = 0;

          idata.pay_type = -1;
          idata.bank = -1;
          idata.stock = valueStock.id;
          idata.cash_part = payment.paidup;
          idata.Pay_mouny = payment.paidup;
          idata.Remaining = payment.stay;
          idata.bank_part = 0;
          idata.network_part = 0;
          idata.agel_part = payment.stay;
          idata.emp_part = 0;
          idata.inv_type = invT;
          idata.customer_name = newValue.name;
          idata.cust_id = newValue.id;
          setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

          setIData({
            ...idata,
            pay_type: -1,
            bank: -1,
            stock: valueStock.id,
            cash_part: payment.paidup,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: 0,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
          });
        }
        else if (switchState.cashORnetworksw === true) {

          payment.paidup = payment.paidup;
          payment.stay = payment.stay;

          remains.cashPart = 0;
          remains.agelPart = payment.stay;
          remains.networkPart = payment.paidup;
          remains.bankPart = 0;

          idata.pay_type = -1;
          idata.bank = valueBank.id;
          idata.stock = valueStock.id;
          idata.cash_part = 0;
          idata.Pay_mouny = payment.paidup;
          idata.Remaining = payment.stay;
          idata.bank_part = 0;
          idata.network_part = payment.paidup;
          idata.agel_part = payment.stay;
          idata.emp_part = 0;
          idata.inv_type = invT;
          idata.customer_name = newValue.name;
          idata.cust_id = newValue.id;
          setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

          setIData({
            ...idata,
            pay_type: -1,
            bank: valueBank.id,
            cash_part: 0,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: payment.paidup,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
          });
          checkDesc = 1;

        }
        else {

          payment.paidup = payment.paidup;
          payment.stay = payment.stay;

          remains.cashPart = payment.paidup;
          remains.agelPart = payment.stay;
          remains.networkPart = 0;
          remains.bankPart = 0;


          idata.pay_type = -1;
          idata.bank = -1
          idata.stock = valueStock.id;
          idata.cash_part = payment.paidup;
          idata.Pay_mouny = payment.paidup;
          idata.Remaining = payment.stay;
          idata.bank_part = 0;
          idata.network_part = 0;
          idata.agel_part = payment.stay;
          idata.emp_part = 0;
          idata.inv_type = invT;
          idata.customer_name = newValue.name;
          idata.cust_id = newValue.id;
          setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

          setIData({
            ...idata,
            pay_type: -1,
            bank: -1,
            stock: valueStock.id,
            cash_part: payment.paidup,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: 0,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
          });
          idata.pay_type = -1;
          idata.bank = -1
          idata.stock = valueStock.id;
          idata.cash_part = payment.paidup;
          idata.Pay_mouny = payment.paidup;
          idata.Remaining = payment.stay;
          idata.bank_part = 0;
          idata.network_part = 0;
          idata.agel_part = payment.stay;
          idata.emp_part = 0;
          idata.inv_type = invT;
          idata.customer_name = newValue.name;
          idata.cust_id = newValue.id;
          checkDesc = 1;

        }

      }
      else if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) === 0) {
        setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
        setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

        setRemains({ ...remains, cashPart: 0, agelPart: idata.netAmount, bankPart: 0, networkPart: 0 });


        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);


        remains.cashPart = 0;
        remains.agelPart = idata.netAmount;
        remains.networkPart = 0;
        remains.bankPart = 0;

        payment.paidup = 0;
        payment.stay = idata.netAmount;

        idata.pay_type = -1;
        idata.bank = -1;
        idata.stock = valueStock.id;
        idata.Pay_mouny = 0;
        idata.Remaining = idata.netAmount;
        idata.cash_part = 0;
        idata.network_part = 0;
        idata.agel_part = idata.netAmount;
        idata.emp_part = 0;
        idata.bank_part = 0;
        idata.inv_type = invT;
        idata.customer_name = newValue.name;
        idata.cust_id = newValue.id;
        setIData({
          ...idata,
          pay_type: -1,
          bank: -1,
          Remaining: idata.netAmount,
          Pay_mouny: 0,
          agel_part: idata.netAmount,
          inv_type: invT,
          customer_name: newValue.name,
          cust_id: newValue.id,
        });
        checkDesc = 1;
      }
      else {
        setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
        setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

        setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);
        payment.paidup = payment.paidup;
        payment.stay = payment.stay;

        remains.cashPart = payment.paidup;
        remains.agelPart = payment.stay;
        remains.networkPart = 0;
        remains.bankPart = 0;

        idata.pay_type = -1;
        idata.bank = -1;
        idata.stock = valueStock.id;
        idata.Pay_mouny = 0;
        idata.Remaining = payment.stay;
        idata.cash_part = payment.paidup;
        idata.agel_part = payment.stay;
        idata.network_part = 0;
        idata.emp_part = 0;
        idata.bank_part = 0;
        idata.inv_type = invT;
        idata.customer_name = newValue.name;
        idata.cust_id = newValue.id;
        setIData({
          ...idata,
          pay_type: -1,
          bank: -1,
          inv_type: invT,
          customer_name: newValue.name,
          cust_id: newValue.id,
          agel_part: payment.stay,
          Remaining: payment.stay,
          cash_part: payment.paidup
        });
        checkDesc = 1;

      }
    }
    else {
      setIData({
        ...idata,
        customer_name: newValue.name,
        cust_id: newValue.id,
      });
      idata.inv_type = invT;
      idata.customer_name = newValue.name;
      idata.cust_id = newValue.id;
      checkDesc = 1;

    }
    await clickChangeCusomers(newValue);
    //}

    console.log(" the inv_type is", invT);
  };



  const changAutoSalesMen = (newValue) => {
    setValueSalesmen(newValue);
    toDoIdata("salesman", newValue.id);
  };
  const changAutoEmployee = (newValue) => {
    setValueEmployePMD(newValue);
    toDoIdata("emp", newValue.id);
  };
  const changAutoSafes = (newValue) => {
    setValueSafes(newValue);
    toDoIdata("safe", newValue.id);
  };
  const changAutoStock = (newValue) => {
    setValueStock(newValue);
    toDoIdata("stock", newValue.id);
  };
  const changAutoOmla = (newValue) => {
    setOmlaValue(newValue);
    toDoIdata("omla", newValue.id);
  };
  const changAutoCostcenter = (newValue) => {
    setValueCostcenter(newValue);
    toDoIdata("center", newValue.id);
  };
  const changAutoBank = (newValue) => {
    setValueBank(newValue);
    toDoIdata("bank", newValue.id); /*setValueBankPMD(newValue);*/
  };
  const changAutoBankPMD = (newValue) => {
    setValueBankPMD(newValue);
    setRemains({ ...remains, networkId: newValue.id });
    toDoIdata("bank", newValue.id);
  };
  const valueAutoBankPaid = (newValue) => {
    setValueBanksPaid(newValue);
    setRemains({ ...remains, bankId: newValue.id });
    toDoIdata("bank2", newValue.id);
  };

  const changAutoPricePay = (newValue) => {

    setValuePricePay(newValue);
    setValueItemsUnits(optionsCurrUnits[0]);
    setSubInfo({
      ...subInfo,
      perc: 1,
    });
    getTypePrice(newValue);

    //if (valueItemUnits.unit === 1) { getTypePrice(newValue); }

    // currUnit.length > 0 &&
    //   changCurrencieToinv(newValue.id, insh.stateChang.taxperc);
  };
  const getTypePrice = (newVal) => {
    let newPrice = parseFloat(subInfo.Price);
    let prc = setting.cusType == 1 ? subInfo.salePrice : subInfo.PricePu;

    if (newVal.id === 1) { newPrice = parseFloat(prc); }
    else if (newVal.id === 2) { newPrice = parseFloat(subInfo.dPrice); }
    else if (newVal.id === 3) { newPrice = parseFloat(subInfo.jPrice); }
    else { newPrice = parseFloat(prc); }

    let totbef = (parseFloat(newPrice) * parseFloat(subInfo.val1));
    let tot = (parseFloat(totbef) - parseFloat(subInfo.discount));

    let restaxvalA = maths(
      parseFloat(tot),
      parseFloat(subInfo.taxperc),
      "taxval"
    );
    setSubInfo({
      ...subInfo,
      Price: newPrice,
      totJust: tot,
      taxval: restaxvalA,
      perc: 1,
    });
  };

  const changAutoCurrUnits = (op, newValue) => {
    setIndexUnit(op.nativeEvent.target.dataset.optionIndex);
    setValueItemsUnits(newValue);
    setValueCurrUnits(newValue);
    LetvalueCurrUnits = newValue;
    insh.stateChang.taxperc = false;

    setValuePricePay(insh.optionPricePay[0]);
    let prc = setting.cusType == 1 ? newValue.sale : newValue.purch;
    let totbef = (parseFloat(prc) * parseFloat(subInfo.val1));
    let tot = (parseFloat(totbef) - parseFloat(subInfo.discount));

    let restaxvalA = maths(
      parseFloat(tot),
      parseFloat(subInfo.taxperc),
      "taxval"
    );
    setSubInfo({
      ...subInfo,
      barcode: newValue.barcode ?? subInfo.barcode,
      Price: setting.cusType == 1 ? newValue.sale : newValue.purch,
      perc: newValue.perc,
      totJust: tot,
      taxval: restaxvalA,
      PricePu: newValue.purch,
      salePrice: newValue.sale,
    });
  };
  const [cuRows, setcuRows] = useState({});

  const currShowSearch = (e) => {
    setSearchedCurrShow(e.target.value);

    if (e.target.value == "") {
      const locSto = JSON.parse(localStorage.getItem("sto")) || {};
      setcuRows(locSto.Currencies);
      setAuto({ ...auto, group: "", groupSub: "" });
      setGroupsSub([]);
    }
  };
  const [searchedInvShow, setSearchedInvShow] = useState("");
  const [searchedCurrShow, setSearchedCurrShow] = useState("");

  // fillter groups

  const changFavSlides = (val) => {
    const res = gets.CurrenciesFav.filter((x) => x.favorite === val);
    setFavGroups(res);
  };

  const changSlides = (e, t) => {
    if (t === "Gmain") getSubGroups(e);

    const filteredCuRows = gets.Currencies.filter((row) => {
      return (
        row.symbol.toLowerCase().includes(e) ||
        row.nameG.toLowerCase().includes(e) ||
        row.barcode.toLowerCase().includes(e) ||
        row.sale_price.toString().toLowerCase().includes(e)
      );
    });
    setcuRows(filteredCuRows);
  };
  const [checked, setChecked] = useState(insh.Checked);
  const RestAfterGetCurrMathRate = () => {
    setInvDisc(insh.InvDisc);
    afterGetCurrMathRate("");
  };
  const changChcked = (event) => {
    if (
      event.target.name === "discMinusck" ||
      event.target.name === "discRateck"
    ) {
      RestAfterGetCurrMathRate();

      if (event.target.name === "discMinusck") {
        setChecked({
          ...checked,
          discMinusck: event.target.checked,
          discRateck: false,
        });
        setUiElement({ ...uiElement, rate: true, minus: false });
      } else if (event.target.name === "discRateck") {
        setChecked({
          ...checked,
          discMinusck: false,
          discRateck: event.target.checked,
        });
        setUiElement({ ...uiElement, rate: false, minus: true });
      }
    }

    if (event.target.name === "networkck" || event.target.name === "cashck") {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setValueBankPMD(insh.AutoBank); //setOptionsBankPMD(insh.AutoBankOp);

      if (event.target.name === "networkck") {
        setChecked({ ...checked, networkck: true, cashck: false });
        setUiElement({ ...uiElement, bank: false });
        setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
        setValueBankPMD(AutoOptions.Banks[0]); //getAutobanksPMD(0);
      } else if (event.target.name === "cashck") {
        setChecked({ ...checked, networkck: false, cashck: true });
        setUiElement({ ...uiElement, bank: true });
        // setI_Data({...idata, pay_type:1 });
      }
    }

    /* ======== for payment Diloag ======== */
    if (event.target.name == "paymentDiloagck") {
      setChecked({ ...checked, paymentDiloagck: event.target.checked });
    } else if (event.target.name == "network_partck") {
      setChecked({
        ...checked,
        network_partck: event.target.checked,
        cash_partck: true,
      });
      if (event.target.checked === true) {
        setValueBankPMD(AutoOptions.Banks[0]);
        /*getAutobanksPMD(0);*/ changChckedPM("", "", "", "", "bankPM");
        chashVSnetwork(true);
        setUiElement({ ...uiElement, bankPM: false });
      } else if (event.target.checked === false) {
        MathChckedIdata("network_part", idata.network_part);
        changAutosPM("", "", "", "bankPM");
        chashVSnetwork(false);
        setUiElement({ ...uiElement, bankPM: true });
      }
    } else if (event.target.name === "agel_partck") {
      setChecked({
        ...checked,
        agel_partck: event.target.checked,
        cash_partck: true,
      });
      if (event.target.checked === false) {
        MathChckedIdata("agel_part", idata.agel_part);
      }
    } else if (event.target.name === "bank_partck") {
      setChecked({ ...checked, bank_partck: event.target.checked });
      if (event.target.checked === true) {
        setValueBankTransPMD(AutoOptions.Banks[0]);
        /*getAutobanks2PMD(0);*/ changChckedPM("", "", "", "", "bankPM2");
      } else if (event.target.checked === false) {
        MathChckedIdata("bank_part", idata.bank_part);
        changAutosPM("", "", "", "bankPM2");
      }
    } else if (event.target.name === "emp_partck") {
      setChecked({ ...checked, emp_partck: event.target.checked });
      if (event.target.checked === true) {
        setValueEmployePMD(gets.Employees[0]);
        /*getAutoEmployePMD(0);*/ changChckedPM("", "", "", "", "empPM");
      } else if (event.target.checked === false) {
        MathChckedIdata("emp_part", idata.emp_part);
        changAutosPM("", "", "", "empPM");
      }
    } else if (event.target.name === "autoOrStaticck") {
      setChecked({ ...checked, autoOrStaticck: event.target.checked });
    }
  }; // end checked

  const fltringAutoCurrUnits = (chitem) => {
    setIndexUnit(0);
    const res = [];
    setCurrUnitsAll(chitem);
    if (checked.autoOrStaticck == false) {
      setOptionsCurrUnits(chitem);
      setValueCurrUnits(chitem[0]);
      LetvalueCurrUnits = chitem[0];
    } else LetvalueCurrUnits = chitem[0];
  };
  const BefBarcodedataCurrencie = async (id, ious) => {
    setItemId(id);
    setCurrUnit(ious);
    // permiCuCo.DTSP = false;
    await fltringAutoCurrUnits(ious);
    insh.stateChang.taxperc = true;
    await fltringCurrencieToinv(
      ious[0],
      valuePricePay.id,
      insh.stateChang.taxperc
    );
    // eds change
    await changeCountCurr(ious[0].barcode);
  };

  const onRowClicks = (rowData) => {
    if (checked.autoOrStaticck == true) {
      getBarcodeMulti(rowData?.barcode);
    } else {
      // rowClickNormal(rowData?.barcode);
      getBarcodeMultiNormal(rowData.barcode, false);

      // clickItemNormal(rowData);
    }
  };



  const rowClickNormal = async (codeItem) => {

    let item = null;
    let unitF = null;
    let ibance = null;
    let Units = null;


    if (permistionInv?.CUSTPRICE && stor.invsType != 5) {
      if (codeItem != null) {
        await axios
          .get(
            uri +
            `RptSafes/CurrCodesUnitsSubCust?currCode=${codeItem}
          &&emp=${sto.empi}
          &&safe=${valueSafes.id}&&cust_id=${valueCustomers.id}&&invType=${setting.PrTy_InPr}`
          )
          .then((res) => {

            item = res.data?.barcodes[0];
            unitF = res.data?.unitsSub[0];
            Units = res.data?.unitsSub;
            ibance = res.data?.balance[0];
            setValueItemsUnits(res.data?.unitsSub[0]);
            setOptionsCurrUnits(res.data?.unitsSub);
            setValueCurrUnits(res.data?.unitsSub[0]);
            setCurrUnit(res.data?.unitsSub);
            setValueTableUnits(res.data?.unitsSub[0]);
            setOptinsTableUnits(res.data?.unitsSub);

          })
          .catch((err) => {
            toast.error("لا يوجد صنف لهذا الباركود");
            console.log(err);
          });
        if (item != null) {
          let balance = ibance == null ? 0 : Number(ibance?.Qtys);
          getInData({ ...item }, { ...unitF }, Units, balance);
        }
        else {
          toast.error("لا يوجد صنف لهذا الباركود");
        }
      }
    } else {
      if (codeItem != null) {
        await axios
          .get(
            uri +
            `RptSafes/CurrCodesUnitsSub?currCode=${codeItem}
          &&emp=${sto.empi}
          &&safe=${valueSafes.id}`
          )
          .then((res) => {

            item = res.data?.barcodes[0];
            unitF = res.data?.unitsSub[0];
            Units = res.data?.unitsSub;
            ibance = res.data?.balance[0];
            setValueItemsUnits(res.data?.unitsSub[0]);
            setOptionsCurrUnits(res.data?.unitsSub);
            setValueCurrUnits(res.data?.unitsSub[0]);
            setCurrUnit(res.data?.unitsSub);
            setValueTableUnits(res.data?.unitsSub[0]);
            setOptinsTableUnits(res.data?.unitsSub);

          })
          .catch((err) => {
            toast.error("لا يوجد صنف لهذا الباركود");
            console.log(err);
          });
        if (item != null) {
          let balance = ibance == null ? 0 : Number(ibance?.Qtys);
          getInData({ ...item }, { ...unitF }, Units, balance);
        }
        else {
          toast.error("لا يوجد صنف لهذا الباركود");
        }
      }
    }



  };

  const getInData = (dataCode, unitF, Units, ibance) => {
    setItemId(dataCode.curr);
    setCurrUnit(unitF);
    let pricei = 0.0;
    let totJust = 0.0;
    let taxval = 0.0;
    let taxperc = 0.0;
    let diaperc = 0.0;
    let dismount = 0.0;
    let valperc = 0.0;
    if (setting.PrTy_InPr === "22") {
      taxperc = 0.0;
      pricei = parseFloat(dataCode?.purch).toFixed(2);
    } else if (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12" || setting.PrTy_InPr === "03") {
      pricei = parseFloat(dataCode?.sale);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    }
    else {
      pricei = parseFloat(dataCode?.purch);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    };
    if (valueCustomers?.disc_perc > 0 || valueCustomers?.discount > 0) {
      if (valueCustomers?.disc_perc > 0) {
        dataCode.discount = valueCustomers?.disc_perc;
        let disc_mount = (
          parseFloat(valueCustomers?.disc_perc / 100) * parseFloat(pricei)
        ).toFixed(2);
        dataCode.amount_disc = disc_mount;
      } else if (valueCustomers?.discount > 0) {
        let disc_perc = (
          (parseFloat(valueCustomers?.discount) / parseFloat(pricei)) * 100).toFixed(2);
        dataCode.discount = disc_perc;
        dataCode.amount_disc = valueCustomers?.discount;
      }
    } else {
      dismount = Number(dataCode.amount_disc);
      diaperc = Number(dataCode.discount);
      if (parseFloat(dismount) > parseFloat(pricei)) dismount = 0;
      if (diaperc > 0) {
        dataCode.discount = diaperc;
        let disc_mount = (
          parseFloat(diaperc / 100) * parseFloat(pricei)
        ).toFixed(2);
        dataCode.amount_disc = disc_mount;
      } else if (dismount > 0) {
        let disc_perc = (
          (parseFloat(dismount) / parseFloat(pricei)) * 100).toFixed(2);
        dataCode.discount = disc_perc;
        dataCode.amount_disc = dismount;
      }
    }

    taxval = ((parseFloat(pricei) * parseFloat(dataCode.tax)) / 100).toFixed(2);
    totJust = (parseFloat(pricei)).toFixed(2);
    diaperc = (parseFloat(dataCode.discount ?? 0)).toFixed(2);
    dismount = (parseFloat(dataCode.amount_disc ?? 0)).toFixed(2);
    valperc = (parseFloat(dataCode.perc)).toFixed(2);

    setSubInfo({
      ...subInfo,
      val1: 1,
      is_tab3_curr: dataCode?.is_tab3_curr,
      id: dataCode.curr,
      minPrice: dataCode.mPrice,
      Price: pricei,
      val: dataCode.perc,
      barcode: dataCode.barcode,
      symbol: dataCode.symbol,
      type: dataCode.ctype,
      perc: dataCode.perc,
      taxperc: taxperc,
      totJust: parseFloat(pricei).toFixed(2),
      discount: dismount,
      DiscPers: diaperc,
      taxval: ((pricei * taxperc) / 100).toFixed(2),
      unitame: unitF.unitName,
      jPrice: parseFloat(dataCode.jPrice),
      dPrice: parseFloat(dataCode.dPrice),
      salePrice: parseFloat(dataCode.sale),
      PricePu: parseFloat(dataCode.purch),
      UnitsTable: Units,
      defUnit: unitF,
      no: isdata?.length,
      Qtys: Number(ibance),
    });
    setCounts({ curr: ibance });
  };

  const BefrowDataCurrencie = async (id, ious) => {
    setItemId(id);

    setCurrUnit(ious);



    // permiCuCo.DTSP = false;
    await fltringAutoCurrUnits(ious);
    insh.stateChang.taxperc = true;
    await fltringCurrencieToinv(
      ious[0],
      valuePricePay.id,
      insh.stateChang.taxperc
    );
    await changeCountCurr(ious[0].barcode);
  };

  const changeCountCurr = (bc) => {
    try {
      const resCurr = [];
      countCurrBySafe.map((x) => {
        if (x.barcode == bc && x.safe == valueSafes.id) resCurr.push(x);
      });
      if (checked.autoOrStaticck === false) {
        resCurr.length != 0
          ? setCounts({ curr: resCurr[0].Qtys })
          : setCounts({ curr: 0 });
      } else {
        resCurr.length != 0
          ? (counts.curr = resCurr[0].Qtys)
          : (counts.curr = 0);
      }
    } catch (error) {
      alert("هناك خطاء في الصنف قم برماجعة الدعم الفني");
    }
  };

  const retPrmiSDPandSDV = (val, prmPandV, f) => {
    if (val > prmPandV && f === "DiscP") {
      alert(`
قيمة الخصم المدخله أكبر من قيمة الخصم المسموح
قيمة الخصم الممنوحه: ${prmPandV}
سيتم تصفير قيمة الخصم .. قم بإدخال القيمة المسموح بها مره أخرى والتي أعلى قيمه لها : ${prmPandV}
      `);
      return "";
    } else if (val > prmPandV && f === "DiscC") {
      alert(`
قيمة الخصم المدخله أكبر من قيمة الخصم المسموح
قيمة الخصم الممنوحه: ${prmPandV}
سيتم تصفير قيمة الخصم .. قم بإدخال القيمة المسموح بها مره أخرى والتي أعلى قيمه لها : ${prmPandV}
      `);
      return "";
    }
  };


  const changInfo = (prop) => (event) => {
    if (prop === "discount") {
      subInfo.DiscPers = (
        (event.target.value * 100) /
        parseFloat(subInfo.val1 * subInfo.Price)
      ).toFixed(2);
      let ret = null;
      if (permistionInv.SDV !== 0)
        ret = retPrmiSDPandSDV(
          parseFloat(event.target.value),
          permistionInv.SDV,
          "DiscC"
        );
      else ret = retPrmiSDPandSDV(subInfo.DiscPers, permistionInv.SDP, "DiscP");
      if (ret === "") {
        event.target.value = "";
        subInfo.DiscPers = "";
      }
    } else if (prop === "DiscPers") {
      subInfo.discount = (
        parseFloat(subInfo.val1 * subInfo.Price) *
        (event.target.value / 100)
      ).toFixed(2);
      let ret = null;
      if (permistionInv.SDP !== 0)
        ret = retPrmiSDPandSDV(
          parseFloat(event.target.value),
          permistionInv.SDP,
          "DiscP"
        );
      else ret = retPrmiSDPandSDV(subInfo.discount, permistionInv.SDV, "DiscC");
      if (ret === "") {
        event.target.value = "";
        subInfo.discount = "";
      }
    } else if (prop === "Price") {
      subInfo.discount = (
        parseFloat(subInfo.val1 * event.target.value) *
        (subInfo.DiscPers / 100)
      ).toFixed(2);
      subInfo.totJust = parseFloat(subInfo.val1 * event.target.value).toFixed(2);
      subInfo.taxval = parseFloat(
        (subInfo.totJust * subInfo.taxperc) / 100
      ).toFixed(2);
    } else if (prop === "totJust") {
      let prce = parseFloat(event.target.value / subInfo.val1).toFixed(2);
      subInfo.Price = prce;
      subInfo.discount = (
        parseFloat(subInfo.val1 * prce) *
        (subInfo.DiscPers / 100)
      ).toFixed(2);
      subInfo.taxval = parseFloat(
        (subInfo.totJust * subInfo.taxperc) / 100
      ).toFixed(2);
    } else if (prop === "val1") {
      subInfo.discount = (
        parseFloat(event.target.value * subInfo.Price) *
        (subInfo.DiscPers / 100)
      ).toFixed(2);
      subInfo.totJust = parseFloat(event.target.value * subInfo.Price).toFixed(
        2
      );
      subInfo.taxval = parseFloat(
        (subInfo.totJust * subInfo.taxperc) / 100
      ).toFixed(2);
    } else if (prop === "taxperc") {
      subInfo.taxval = parseFloat(
        (subInfo.totJust * event.target.value) / 100
      ).toFixed(2);
    }

    setSubInfo({ ...subInfo, [prop]: event.target.value });
  };

  const changInvs = (prop) => (event) => {
    setInfoInv({ ...infoInv, [prop]: event.target.value });
    setIData({ ...idata, InvId_Return: event.target.value });
  };

  const handClickInvs = async () => {
    if (infoInv.InvId_Return === "") {
      handOSnack({
        vertical: "top",
        horizontal: "right",
        severit: "warning",
        text: "أدخل رقم المرتجع",
        time: 2000,
      });
    } else {
      let IsSalesman = AutoOptions?.salesuser?.id == -1 || AutoOptions?.salesuser?.id == 0 ? false : true,

        EmpSales = false,

        isExsist = false,

        pipt = setting.PrTy_InPr == "12" ? "02" : "01",
        piptName = setting.PrTy_InPr == "12" ? "مبيعات" : "مشتريات";
      await axios
        .get(
          uri + `InvRet?PcIdIvPc=${setting.PrTy_InPr}&&branch=${sto.branchi}`
        )
        .then((res) => {
          console.log("res.data");
          console.log(res.data);

          for (let i = 0; i < res.data.length; i++) {
            if (
              parseInt(res.data[i].InvId_Return) ==
              parseInt(infoInv.InvId_Return)
            )
              isExsist = true;


          }
        })
        .catch((error) => { });
      if (isExsist == true) {
        handOSnack({
          vertical: "top",
          horizontal: "right",
          severit: "warning",
          text: `فاتورة ${piptName} المدخلة تم إرجاعها مسبقا`,
          time: 4000,
        });
      }
      else {
        await axios
          .get(
            uri +
            `InvRet?id=${infoInv.InvId_Return}&&PcIdIvPc=${pipt}&&branch=${sto.branchi}`
          )
          .then((res) => {
            if (res.data?.sales_emp != sto.empi) {
              EmpSales = IsSalesman == false ? false : true;
              if (IsSalesman == true) {
                handOSnack({
                  vertical: "top",
                  horizontal: "center",
                  severit: "warning",
                  text: "فاتورة المبيعات المراد ارجاعها تم ادخالها من قبل موظف اخر",
                  time: 4000,
                });
              } else {
                if (AutoOptions?.StepTwo?.id == 1 && !isUpdateDate && setting.PrTy_InPr === "12") {
                  showChosedInv(false, res.data.proc_id, true);
                } else {
                  if (permistionInv?.SAMEDATE) {
                    showChosedInv(false, res.data.proc_id, false);
                  } else {
                    showChosedInv(false, res.data.proc_id, true);
                  }
                }

                setOr({ ...or, postput: "toPost" });
              }
            } else {
              if (AutoOptions?.StepTwo?.id == 1 && !isUpdateDate && setting.PrTy_InPr === "12") {
                showChosedInv(false, res.data.proc_id, true);
              } else {
                if (permistionInv?.SAMEDATE) {
                  showChosedInv(false, res.data.proc_id, false);
                } else {
                  showChosedInv(false, res.data.proc_id, true);
                }
              }

              setOr({ ...or, postput: "toPost" });

            }

          })
          .catch((error) => {
            handOSnack({
              vertical: "top",
              horizontal: "right",
              severit: "warning",
              text: "رقم المرتجع غير موجود",
              time: 2000,
            });
          });
      } // else c
    } // else m

    // eds changes
    if (!stor.hasOwnProperty("comt")) setStor({ ...stor, comt: -1 });
  };
  const beZero = () => {
    setStor({ ...stor, comt: -1 });
    if (subInfo.discount === "") subInfo.discount = 0;
    if (subInfo.DiscPers === "") subInfo.DiscPers = 0;
    if (subInfo.Price === "") subInfo.Price = 0;
    if (subInfo.val1 === "") subInfo.val1 = 0;
    if (subInfo.perc === "") subInfo.perc = 0;
    if (subInfo.taxperc === "") subInfo.taxperc = 0;
    if (subInfo.taxval === "") subInfo.taxval = 0;
    if (subInfo.totJust === "") subInfo.totJust = 0;
  };

  const getrowDataCurrencie = async (props) => {
    beZero();
    or.cros = "newRow";
    or.PrAC = 0;
    let maxQty = parseFloat(permistionInv?.MAXQTY ?? 100000);
    let maxPrice = parseFloat(permistionInv?.MAXPRICE ?? 100000);

    if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
      if (subInfo.barcode != "") {
        if (parseFloat(subInfo.val1) != 0) {
          let val1InSub = 0,
            countsCurr = 0,
            minCurrPrice = 0,
            subInfoVal1_perc = subInfo.val1 * subInfo.perc;
          minCurrPrice = (parseFloat(subInfo.minPrice) * parseFloat(subInfo.perc)).toFixed(2);
          for (let m = 0; m < isdata.length; m++) {
            if (subInfo.barcode == isdata[m].barcode)
              val1InSub = isdata[m].val1;
          }
          countsCurr = Number(subInfo.Qtys) - parseInt(val1InSub);

          if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12") {

            if (permistionInv.SNOP === true && subInfo != null && parseFloat(subInfo.Price) < parseFloat(subInfo.PricePu)) {
              alert(
                `لا يمكن البيع اقل من سعر الشراء للصنف سعر الشراء المسجل للصنف هو : ${subInfo.PricePu}`
              );
            }
            else if (parseFloat(subInfo.val1) > parseFloat(maxQty)) {
              alert(
                `لقد تجاوزت حد الكمية المسموح فيها... برجاء الذهاب لاعدادات النظام لزيادة الحد: ${maxQty}`
              );
            }
            else if (parseFloat(subInfo.Price) > parseFloat(maxPrice)) {
              alert(
                `لقد تجاوزت حد السعر المسموح فيه... برجاء الذهاب لاعدادات النظام لزيادة الحد:  ${maxPrice}`
              );
            }
            else if (permistionInv.SNOMIN === 1 && parseFloat(subInfo.Price) < parseFloat(minCurrPrice)) {
              alert(
                `لا يمكن البيع اقل من السعر الادنى للصنف السعر الادنى المسجل للصنف هو : ${minCurrPrice}`
              );
            } else if (permistionInv.ASPZ === false && subInfo.Price <= 0) {
              alert(
                `لا يوجد لديك صلاحية البيع بسعر صفر `
              );
            }
            else if (permistionInv.SIM == false &&
              countsCurr < subInfoVal1_perc && subInfo.type != 4 &&
              (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
              alert(
                `
              الكمية المدخلة للصنف أكبر من رصيد المخزن
              الكمية الاجمالية المدخلة : ${parseFloat(subInfo.val1) * parseFloat(subInfo.perc)
                }
              رصيد المخزن : ${valueSafes.name} = ${parseInt(counts.curr) - parseInt(val1InSub)
                }
              `
              );
            }
            else if (permistionInv.APDC === 1 && permistionInv.DSOI == 1 && parseFloat(subInfo.DiscPers) > parseFloat(permistionInv.SDP)) {
              alert(
                `
              لقد تجاوزت نسبة الخصم المسموح بها
              نسبة الخصم المسموح بها : ${parseFloat(permistionInv.SDP)
                }
              `
              );
            }
            else if (permistionInv.APDC === 2 && permistionInv.DSOI == 1 && parseFloat(subInfo.discount) > parseFloat(permistionInv.SDV)) {
              alert(
                `
              لقد تجاوزت مبلغ الخصم المسموح بها
              مبلغ الخصم المسموح بة : ${parseFloat(permistionInv.SDV)
                }
              `
              );
            }
            else if (permistionInv.APDC === 3 && permistionInv.DSOI == 1 &&
              ((parseFloat(permistionInv.SDV) != 0 && subInfo.discount > permistionInv.SDV) ||
                (parseFloat(permistionInv.SDP) != 0 && parseFloat(subInfo.DiscPers) > parseFloat(permistionInv.SDP)))) {
              alert(
                `
              لقد تجاوزت حد الخصم المسموح بها
                }
              `
              );
            } else if (parseFloat(subInfo.val1) < 0 || parseFloat(subInfo.val1) == 0) {
              alert(
                `
            لا يمكن تنزيل الصنف بكمية سالبة او صفرية
                }
              `
              );
            } else if (parseFloat(subInfo.Price) < 0) {
              alert(
                `
              لا يمكن البيع بقيمة سالبة
                }
              `
              );
            }
            else {
              for (let m = 0; m < isdata.length; m++) {
                if (
                  parseInt(subInfo.Price) ==
                  parseInt(isdata[m].new_exchange_price) &&
                  subInfo.barcode == isdata[m].barcode
                ) {
                  or.cros = "rnewRow";
                  or.i = m;
                  break;
                } else {
                  or.cros = "newRow";
                }
              }
              await handRowAdd(or);
              if (props === "dialog") { await handleCloseCuDWithSWState(); }
              await handleClDia("fav", false);
              await setSubInfo(insh.InfoSub);
              if (props === "main") {
                await setRptParams({ ...rptParams, barcodeNormal: '', barcodeS: '', curr: {} });
              }
              setCurrUnit([]);
            }
          }
          else {
            for (let m = 0; m < isdata.length; m++) {
              if (
                parseInt(subInfo.Price) ==
                parseInt(isdata[m].new_exchange_price) &&
                subInfo.barcode == isdata[m].barcode
              ) {
                or.cros = "rnewRow";
                or.i = m;
                break;
              } else {
                or.cros = "newRow";
              }
            }

            await handRowAdd(or);
            if (props === "dialog") { await handleCloseCuDWithSWState(); }
            await handleClDia("fav", false);
            await setSubInfo(insh.InfoSub);
            if (props === "main") {
              await setRptParams({ ...rptParams, barcodeNormal: '', barcodeS: '', curr: {} });
            }
            setCurrUnit([]);
          }
        } /* end Val1 */ else {
          alert("لا يمكنك التنزيل الكمية 0");
        }
      } /* end barcode */ else {
        alert("لا يوجد باركود للصنف تحقق من البيانات");
      }
    } else {
      if (subInfo.barcode !== "") {
        if (parseFloat(subInfo.val1) !== 0) {
          let val1InSub = 0;
          for (let m = 0; m < isdata.length; m++) {
            if (subInfo.barcode == isdata[m].barcode)
              val1InSub = isdata[m].val1;
          }

          if (permistionInv.ASPZ === 1 || subInfo.Price > 0) {
            for (let m = 0; m < isdata.length; m++) {
              if (
                parseInt(subInfo.Price) ==
                parseInt(isdata[m].new_exchange_price) &&
                subInfo.barcode == isdata[m].barcode
              ) {
                or.cros = "rnewRow";
                or.i = m;
                break;
              } else {
                or.cros = "newRow";
              }
            }

            await handRowAdd(or);
            if (props === "dialog") { await handleCloseCuDWithSWState(); }
            await setSubInfo(insh.InfoSub);
            if (props === "main") {
              await setRptParams({ ...rptParams, barcodeNormal: '', barcodeS: '', curr: {} });
            }
            setCurrUnit([]);
          } /* price > 0 */ else alert("السعر اقل من صفر");
        } /* end Val1 */ else {
          alert("لا يمكنك التنزيل الكمية 0");
        }
      } /* end barcode */ else {
        alert("لا يوجد باركود للصنف تحقق من البيانات");
      }
    }
  };

  // const noGetThings = () => { return null;}
  const noGetThings = () => { };
  const [procIdSearch, setProcIdSearch] = useState(0);
  const [openButtonsSearch, setOpenButtonsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = React.useState(0);
  const [valueE, setValueE] = React.useState(0);

  const inputRefAuto = useRef(null);
  const inputRefNormal = useRef(null);

  const keepFocus = () => {
    inputRefAuto.current.focus();
  };
  const handNewInv = () => {
    // alert('hand New Inv');
    setValue(0);
    setExpenseList([]);
    setIsUpdateDate(false);
    setIsLoading(false);
    setProcIdSearch(0);
    setOpenButtonsSearch(false);
    setIshedden(false);
    setIsOpenUpdate(false);
    setPdfToggle(null);
    reLoadLastInv();
    setIsData([]);
    setValueCustomers(AutoOptions.Customers[0]); //getAutoCustomers(0);
    setValueSalesmen(AutoOptions?.salesuser);
    // setValueCostcenter(insh.Auto);
    setValueCostcenter(AutoOptions?.centerUser);

    // condshSet_ValueType
    const inveTypeIndex = getInveTypeIndex(optionsCustomers[0].Cust_inv_type);

    // changAutoType(AutoOptions.types[inveTypeIndex], false); //chang_AutoType(optionsType[1]);
    setValueStock(AutoOptions.Stocks[0]); //getAutoStocks(0);
    setOmlaValue(getDefaultOmla(gets.omlats));
    // const safe = getSafeDefault(gets.permisApp.user_id, gets.Users);
    let invKind = null;

    if (AutoOptions.Customers[0].Cust_inv_type != null) {
      if (AutoOptions.Customers[0].Cust_inv_type == 0 || AutoOptions.Customers[0].Cust_inv_type == 2) {
        setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
        setUiElement({ ...uiElement, bank: true });

        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });
        setUiElement({ ...uiElement, bank: true });
        setIData({
          ...location.state.idata,
          inv_type: 2, pay_type: 1, bank: 0, cust_id: optionsCustomers[0].id,
          customer_name: AutoOptions.Customers[0].name,
          date: keepDate && setting.PrTy_InPr === "01" ? dateKeep.Date : moment(new Date()).format("YYYY-MM-DD")
          , trans_no: AutoOptions.maxShift.id,
        });
        setValueStock(AutoOptions.Stocks[0]); //setOptionsBank(insh.AutoBankOp);
        setValueType(AutoOptions.types[1]);
        invKind = AutoOptions.types[1].id;
      } else if (AutoOptions.Customers[0].Cust_inv_type == 1) {
        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);
        setIData({
          ...location.state.idata, inv_type: 1, pay_type: -1, bank: -1, cust_id: AutoOptions.Customers[0].id,
          customer_name: AutoOptions.Customers[0].name,
          date: keepDate && setting.PrTy_InPr === "01" ? dateKeep.Date : moment(new Date()).format("YYYY-MM-DD"),
          trans_no: AutoOptions.maxShift.id,
        });
        setValueType(AutoOptions.types[0]);
        invKind = AutoOptions.types[0].id;
      } else if (AutoOptions.Customers[0].Cust_inv_type == 3 || AutoOptions.Customers[0].Cust_inv_type == 4) {

        const text = transForm("network").toString();
        setLbl({ ...lbl, chashNetwork: text });
        setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
        setUiElement({ ...uiElement, bank: false });

        setSwitchState({ ...switchState, cashORnetworksw: true });
        setValueType(AutoOptions.types[1]); //getAutobanks(0);
        invKind = AutoOptions.types[1].id;
        setIData({
          ...location.state.idata, inv_type: 2, pay_type: 2, bank: AutoOptions.Banks[0].id, cust_id: AutoOptions.Customers[0].id,
          customer_name: optionsCustomers[0].name,
          date: keepDate && setting.PrTy_InPr === "01" ? dateKeep.Date : moment(new Date()).format("YYYY-MM-DD"),
          trans_no: AutoOptions.maxShift.id,
        });
      }
    } else {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({ ...uiElement, bank: true });
      setSwitchState({ ...switchState, cashORnetworksw: false });
      setIData({
        ...location.state.idata, inv_type: 2, pay_type: 1, bank: 0, cust_id: AutoOptions.Customers[0].id,
        customer_name: AutoOptions.Customers[0].name,
        date: keepDate && setting.PrTy_InPr === "01" ? dateKeep.Date : moment(new Date()).format("YYYY-MM-DD"),
        trans_no: AutoOptions.maxShift.id,
      });
      setValueStock(AutoOptions.Stocks[0]); //setOptionsBank(insh.AutoBankOp);
      setValueType(AutoOptions.types[1]);
      setRemains(insh.Remains);
      invKind = AutoOptions.types[1].id;
    }

    setValueSafes(AutoOptions.Safes[0]);

    setSums(insh.Sums);
    setStor({ ...stor, comt: -1 });
    setExSub(0);
    setPayment(insh.Payment);
    setIsClick(insh.ished);
    setRemains(insh.Remains);


    setChecked({
      ...checked,
      costWithVat: true,
      discMinusck: false,
      discRateck: false,
      networkck: false,
      cashck: true,
      network_partck: false,
      cash_partck: false,
      agel_partck: false,
      bank_partck: false,
      emp_partck: false,
    });
    setOr(insh.Or);
    setIshed(insh.ished);
    setPermiElm({ ...permiElm, SaUp: permistionInv.Sa });
  };

  const goAlert = () => {
    handOSnack({
      vertical: "top",
      horizontal: "center",
      severit: "warning",
      // background: isPurches ? "#008080" : isStock ? "#3f51b5" : colors.green[500],
      text: `
      لقد تجاوزت نسبة الخصم المسموح بها
      نسبة الخصم المسموح بها : ${parseFloat(permistionInv.SDP)
        }`,
      time: 2000,
    });
    return 0;
  };
  const goAlertV = () => {
    alert(`
    لقد تجاوزت مبلغ الخصم المسموح به
    مبلغ الخصم المسموح بها : ${parseFloat(permistionInv.SDV)
      }`
    );

    return 0;
  };
  const goAlertVal = () => {

    return 1;
  };
  const goAlertPrice = () => {

    return 0;
  };
  let templatePrintFile = '';


  var columnsInvSub = [
    { title: "المعرف", field: "id", hidden: true, rowStyle: stElemnt.SubR },
    {
      title: transForm("item_number"),
      field: "currency_from",
      hidden: true,
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("barcode_number"),
      field: "barcode",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("item"),
      field: "symbol",
      editable: "never",
      rowStyle: stElemnt.SubMu,
    },
    {
      title: transForm("unit"),
      field: "unitame",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("quanity"),
      field: "val1",
      editComponent: (props) => (
        <TextField
          variant="outlined"
          size="small"
          className={[clasTF.rootmt, clasTF.mtTval1]}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("packaging"),
      field: "val",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("price"),
      field: "new_exchange_price",
      type: "numeric",
      editable: "always",
      editComponent: (props) => (
        <TextField
          disabled={!permistionInv.USP}
          variant="outlined"
          size="small"
          className={[clasTF.rootmt, clasTF.mtTpric]}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("total"),
      field: "totJust",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },

    {
      title: transForm("discount_mount"),
      field: "discount",
      type: "numeric",
      editable: "always",
      editComponent: (props) => (
        <TextField
          id="discount"
          name="discount"
          disabled={
            (permistionInv.APDC === 2 || permistionInv.APDC === 3) && permistionInv.DSOI == 1
              ? false
              : true
          }
          variant="outlined"
          size="small"
          className={clasTF.rootmt}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) =>
            props.onChange(
              e.target.value > permistionInv.SDV ? goAlertV() : e.target.value === "" ? goAlertVal() : e.target.value
            )
          }
        />
      ),
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("discount_perc"),
      field: "DiscPers",
      type: "numeric",
      //editable:nevEve,
      editable: "always",
      editComponent: (props) => (
        <TextField
          disabled={
            (permistionInv.APDC === 1 || permistionInv.APDC === 3) && permistionInv.DSOI == 1
              ? false
              : true
          }
          variant="outlined"
          size="small"
          className={[clasTF.rootmt, clasTF.mtTdisc]}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) =>
            props.onChange(
              e.target.value > permistionInv.SDP ? goAlert() : e.target.value === "" ? goAlertVal() : e.target.value
            )
          }
        />
      ),
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("total_after_discount"),
      field: "totAfterDisc",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("tobacco_tax"),
      field: "tab3Val",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("vat_perc"),
      field: "taxperc",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("vat_total"),
      // title: "إجمالي القيمة المضافة",
      field: "taxval",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("net"),
      field: "netAmountSub",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: "ملاحظات",
      field: "",
      hidden: true,
      editComponent: (props) => (
        <TextField
          variant="outlined"
          size="small"
          className={clasTF.rootmt}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      hidden: true,
      rowStyle: stElemnt.SubR,
    },
    {
      title: transForm("note"),
      field: "notes",
      editComponent: (props) => (
        <TextField
          variant="outlined"
          size="small"
          className={[clasTF.rootmt, clasTF.mtTnote]}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      rowStyle: stElemnt.SubR,
    },

    {
      title: setting.priceNM,
      field: "sale_price",
      hidden: true,
      editComponent: (props) => (
        <TextField
          variant="outlined"
          size="small"
          className={[clasTF.rootmt, clasTF.mtTpric]}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      rowStyle: stElemnt.SubR,
    },
  ];


  // func m t

  const befPushTos = async () => {
    addChangds();
  };

  let his = useHistory();
  const [base64String, setBase64String] = useState();
  const [generating, setGenerating] = useState(false);

  const toPrint = async (type, e, hist) => {

    or.PrAC = hist;
    if (isdata.length == 0) {
      handOSnack({
        vertical: "top",
        horizontal: "center",
        severit: "warning",
        text: transForm("most_download_item"),
        time: 2000,
      });
    } else {
      await toWhere(type, e);
    }

  };

  const toPrintCashOrNetwork = (type, e, hist, valChecked) => {
    let isSave = 0;
    if (valChecked == true && valueType.id !== 1) {
      const text = transForm("network").toString();
      setLbl({ ...lbl, chashNetwork: text });
      setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
      setUiElement({ ...uiElement, bank: false });
      setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

      setIData({ ...idata, pay_type: 2, bank: AutoOptions.Banks[0].id });
      isSave = 1;

      setValueType(AutoOptions.types[1]);

      remains.networkPart = idata.netAmount;
      remains.agelPart = 0;
      remains.bankPart = 0;
      remains.cashPart = 0;
      idata.bank = AutoOptions.Banks[0].id
      idata.pay_type = 2;
      idata.inv_type = 2;
      idata.cash_part = 0;
      idata.agel_part = 0;
      idata.bank_part = 0;
      idata.network_part = idata.netAmount;

      setChecked({
        ...checked,
        cash_partck: false,
        network_partck: true,
        agel_partck: false,
      });
      isSave = 1;

    } else if (valChecked == false && valueType.id !== 1) {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({ ...uiElement, bank: true, stock: false });
      setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id });
      setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

      setValueType(AutoOptions.types[1]);
      remains.cashPart = idata.netAmount;
      remains.agelPart = 0;
      remains.bankPart = 0;
      remains.networkPart = 0;
      idata.pay_type = 1;
      idata.inv_type = 2;
      idata.cash_part = idata.netAmount;
      idata.agel_part = 0;
      idata.bank_part = 0;
      idata.network_part = 0;

      setChecked({
        ...checked,
        cash_partck: true,
        network_partck: false,
        agel_partck: false,
      });
      isSave = 1;


    } else if (parseFloat(payment.paidup) > 0 && valChecked === true && valueType.id === 1) {
      const text = transForm("network").toString();
      setLbl({ ...lbl, chashNetwork: text });
      setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
      setUiElement({ ...uiElement, bank: false });
      setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
      setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
      setValueType(AutoOptions.types[0]);
      remains.networkPart = payment.paidup;
      remains.agelPart = payment.stay;
      remains.bankPart = 0;
      remains.cashPart = 0;
      idata.bank = AutoOptions.Banks[0].id
      idata.pay_type = -1;
      idata.inv_type = 1;
      idata.cash_part = payment.stay;
      idata.agel_part = 0;
      idata.bank_part = 0;
      idata.network_part = payment.paidup;

      setChecked({
        ...checked,
        cash_partck: false,
        network_partck: true,
        agel_partck: false,
      });
      isSave = 1;

    }
    else if (parseFloat(payment.paidup) > 0 && valChecked == false && valueType.id == 1) {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({ ...uiElement, bank: true });
      setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
      setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, stock: AutoOptions.Stocks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
      isSave = 1;


      setValueType(AutoOptions.types[0]);
      remains.cashPart = payment.paidup;
      remains.agelPart = payment.stay;
      remains.bankPart = 0;
      remains.networkPart = 0;
      idata.pay_type = -1;
      idata.inv_type = 1;
      idata.cash_part = payment.paidup;
      idata.agel_part = payment.stay;
      idata.bank_part = 0;
      idata.network_part = 0;

      setChecked({
        ...checked,
        cash_partck: true,
        network_partck: false,
        agel_partck: false,
      });
      isSave = 1;
    }
    if (isSave == 1) { toPrint(type, e, hist); }

  };
  const handPrint = async (procid) => {
    const serializedinv = JSON.stringify({
      proc_id: procid,
      invN: setting.titleHed,
      invNEn: setting.titleHedEn,
      salesman: valueSalesmen.name,
      backInv: "InvSO",
      branch: sto.branchi,
      ProcTypeInvProc: setting.PrTy_InPr,
      Delivery: permistionInv?.PRNTOUT,
      Step_inv2: AutoOptions?.StepTwo?.id === 1 ? true : false,
      Direct: i18next.language == "ar" ? true : false,
      NRound: permistionInv?.ROUND == null ? 4 : permistionInv?.ROUND,
      // UseBefore:permiCuCo?.USBEF,
    });
    await localStorage.setItem("datainv", serializedinv);
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    if (or.PrAC === 1) {
      if (premiApp?.cashirTemplate == 3) {
        his.push({ pathname: "/RestCasher" });
      } else if (premiApp?.cashirTemplate == 2) {
        his.push({ pathname: "/CashairNoTax" });
      }
      else if (premiApp?.cashirTemplate == 4) {
        his.push({ pathname: "/CashairInv" });
      }
      else if (premiApp?.cashirTemplate == 5) {
        his.push({ pathname: "/CashairInv" });
      } else if (premiApp?.cashirTemplate == 6) {
        his.push({ pathname: "/CashairNoTax" });
      }
      else if (premiApp?.cashirTemplate == 7) {
        his.push({ pathname: "/CashairInv" });
      }
      else {
        his.push({ pathname: "/C" });
      }
    } else if (or.PrAC === 2) {
      if (premiApp?.billTemplate == 4) {
        his.push({ pathname: "/bill4" });
      } else if (premiApp?.billTemplate == 3) {
        his.push({ pathname: "/gold-bill" });
      } else if (premiApp?.billTemplate == 18) {
        his.push({ pathname: "/bill4" });
      }
      else if (premiApp?.billTemplate == 5) {
        his.push({ pathname: "/RevCompany" });
      } else if (premiApp?.billTemplate == 6) {
        his.push({ pathname: "/RevInv" });
      } else if (premiApp?.billTemplate == 7) {
        his.push({ pathname: "/bill2" });
      }
      else if (premiApp?.billTemplate == 9) {
        his.push({ pathname: "/RevCompany" });
      }
      else if (premiApp?.billTemplate == 8) {
        his.push({ pathname: "/bill4" });
      }
      else if (premiApp?.billTemplate == 10) {
        his.push({ pathname: "/EngInv" });
      }
      else if (premiApp?.billTemplate == 2) {

        his.push({ pathname: "/bill2" });
        // window.open( "/bill2");
      } else if (premiApp?.billTemplate == 11) {

        his.push({ pathname: "/A" });
        // window.open( "/bill2");
      }
      else if (premiApp?.billTemplate == 12) {
        his.push({ pathname: "/A" });
        // window.open( "/bill2");
      }
      else if (premiApp?.billTemplate == 14) {

        his.push({ pathname: "/A" });
        // window.open( "/bill2");
      } else if (premiApp?.billTemplate == 16) {
        his.push({ pathname: "/RevInv" });
      } else if (premiApp?.billTemplate == 19) {
        his.push({ pathname: "/RevInv" });
      } else if (premiApp?.billTemplate == 21) {
        his.push({ pathname: "/RevCompany" });
      } else if (premiApp?.billTemplate == 22) {
        his.push({ pathname: "/RevCompany" });
      }  else if (premiApp?.billTemplate == 24|| premiApp?.billTemplate == 25 || 
        premiApp?.billTemplate == 26 ||premiApp?.billTemplate == 27) {
        his.push({ pathname: "/RevCompany" });
      } else if (premiApp?.billTemplate == 23) {
        his.push({ pathname: "/bill4" });
      }
      else his.push({ pathname: "/A" });
    } else if (or.PrAC === 3) {
      setGenerating(true);
      await handleDirectPrintTemp2(
        JSON.parse(serializedinv),
        isdata.length,
        handNewInv
      );
      // await PrintInvoiceDirectly(JSON.parse(serializedinv), handNewInv);
      setGenerating(false);
    } else if (or.PrAC === 4) {
      handNewInv();

      setGenerating(true);
      await PrintInvoiceDirectly(JSON.parse(serializedinv), true, handNewInv);
      setGenerating(false);
    } else if (or.PrAC === 5) {
      await PrintInvoiceDirectly(
        JSON.parse(serializedinv),
        true,
        handNewInv
      );
    } else if (or.PrAC === 6) {
      setGenerating(true);
      const invoiceDataTemp = { proc_id: procid, branchId: sto.branchi, procTypeInvProc: setting.PrTy_InPr };
      await generateDocument(setBase64String, templatePrintFile, invoiceDataTemp);
      await handNewInv();
      setGenerating(false);
    }
  };

  useEffect(() => {
    if (base64String) { PrintPdf(); console.log(" i'm in form pdf printpdf") }
  }, [base64String]);
  const PrintPdf = () => printJS({ printable: base64String, type: "pdf", base64: true });

  const PushTos = async (t) => {
    setIsLoading(true);
    befPushTos();
    dateKeep.Date = moment(idata.date).format('YYYY-MM-DD');
    let Sa_or_Pa_rest_id = null;
    console.log("the data is", remains);

    await ButtonLoading(t);

    const model = {
      inv: {
        ...idata,
        Pay_mouny: payment.paidup ? payment.paidup : 0,
        Remaining: payment.stay,
        agel_part: remains.agelPart,
        cash_part: remains.cashPart,
        network_part: remains.networkPart,
        bank_part: remains.bankPart,
        emp_part: remains.empPart,
        trans_no: maxShifts,
        center: valueCostcenter.id ?? -1,
        cust_id: valueCustomers.id,
        customer_name: valueCustomers.name,
      },
      //stor: stor,
      stor: {
        ...stor,
        Step_inv2: AutoOptions?.StepTwo?.id === 1 ? true : false,
        isOrder: false,
        orderId: 0
      },

      parms: {
        omlaId: omlaValue?.id,
        tobaccoFees: premiA.tobaccoFees,
        omlaExchange: omlaValue?.exchange,
        iuserid: idata.create_user,
        iformidCuCo: dataF[3].id,
        proc_type: setting.routIS == "Inv_Sub_ToS/" ? 2 : 1,
        yashml: permiCuCo.yashml == "W",
        isAgel: remains?.isAgel,
        isCash: remains?.isCash,
        isNetwork: remains?.isNetwork,
        isBank: remains?.isBank,
        isEmp: remains?.isEmp,
        isWindow: remains?.isWindow,
        empId: remains?.empId,
        // bankId: remains?.bankId,
        bankId: valueBanksPaid?.id,
        networkId: valueBankPMD?.id,
        updatePrice: permistionInv?.UPDATEPRICE ?? false,
      },
      State: "Post",
      _Data: isdata,
      expenses: expenseList,
    };

    if (or.postput == "toPost") {
      await axios
        .post(uri + "_HInv", model)
        .then((resI) => {
          /*console.log('done I_po');*/
          console.log(" the  data is", model);

          if (or.PrAC !== 0) handPrint(resI.data.proc_id);
          ButtonSuccess(t, true);
        })
        .catch((resI) => {
          handOSnack({
            vertical: "top",
            horizontal: "right",
            severit: "warning",
            text:
              "لم يتم اضافة الفاتورة" + "بسبب " + resI.response?.data?.Message,
            time: 2000,
          });

          ButtonSuccess(t, false);
        });
    } else if (or.postput == "toPut") {
      await ButtonLoading(t);
      // I_Pu
      console.log(" the  data is", model);


      // if (permistionInv.IPU) {
      if (permistionInv.Up && isOpenUpdate) {

        await axios
          .put(uri + "_HInv", model)
          .then((resI) => {
            if (resI?.data?.id == null) {
              handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text:
                  resI?.data,
                time: 2000,
              });
              if (or.PrAC !== 0) handPrint(model.inv.proc_id);
              // ButtonSuccess(t, true);
              if (isDialog == true) { props.onClose(); } else { ButtonSuccess(t, true); }

            } else {
              console.log(" the  data is", model);

              if (or.PrAC !== 0) handPrint(resI.data.proc_id);
              if (isDialog == true) { props.onClose(); } else { ButtonSuccess(t, true); }
            }
            /*console.log('done I_po');*/

          })
          .catch((resI) => {
            handOSnack({
              vertical: "top",
              horizontal: "center",
              severit: "warning",
              text:
                "لم يتم تعديل الفاتورة" +
                "  " +
                "بسبب " +
                resI.response?.data?.Message,
              time: 2000,
            });
            ButtonSuccess(t, false);
          });
      } else {

        const tb = { inv: idata, stor: stor };

        await axios
          .put(uri + "Inv_R_RS_", tb)
          .then((resI_Pu) => {
            /*console.log('done I_Pu');*/

            if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
              Sa_or_Pa_rest_id = resI_Pu.data.sale_rest_id;
            else Sa_or_Pa_rest_id = resI_Pu.data.purch_rest_id;


            if (or.PrAC !== 0) handPrint(resI_Pu.data.proc_id);
            // ButtonSuccess(t, true);
            if (isDialog == true) { props.onClose(); } else { ButtonSuccess(t, true); }

          })
          .catch((resI_Pu) => {
            // if(isDialog==true){props.onClose();}else{  ButtonSuccess(t, true);}

            ButtonSuccess(t, false);
            /*console.log('no I_Pu');*/
          });
      }
    }
  };

  const PushTost = async (t) => {
    befPushTos();
    let Sa_or_Pa_rest_id = null;
    if (or.postput == "toPost") {
      await ButtonLoading(t);
      const tb = {
        invtemp: idata,
        stor: stor,
        parms: {
          iuserid: idata.create_user,
          iformidCuCo: dataF[3].id,
        },
      };

      await axios
        .post(uri + "Inv_R_RS__", tb)
        .then((resI) => {
          /*console.log('done I_po');*/
          axios
            .post(
              uri +
              setting.routIS +
              permiCuCo.yashml +
              "?pcid=" +
              resI.data.proc_id +
              "&&State=Postt",
              isdata
            )
            .then((resS) => {
              /*console.log('done IS_po');*/
              if (or.PrAC !== 0) handPrint(resI.data.proc_id);
              ButtonSuccess(t, true);
            })
            .catch((resS) => {
              /*console.log('no IS_po');*/
            });
        })
        .catch((resI) => {
          ButtonSuccess(t, false);
        });
    }
    if (or.postput == "toPut") {
      await ButtonLoading("t");
      // I_Pu
      const tb = { inv: idata, stor: stor };

      await axios
        .put(uri + "Inv_R_RS", tb)
        .then((resI_Pu) => {
          /*console.log('done I_Pu');*/

          if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
            Sa_or_Pa_rest_id = resI_Pu.data.sale_rest_id;
          else Sa_or_Pa_rest_id = resI_Pu.data.purch_rest_id;

          // R_Pu
          axios
            .put(uri + "Restrictions" + "?pcid=" + resI_Pu.data.proc_id)
            .then((retR_Pu) => {
              /*console.log('done R_Pu');*/
            })
            .catch((retR_Pu) => {
              /*console.log('no R_Pu');*/
            });

          // IS_De&Po
          axios
            .post(
              uri +
              setting.routIS +
              permiCuCo.yashml +
              "?pcid=" +
              resI_Pu.data.proc_id +
              "&&State=rePost",
              isdata
            )
            .then((resIS_Po) => {
              /*console.log('done resIS_Po');*/
            })
            .catch((resIS_Po) => {
              /*console.log('no resIS_Po');*/
            });

          // RS_De&Po
          axios
            .post(uri + "Restrictions_Sub" + "?idR=" + Sa_or_Pa_rest_id, idata)
            .then((resRS_Po) => {
              /*console.log('done RS_Po');*/
            })
            .catch((resRS_Po) => {
              /*console.log('no RS_Po');*/
            });

          /* E inner */
          if (or.PrAC !== 0) handPrint(resI_Pu.data.proc_id);
          ButtonSuccess("t", true);
        })
        .catch((resI_Pu) => {
          ButtonSuccess(t, false); /*console.log('no I_Pu');*/
        });
    }
  };
  const deleteTos = async (e) => {



    await e.preventDefault();
    setConfirmDialog({ ...confirmDialog, isOpen: false });
    ButtonLoading("delete");

    await axios.delete(uri + `_HInv?id=${idata.proc_id}`).then(res => {
      toast.success("invoice has deleted");
      ButtonSuccess("delete", true);

    }).catch(err => {
      console.log("eror", err)
      ButtonSuccess("delete", false);
      toast.error("not delete ")
    })
    // await axios
    //   .delete(uri + setting.routI_R_RS + "?pcid=" + parseInt(idata.proc_id))
    //   .then((resIsRs) => {
    //     ButtonSuccess("delete", true);
    //   })
    //   .catch((resIsRs) => {
    //     ButtonSuccess("delete", false);
    //   });
  };

  const loadePayMents = () => {
    //  alert(idata.netAmount)
    setPayment({
      ...payment,
      paidupPMDcn: payment.paidup,
      stayPMDcn: payment.stay,
    });

    if (switchState.cashORnetworksw == false && valueType.id == 2) {
      setChecked({
        ...checked,
        cash_partck: true,
        network_partck: false,
        agel_partck: false,
      });
      setIData({
        ...idata,
        cash_part: idata.netAmount,
        network_part: "",
        agel_part: "",
        emp_part: "",
        bank_part: "",
        check_refno: "",
        netAmountPMDcn: idata.netAmount,
      });
    } else if (switchState.cashORnetworksw == true && valueType.id == 2) {
      setChecked({
        ...checked,
        cash_partck: false,
        network_partck: true,
        agel_partck: false,
      });
      setIData({
        ...idata,
        cash_part: "",
        network_part: idata.netAmount,
        agel_part: "",
        emp_part: "",
        bank_part: "",
        check_refno: "",
        netAmountPMDcn: idata.netAmount,
      });


      setValueBankPMD(valueBank); //setOptionsBankPMD(optionsBank);
    }
    // else if (valueType.id === 1) {
    //   setChecked({
    //     ...checked,
    //     network_partck: false,
    //     cash_partck: false,
    //     agel_partck: true,
    //   });
    //   setIData({
    //     ...idata,
    //     cash_part: "",
    //     network_part: "",
    //     agel_part: idata.netAmount,
    //     emp_part: "",
    //     bank_part: "",
    //     check_refno: "",
    //     netAmountPMDcn: idata.netAmount,
    //   });
    // }
    else if (valueType.id === 1) {

      if (payment.paidup > 0) {

        alert(payment.paidup)
        if (switchState.cashORnetworksw == false) {
          // setChecked({
          //   ...checked,
          //   cash_partck: false,
          //   network_partck: false,
          //   agel_partck: true,
          // });
          setIData({
            ...idata,
            cash_part: payment.paidup,
            network_part: "",
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
          });
        } else if (switchState.cashORnetworksw == true) {
          setChecked({
            ...checked,
            cash_partck: false,
            network_partck: true,
            agel_partck: true,
          });
          setIData({
            ...idata,
            cash_part: "",
            network_part: payment.paidup,
            agel_part: payment.stay,
            emp_part: "",
            bank_part: "",
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
          });
          setValueBankPMD(valueBank); //setOptionsBankPMD(optionsBank);

        }
      } else {
        setChecked({
          ...checked,
          cash_partck: false,
          network_partck: false,
          agel_partck: true,
        });
        setIData({
          ...idata,
          cash_part: payment.paidup,
          network_part: "",
          agel_part: payment.stay,
          emp_part: "",
          bank_part: "",
          check_refno: "",
          netAmountPMDcn: idata.netAmount,
        });
      }


    }


  };

  const usedPayedWindow = (v) => {
    if (v === 0) idata.used_payed_window = v;
    else idata.used_payed_window = v;
  };

  // ============================================ btn load
  const [loading, setLoading] = useState(insh.LoadAndSucc);
  const [success, setSuccess] = useState(insh.LoadAndSucc);
  const timer = React.useRef();

  const buttonClassnameSave = clsx({
    [clasCAB.buttonSuccessCAB]: success.save,
  });
  const buttonClassnameSavetmp = clsx({
    [clasCAB.buttonSuccessCAB]: success.savetmp,
  });

  const buttonClassnameSavePMD = clsx({
    [clasCAB.buttonSuccessCAB]: success.savePMD,
  });

  const buttonClassnameDelete = clsx({
    [clasCAB.buttonSuccessCAB]: success.delete,
  });

  const buttonClassnamePrint = clsx({
    [clasCAB.buttonSuccessCAB]: success.print,
  });
  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const ButtonLoading = (prop) => {
    setLoading({ ...loading, [prop]: true });
  };
  const ButtonSuccess = (prop, state) => {
    timer.current = window.setTimeout(() => {
      setLoading({ ...loading, [prop]: false });
      setSuccess({ ...success, [prop]: true });
      if (
        prop == "delete" ||
        prop == "save" ||
        prop == "savetmp" ||
        prop == "savePMD"
      ) {
        if (state) handNewInv();
      }
      if (prop == "savePMD") {
        handClosePMD("done");
      }

      timer.current = window.setTimeout(() => {
        setSuccess({ ...success, [prop]: false });
      }, 500);
    }, 2000);
  };
  // ========================================== btn load


  const toDB = async (type, e) => {
    // if (checked.paymentDiloagck === true) {
    if (showPaid === true && type !== "savetmp") {
      if ((or.postput == "toPut" && isOpenUpdate) || or.postput == "toPost") {
        if (parseFloat(idata.netAmount) !== parseFloat(remains.allpart)) {
          alert("المبلغ غير متساوي");
        } else if (isdata.length == 0) {
          alert(" لا يوجد اصناف في الجدول ");
        } else if (parseFloat(idata.netAmount) == 0) {
          alert(" لا يمكن حفظ الفاتورة باجمالي صفر    ");
        }
        else {
          handClosePMD("cancle");
          await PushTos(type);
        }
      } else {

        usedPayedWindow(0);

        if (type == "savetmp") {
          await PushTost(type);
        } else {
          await PushTos(type);
        }
      }
    } else {

      usedPayedWindow(0);
      if (type == "savetmp") {
        await PushTost(type);
      } else {
        await PushTos(type);
      }
    }
  };

  const paidFun = (type) => {


    if (valueType.id == 2) {
      setRemains({
        ...remains,
        cashPart: switchState.cashORnetworksw == false ? idata.netAmount : 0,
        agelPart: 0,
        bankPart: 0,
        networkPart: switchState.cashORnetworksw == true ? idata.netAmount : 0,
        empPart: 0,
        isCash: switchState.cashORnetworksw == false,
        isWindow: true,
        isNetwork: switchState.cashORnetworksw == true,
        isAgel: false,
        isEmp: false,
        allpart: idata.netAmount,
        typePress: type,
      });
      // setValueBank(gets.Banks[0]); //getAutobanks(0);

    } else if (valueType.id == 1 && parseFloat(payment.paidup) > 0) {
      setRemains({
        ...remains,
        cashPart: switchState.cashORnetworksw == false ? payment.paidup : 0,
        agelPart: payment.stay,
        bankPart: 0,
        networkPart: switchState.cashORnetworksw == true ? payment.paidup : 0,
        empPart: 0,
        isCash: switchState.cashORnetworksw == false,
        isWindow: true,
        isAgel: true,
        isEmp: false,
        isNetwork: switchState.cashORnetworksw == true,
        allpart: idata.netAmount,
        typePress: type,
      });

    } else {
      setRemains({
        ...remains,
        cashPart: 0,
        agelPart: idata.netAmount,
        bankPart: 0,
        networkPart: 0,
        empPart: 0,
        isCash: false,
        isWindow: true,
        isAgel: true,
        isEmp: false,
        isNetwork: false,
        allpart: idata.netAmount,
        typePress: type,
      });
    }

    setValueBankPMD(switchState.cashORnetworksw ? valueBank : AutoOptions.Banks[0]);
    setValueBanksPaid(AutoOptions.Banks[0]);
    setValueEmployePMD(gets.Employees[0]);
    setPayment({ ...payment, paidupPMDcn: payment.paidup, stayPMDcn: payment?.stay });
  }

  const sendToZatca = async (t) => {

    console.log("the data is", idata);
    const model = {
      ...idata,
      Pay_mouny: payment.paidup ? payment.paidup : 0,
      Remaining: payment.stay,
      agel_part: remains.agelPart,
      cash_part: remains.cashPart,
      network_part: remains.networkPart,
      bank_part: remains.bankPart,
      emp_part: remains.empPart,
    };
    if (or.postput == "toPut") {
      setLoading(true);
      await ButtonLoading(t);
      // I_Pu
      console.log(" the  data is", model);

      const URL = uri + "Zatca/SignInvAndSendToZatca";
      await axios
        .post(URL, model)
        .then((resI) => {
          ButtonSuccess(t, true);
        })
        .catch((resI) => {
          handOSnack({
            vertical: "top",
            horizontal: "right",
            severit: "warning",
            text:
              "لم يتم submite الفاتورة" +
              "  " +
              "بسبب " +
              resI.response?.data?.Message,
            time: 2000,
          });
          ButtonSuccess(t, false);
        });
    }
  };
  const toPrintTemplate = async (fileName) => {
    // setTemplatePrintFile(fileName);
    templatePrintFile = fileName;
    console.log("theFilename ", templatePrintFile);
    or.PrAC = 6;
    if (isdata.length > 0) await toWhere("print", "e");
    else
      handOSnack({
        vertical: "top",
        horizontal: "right",
        severit: "warning",
        text: "يجب تنزيل اصناف",
        time: 2000,
      });
  };


  const toWhere = (type, e) => {
    if (type === "save") or.PrAC = 0;
    if (valueCustomers.id === null || valueCustomers.id === "") {
      handOSnack({
        vertical: "top",
        horizontal: "center",
        severit: "warning",
        text: "تاكد من اختيار العميل",
        time: 2000,
      });
    } else {
      if (isdata.length === 0) {
        // alert(" لا يوجد اصناف في الجدول ");
        handOSnack({
          vertical: "top",
          horizontal: "center",
          severit: "warning",
          text: "لا يوجد اصناف في الجدول ... برجاء تنزيل الاصناف",
          time: 2000,
        });
      } else {
        if (AutoOptions?.StepTwo?.id == 1 && (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")) {
          const tb = {
            CustStepTwo: true,
            parms: {
              cust_id: valueCustomers?.id,
            },
          };
          axios
            .post(uri + "GetD", tb)
            .then((res) => {
              if (res.data?.StepTwoNotes?.notes === "Good") {
                toWhereSave(type, e);
              } else {
                handOSnack({
                  vertical: "top",
                  horizontal: "center",
                  severit: "warning",
                  text: res.data?.StepTwoNotes?.notes,
                  time: 2000,
                });
              }
            })
            .catch((error) => {
              toWhereSave(type, e);
            });
        } else {
          toWhereSave(type, e);
        }
      }

    }



  };


  const toWhereSave = (type, e) => {
    if (parseFloat(payment.paidup) > parseFloat(idata.netAmount)) {
      if ((setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")) {
        if (switchState.cashORnetworksw == true) {
          setValueType(AutoOptions.types[1]);

          remains.networkPart = idata.netAmount;
          remains.agelPart = 0;
          remains.bankPart = 0;
          remains.cashPart = 0;


          idata.pay_type = 2;
          idata.inv_type = 2;
          idata.cash_part = 0;
          idata.agel_part = 0;
          idata.bank_part = 0;
          idata.network_part = idata.netAmount;

          setChecked({
            ...checked,
            cash_partck: false,
            network_partck: true,
            agel_partck: false,
          });
          blurPaid2(payment.paidup);

        }
        else {
          setValueType(AutoOptions.types[1]);
          remains.cashPart = idata.netAmount;
          remains.agelPart = 0;
          remains.bankPart = 0;
          remains.networkPart = 0;


          idata.pay_type = 1;
          idata.inv_type = 2;
          idata.cash_part = idata.netAmount;
          idata.agel_part = 0;
          idata.bank_part = 0;
          idata.network_part = 0;

          setChecked({
            ...checked,
            cash_partck: true,
            network_partck: false,
            agel_partck: false,
          });
          blurPaid2(payment.paidup);

        }
      }
      else {

        if (switchState.cashORnetworksw == true) {
          setValueType(AutoOptions.types[1]);
          remains.networkPart = idata.netAmount;
          remains.agelPart = 0;
          remains.bankPart = 0;
          remains.cashPart = 0;
          remains.empPart = 0;
          payment.paidup = idata.netAmount;
          payment.stay = 0;

          idata.pay_type = 2;
          idata.inv_type = 2;
          idata.cash_part = 0;
          idata.agel_part = 0;
          idata.bank_part = 0;
          idata.network_part = idata.netAmount;

          setChecked({
            ...checked,
            cash_partck: false,
            network_partck: true,
            agel_partck: false,
          });
          if (isdata.length > 0) {
            if (showPaid === true && type !== "savetmp") {
              if ((or.postput == "toPut" && isOpenUpdate) || or.postput == "toPost") {
                paidFun(type);
                handleClickOpenPaid(type);
              } else {
                toDB(type, e);
              }
            } else {
              toDB(type, e);
            }
          }
          else {
            // handOSnack({ vertical: 'top', horizontal: 'center' });
            handOSnack({
              vertical: "top",
              horizontal: "right",
              severit: "warning",
              text: transForm("most_download_item"),
              time: 2000,
            });
          }


        }
        else {
          setValueType(AutoOptions.types[1]);
          remains.cashPart = idata.netAmount;
          remains.agelPart = 0;
          remains.bankPart = 0;
          remains.networkPart = 0;


          payment.paidup = idata.netAmount;
          payment.stay = 0;
          idata.pay_type = 1;
          idata.inv_type = 2;
          idata.cash_part = idata.netAmount;
          idata.agel_part = 0;
          idata.bank_part = 0;
          idata.network_part = 0;

          setChecked({
            ...checked,
            cash_partck: true,
            network_partck: false,
            agel_partck: false,
          });
          if (isdata.length > 0) {
            if (checked.paymentDiloagck === true) {
              loadePayMents();
              handleClickOpenPMD(TransitionRight);
            } else

              toDB(type, e);
          }
          else {
            // handOSnack({ vertical: 'top', horizontal: 'center' });
            handOSnack({
              vertical: "top",
              horizontal: "right",
              severit: "warning",
              text: transForm("most_download_item"),
              time: 2000,
            });
          }


        }
      }

    }
    else {
      if (isdata.length > 0 && parseFloat(idata.netAmount) > 0) {
        if (showPaid === true && type !== "savetmp") {
          // loadePayMents();
          if ((or.postput == "toPut" && isOpenUpdate) || or.postput == "toPost") {
            paidFun(type);
            handleClickOpenPaid(type);
          } else {
            toDB(type, e);
          }
        } else

          toDB(type, e);
      } else if (isdata.length === 0) {
        // alert(" لا يوجد اصناف في الجدول ");
        handOSnack({
          vertical: "top",
          horizontal: "center",
          severit: "warning",
          text: transForm("no_item_in_table"),
          time: 2000,
        });
      } else if (parseFloat(idata.netAmount) === 0) {
        handOSnack({
          vertical: "top",
          horizontal: "center",
          severit: "warning",
          text: transForm("cant_save_zero_invoice"),
          time: 2000,
        });
      }
      else {
        // handOSnack({ vertical: 'top', horizontal: 'center' });
        handOSnack({
          vertical: "top",
          horizontal: "right",
          severit: "warning",
          text: transForm("most_download_item"),
          time: 2000,
        });
      }
    }
  };

  const hRowrAdd = (newData, resolve) => {
    let restaxvalrA = 0,
      resDiscPerA = 0,
      restotJustSumrA = 0,
      restotJustAfterDiscSumrA = 0,
      resDisCountrA = 0,
      resVal1SumrA = 0,
      resNetrA = 0,
      tot_before_new = 0,
      tot_before_vat_with_tab3val = 0,
      tot_befor_vat_after_disc = 0;

    resVal1SumrA = parseFloat(subInfo.val1) + parseFloat(isdata[or.i].val1);
    restotJustSumrA =
      parseFloat(isdata[or.i].new_exchange_price) * resVal1SumrA;
    resDisCountrA = (
      restotJustSumrA * parseFloat(subInfo.DiscPers / 100)
    ).toFixed(2);
    restotJustAfterDiscSumrA =
      parseFloat(restotJustSumrA) - parseFloat(resDisCountrA);

    restaxvalrA = maths(
      parseFloat(restotJustAfterDiscSumrA),
      parseFloat(subInfo.taxperc),
      "taxval"
    );
    resNetrA = maths(
      parseFloat(restotJustAfterDiscSumrA),
      parseFloat(subInfo.taxperc),
      "Net"
    );
    tot_befor_vat_after_disc = maths(
      parseFloat(restotJustAfterDiscSumrA),
      parseFloat(subInfo.taxperc),
      "before_vat"
    );


    tot_before_new = maths(
      parseFloat(isdata[or.i].new_exchange_price),
      parseFloat(subInfo.taxperc),
      "before_vat"
    );
    if (subInfo?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
      // if (parseFloat(isdata[or.i].tab3Val)>0) {
      tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
        (parseFloat(25) * parseFloat(resVal1SumrA)) : parseFloat(tot_befor_vat_after_disc).toFixed(2);
      let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

      restaxvalrA = mathsTab3val(
        parseFloat(tot_before),
        parseFloat(subInfo.taxperc),
        "taxval"
      );

      resNetrA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc)
        + parseFloat(restaxvalrA)).toFixed(2);
    };


    newData = {
      /* to show */
      minPrice: subInfo.minPrice,
      PricePu: subInfo.PricePu,
      unitame: valueItemUnits.unitName /*  - الـوحدة name */,
      symbol: subInfo.symbol /*  - إسم الصنف  */,

      /* to maaths */
      /* int - الإجمالي */
      totJust: restotJustSumrA,
      /* int - إجمالي الخصم بعد الخصم */
      totAfterDisc: tot_befor_vat_after_disc,

      tot_before_vat_after_d: tot_befor_vat_after_disc,
      /* to go */
      currency_from: parseInt(itemId) /* float - id الصنف */,
      unit: parseInt(valueItemUnits.unit) /* int - الـوحدة id */,
      /* float - الكمية */
      val1: resVal1SumrA,
      /* float - العبوة */
      val: parseFloat(subInfo.perc),
      sale_price: parseFloat(valueItemUnits?.sale),

      /* float - الـسعر */
      new_exchange_price: parseFloat(isdata[or.i].new_exchange_price),
      /* float - الخصم  مبلغ*/
      discount: resDisCountrA,
      /* float - %  خصم نسبة */

      DiscPers: subInfo.DiscPers,
      /* float -  ضريبة القيمة المضافة نسبة */
      taxperc: parseFloat(subInfo.taxperc),

      taxval: restaxvalrA,
      tab3val_sub: tot_before_vat_with_tab3val,
      tab3Val: tot_before_vat_with_tab3val,

      /* float - الصافي */
      netAmountSub: resNetrA,
      barcode: subInfo.barcode /*  - الباركود */,
      sub_center: 0 /* int -  */,
      sub_branch: sto.branchi /* int - الفرع */,
      editAbleVal: false,
      editAblePrice: false,
      editAbleUnit: false,
      editAbleTax: false,
      editAbleDescM: false,
      editAbleDescP: false,
      editAbleDescNote: false,
      UnitsTable: subInfo.UnitsTable,
      defUnit: subInfo.defUnit,
      no: isdata?.length,
      Qtys: subInfo.Qtys,
      type: subInfo.ctype,

    };

    const updateItem = isdata.find((obj) => obj.barcode.toString() === newData.barcode.toString() &&
      obj.new_exchange_price === newData.new_exchange_price);

    if (updateItem?.no != null) {
      let multiplier = (parseFloat(resVal1SumrA)).toFixed(2);
      if (!isNaN(multiplier)) {

        let tot = parseFloat(multiplier * updateItem.new_exchange_price);

        let desc_mount = (
          parseFloat(tot) *
          (updateItem.DiscPers / 100)
        );
        let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

        let taxMount = maths(
          parseFloat(totBe),
          parseFloat(updateItem.taxperc),
          "taxval"
        );
        let betTax = maths(
          parseFloat(totBe),
          parseFloat(updateItem.taxperc),
          "before_vat"
        );

        let resNetA = maths(
          parseFloat(totBe),
          parseFloat(updateItem.taxperc),
          "Net"
        );
        if (subInfo?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
          let tot_before_new = maths(
            parseFloat(isdata[or.i].new_exchange_price),
            parseFloat(updateItem.taxperc),
            "before_vat"
          );
          tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
            (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

          let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

          taxMount = mathsTab3val(
            parseFloat(tot_before),
            parseFloat(updateItem.taxperc),
            "taxval"
          );

          resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
            + parseFloat(taxMount)).toFixed(2);
        }
        const newData = {
          ...updateItem,
          val1: multiplier,
          totJust: tot,
          totAfterDisc: betTax,
          taxval: taxMount,
          netAmountSub: resNetA,
          discount: desc_mount,
          tab3val_sub: tot_before_vat_with_tab3val,
          tab3Val: tot_before_vat_with_tab3val,
        };

        const index = updateItem?.no;
        const dataUpdate = [...isdata];
        dataUpdate[index] = { ...newData };
        setIsData([...dataUpdate]);
        handSums(dataUpdate);
      }
    } else {
      let dataToAdd = [...isdata];
      dataToAdd.push(newData);
      setIsData(dataToAdd);
      handSums(dataToAdd);
      setExSub(dataToAdd.length);
    }
  };

  const maths = (rTotAfterDic, taxperc, ty) => {
    if (permiCuCo.CWVat == 0 && taxperc != 0) {
      if (ty === "taxval") return ((rTotAfterDic * taxperc) / 100).toFixed(2);
      if (ty === "Net")
        return (rTotAfterDic + (rTotAfterDic * taxperc) / 100).toFixed(2);
      if (ty === "before_vat") return rTotAfterDic.toFixed(2);
    } else if (permiCuCo.CWVat == 1 && taxperc != 0) {
      if (ty === "taxval")
        return (
          parseFloat(rTotAfterDic) -
          rTotAfterDic / (1 + taxperc / 100)
        ).toFixed(2);
      if (ty === "Net") return rTotAfterDic.toFixed(2);

      if (ty === "before_vat") return (rTotAfterDic - (rTotAfterDic / ((100 + taxperc) / taxperc))).toFixed(2);

    } else if (taxperc == 0) {
      if (ty === "taxval") return (0).toFixed(2);
      if (ty === "Net")
        return (rTotAfterDic).toFixed(2);
      if (ty === "before_vat") return rTotAfterDic.toFixed(2);
    }
  };
  const mathsTab3val = (rTotAfterDic, taxperc, ty) => {
    if (taxperc == 0) {
      return (0).toFixed(2);
    } else {
      return ((rTotAfterDic * taxperc) / 100).toFixed(2);
    }
  };


  const hRowAdd = (newData, resolve) => {
    setRowUpdate({});
    let errorList = [];
    let restaxvalA = 0,
      resNetA = 0,
      restotJustSumA = 0,
      restotJustAfterDiscSumA = 0,
      resDiscPerA = 0,
      resDisCountA = 0,
      check_tot_before = 0,
      tot_before_vat_with_tab3val = 0,
      tot_befor_vat_after_disc = 0;
    restotJustSumA = parseFloat(subInfo.totJust);
    restotJustAfterDiscSumA =
      parseFloat(subInfo.totJust) - parseFloat(subInfo.discount);

    if (checked.discRateck === true) {
      //  alert('in if')
      resDiscPerA = parseFloat(invDisc.rate);
      resDisCountA = (
        parseFloat(invDisc.rate / 100) * parseFloat(subInfo.totJust)
      ).toFixed(2);

      restotJustAfterDiscSumA =
        parseFloat(subInfo.totJust) - parseFloat(resDisCountA);
    } else if (checked.discMinusck === true) {
      if (subInfo.totJust == 0) {
        resDiscPerA = (
          (parseFloat(idata.minus) / 1) * 100).toFixed(2);
        resDisCountA = (
          parseFloat(resDiscPerA / 100) * 1
        ).toFixed(2);
      } else {
        resDiscPerA = (
          (parseFloat(idata.minus) / parseFloat(subInfo.totJust)) * 100).toFixed(2);
        resDisCountA = (
          parseFloat(resDiscPerA / 100) * parseFloat(subInfo.totJust)
        ).toFixed(2);
      }

    }
    // disc sub level
    else {
      // alert('in else')
      resDiscPerA = parseFloat(subInfo.DiscPers);
      resDisCountA = (
        parseFloat(subInfo.DiscPers / 100) * parseFloat(subInfo.totJust)
      ).toFixed(2);
    }

    restaxvalA = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(subInfo.taxperc),
      "taxval"
    );

    tot_befor_vat_after_disc = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(subInfo.taxperc),
      "before_vat"
    );
    resNetA = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(subInfo.taxperc),
      "Net"
    );
    check_tot_before = maths(
      parseFloat(subInfo.Price),
      parseFloat(subInfo.taxperc),
      "before_vat"
    );
    if (subInfo?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
      tot_before_vat_with_tab3val = (parseFloat(check_tot_before) <= parseFloat(25)) ?
        (parseFloat(25) * parseFloat(subInfo.val1)).toFixed(2) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

      let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

      restaxvalA = mathsTab3val(
        parseFloat(tot_before),
        parseFloat(subInfo.taxperc),
        "taxval"
      );

      resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
    };
    newData = {
      /* to show */
      minPrice: subInfo.minPrice,
      PricePu: subInfo.PricePu,
      unitame: valueItemUnits.unitName /*  - الـوحدة name */,
      symbol: subInfo.symbol /*  - إسم الصنف  */,
      /* to maaths */
      /* int -  الإجمالي */
      totJust: restotJustSumA,
      /* int - إجمالي الخصم بعد الخصم */
      totAfterDisc: tot_befor_vat_after_disc,

      tot_before_vat_after_d: tot_befor_vat_after_disc,

      tab3val_sub: tot_before_vat_with_tab3val,
      tab3Val: tot_before_vat_with_tab3val,

      /* to go */
      // currency_from: parseInt(subInfo.id), /* float - id الصنف */
      currency_from: parseInt(itemId) /* float - id الصنف */,
      unit: parseInt(valueItemUnits.unit) /* int - الـوحدة id */,
      sale_price: parseFloat(valueItemUnits?.sale),
      /* float - الكمية */
      val1: parseFloat(subInfo.val1),
      // new _val1:parseFloat(subInfo.new _val1),
      /* float - العبوة */
      val: parseFloat(subInfo.perc),
      // new _val:parseFloat(subInfo.perc),
      /* float - الـسعر */
      new_exchange_price: parseFloat(subInfo.Price),
      // all_new_exchange_price: parseFloat(subInfo.Price),
      /* float - الخصم  مبلغ*/
      discount: resDisCountA,
      // new _discount: parseFloat(subInfo.discount),
      /* float - %  خصم نسبة */
      DiscPers: resDiscPerA,
      // new _DiscPers: parseFloat(subInfo.DiscPers),
      /* float -  ضريبة القيمة المضافة نسبة */
      taxperc: parseFloat(subInfo.taxperc),
      // new _taxperc: parseFloat(subInfo.taxperc),
      /* float - إجمالي قيمة المضافة  */
      // taxval: subInfo?.is_tab3_curr == 1 ? 2 * restaxvalA : restaxvalA,
      taxval: restaxvalA,
      /* float - الصافي */
      // netAmountSub: resNetA,
      netAmountSub: resNetA,
      // netAmo untSub: parseFloat(subInfo.totJust-subInfo.discount) + parseFloat((subInfo.totJust-subInfo.discount)*subInfo.taxperc/100),
      barcode: subInfo.barcode /*  - الباركود */,
      sub_center: 0 /* int -  */,
      sub_branch: sto.branchi /* int - الفرع */,
      editAbleVal: false,
      editAblePrice: false,
      editAbleUnit: false,
      editAbleTax: false,
      editAbleDescM: false,
      editAbleDescP: false,
      editAbleDescNote: false,
      UnitsTable: subInfo.UnitsTable,
      defUnit: subInfo.defUnit,
      no: isdata?.length,
      Qtys: subInfo.Qtys,
      notes: subInfo?.notes,
      type: subInfo.ctype,

    };
    if (errorList.length < 1) {
      //no error
      let dataToAdd = [...isdata];
      dataToAdd.push(newData);
      setIsData(dataToAdd);
      handSums(dataToAdd);
      setExSub(dataToAdd.length);
    } else {
      resolve();
    }
  };

  const [sums, setSums] = useState(insh.Sums);

  // الدفع المبقي
  const [payment, setPayment] = useState(insh.Payment);
  const [remains, setRemains] = useState(insh.Remains);
  const [isHedden, setIshedden] = useState(false);
  const [isUpdateDate, setIsUpdateDate] = useState(false);
  const [keepDate, setKeepDate] = useState(false);
  // const [keepDate, setKeepDate] =useLocalStorage("keep-purch-date", false);

  const [dateKeep, setDateKeep] = useState({ Date: moment(new Date()).format('YYYY-MM-DD') });


  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isUpdate, setUpdate] = useState(false);

  const [isHeddenReturn, setIsheddenReturn] = useState(false);

  const [isClick, setIsClick] = useState(insh.ished);


  const handSums = (data) => {
    let val1s = 0,
      tot_sale_or_purch = 0,
      /*tot_sales=0,tot_purchs=0,*/ amountOfVats = 0,
      netAmounts = 0,
      amountAfterDiscs = 0,
      amount_after_disc_before_vat = 0,
      discounts = 0,
      amountWithVats = 0,
      invTab3Val = 0,
      tab3Val = 0,
      taxpercs;

    for (var m = 0; m < data.length; m++) {
      val1s += parseFloat(data[m].val1);
      tot_sale_or_purch += parseFloat(data[m].totJust);
      taxpercs = data[m].taxperc;
      /* جمالي القيمة المضافة */
      amountOfVats += parseFloat(data[m].taxval);
      netAmounts += parseFloat(data[m].netAmountSub);
      /* إجمالي قبل الضريبة */
      amountAfterDiscs += parseFloat(data[m].totAfterDisc);
      discounts += parseFloat(data[m].discount);

      // tobacco tax
      invTab3Val += parseFloat(data[m].tab3Val);
      amount_after_disc_before_vat += parseFloat(data[m].totAfterDisc);
    }

    /* في الحالتين */
    /* إجمالي بعد الخصم */
    amountWithVats = (
      parseFloat(tot_sale_or_purch) - parseFloat(discounts)
    ).toFixed(2);
    /* يشمل */
    tab3Val = parseFloat(invTab3Val).toFixed(2);

    if (permiCuCo.CWVat == 1) {
      if (tab3Val > 0) {
        amountAfterDiscs = (
          parseFloat(amount_after_disc_before_vat)
        ).toFixed(2);
        amountOfVats = (
          parseFloat(amountOfVats)
        ).toFixed(2);
        netAmounts = (
          parseFloat(amount_after_disc_before_vat) + parseFloat(amountOfVats) + parseFloat(tab3Val)
        ).toFixed(2);
        amountWithVats = (
          parseFloat(netAmounts)
        ).toFixed(2);

      } else {
        amountAfterDiscs = (
          parseFloat(amount_after_disc_before_vat)
        ).toFixed(2);
        amountOfVats = (
          parseFloat(amountWithVats) - parseFloat(amountAfterDiscs)
        ).toFixed(2);
        netAmounts = (
          parseFloat(amountWithVats)
        ).toFixed(2);
      }
    } else {
      /*لا يشمل */
      amountAfterDiscs = (
        parseFloat(amount_after_disc_before_vat)
      ).toFixed(2);

      netAmounts = (
        parseFloat(amountAfterDiscs) + parseFloat(amountOfVats) + parseFloat(tab3Val)
      ).toFixed(2);

      amountWithVats = (
        parseFloat(amountAfterDiscs) + parseFloat(amountOfVats) + parseFloat(tab3Val)
      ).toFixed(2);


    }



    setSums({ val1: val1s });
    setIData({
      ...idata,
      amountAfterDisc: amountAfterDiscs,
      amountWithVat: amountWithVats,
      tot_sale: tot_sale_or_purch,
      tot_purch: tot_sale_or_purch,
      netAmount: netAmounts,
      amountBefordisc: tot_sale_or_purch,
      amountOfVat: amountOfVats,
      minus: discounts,
      tab3Val: invTab3Val,
    });



    fcHandSumsToPayment(netAmounts);

    fcHandSumsToinvDisc(tot_sale_or_purch, discounts);
  };

  const fcHandSumsToPayment = (newExPrice) => {
    // screan payment
    if (idata.inv_type == 1) {
      setPayment({ ...payment, stay: newExPrice, paidup: 0 });
      setRemains({ ...remains, cashPart: 0, agelPart: newExPrice, bankPart: 0, networkPart: 0 });
    }
    else {
      setPayment({ ...payment, paidup: newExPrice, stay: 0 });
      if (switchState.cashORnetworksw == false) {
        setRemains({ ...remains, cashPart: newExPrice, agelPart: 0, bankPart: 0, networkPart: 0 });
      } else if (switchState.cashORnetworksw == true) {
        setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: newExPrice });
      }
    }
  };

  const fcHandSumsToinvDisc = (totj, discs) => {
    // قيمة الخصم  مبلغ
    if (totj == 0 || totj == "") totj = 1;
    setInvDisc({
      minus: discs,
      rate: (parseFloat(parseFloat(discs) / totj) * 100).toFixed(2),
    });

  };

  const handRowAdd = (or) => {
    if (or.cros === "newRow") {
      hRowAdd();
    } else if (or.cros === "rnewRow") {
      if (permistionInv?.NOREP === true) {
        hRowAdd();
      } else {
        hRowrAdd();
      }

    }
    // }
  };
  const hRowUpdate = (newData, oldData, resolve) => {

    if (newData.new_exchange_price === "") newData.new_exchange_price = 1;
    if (newData.discount === "") newData.discount = 0;
    if (newData.val1 === "") newData.val1 = 1;
    if (newData.DiscPers === "") newData.DiscPers = 0;

    if (newData.new_exchange_price === "") { newData.new_exchange_price = 0; setInvDisc({ ...invDisc, minus: 0, rate: 0 }); };
    if (newData.discount === "") { newData.discount = 0; setInvDisc({ ...invDisc, minus: 0, rate: 0 }); };
    if (newData.val1 === "") { newData.val1 = 0; setInvDisc({ ...invDisc, minus: 0, rate: 0 }); };

    if (newData.DiscPers === "") { newData.DiscPers = 0; setInvDisc({ ...invDisc, minus: 0, rate: 0 }); };
    if (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12" || setting.PrTy_InPr === "01" || setting.PrTy_InPr === "11") {

      let val1 = newData.val1 == 0 ? 1 : newData.val1;
      let subInfoVal1_perc = val1 * newData.val;
      //   let countsCurr = parseInt(rowItem?.balance) - parseInt(rowItem?.val1);
      let totValbef = 0.0;
      for (let m = 0; m < isdata.length; m++) {
        if (oldData.currency_from == isdata[m].currency_from && oldData.no != isdata[m]?.no)
          totValbef += (isdata[m].val1 * isdata[m].val);
      };

      let countsCurr = Number(oldData?.Qtys) - totValbef;
      let maxPrice = parseFloat(permistionInv?.MAXPRICE ?? 100000);
      let maxQty = parseFloat(permistionInv?.MAXQTY ?? 100000);

      if (permistionInv.SIM == false &&
        countsCurr < subInfoVal1_perc &&
        (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
        alert(
          `
          الكمية المدخلة للصنف أكبر من رصيد المخزن
          الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(newData?.val1) * parseFloat(newData?.val))
          }
          رصيد المخزن : ${valueSafes.name} = ${parseInt(newData?.Qtys)
          }
          `
        );
        const dataUpdate = [...oldData];
        const index = oldData.tableData.id;
        dataUpdate[index] = oldData;
        setIsData([...dataUpdate]);
        resolve();
      } else if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12") &&
        parseFloat(newData.val1) > parseFloat(maxQty)) {
        alert(
          `لقد تجاوزت حد الكمية المسموح فيها... برجاء الذهاب لاعدادات النظام لزيادة الحد:  ${maxQty}`
        );
        const dataUpdate = [...oldData];
        const index = oldData.tableData.id;
        dataUpdate[index] = oldData;
        setIsData([...dataUpdate]);
        resolve();

      }

      else {
        if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12") &&
          permistionInv.SNOP === true && newData != null &&
          parseFloat(newData.Price) < parseFloat(newData.PricePu)) {

          alert(
            `لا يمكن البيع اقل من سعر الشراء للصنف سعر الشراء المسجل للصنف هو : ${newData.PricePu}`
          );
          const dataUpdate = [...oldData];
          const index = oldData.tableData.id;
          dataUpdate[index] = oldData;
          setIsData([...dataUpdate]);
          resolve();
        } else if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12") &&
          parseFloat(newData.new_exchange_price) > parseFloat(maxPrice)) {
          alert(
            `لقد تجاوزت حد السعر المسموح فيه... برجاء الذهاب لاعدادات النظام لزيادة الحد:  ${maxPrice}`
          );
          const dataUpdate = [...oldData];
          const index = oldData.tableData.id;
          dataUpdate[index] = oldData;
          setIsData([...dataUpdate]);
          resolve();

        }
        else if ((setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12") && permistionInv.SNOMIN === 1 &&
          parseFloat(newData.new_exchange_price) < parseFloat(newData.minPrice)) {
          alert(
            `لا يمكن البيع اقل من السعر الادنى للصنف السعر الادنى المسجل للصنف هو : ${newData.minPrice}`
          );
          const dataUpdate = [...oldData];
          const index = oldData.tableData.id;
          dataUpdate[index] = oldData;
          setIsData([...dataUpdate]);
          resolve();
        }
        else if ((setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12") &&
          permistionInv.ASPZ === false && newData.new_exchange_price <= 0) {

          alert(
            `لا يوجد لديك صلاحية البيع بسعر صفر `
          );
          const dataUpdate = [...oldData];
          const index = oldData.tableData.id;
          dataUpdate[index] = oldData;
          setIsData([...dataUpdate]);
          resolve();

        }
        else if ((setting.PrTy_InPr === "01" || setting.PrTy_InPr === "11") &&
          permistionInv.ASPZ === true && newData.new_exchange_price <= 0) {

          alert(
            `لا يوجد لديك صلاحية الشراء بسعر صفر `
          );
          const dataUpdate = [...oldData];
          const index = oldData.tableData.id;
          dataUpdate[index] = oldData;
          setIsData([...dataUpdate]);
          resolve();

        }
        else if (permistionInv.APDC === 1 && permistionInv.DSOI == 1 && parseFloat(newData.DiscPers) > parseFloat(permistionInv.SDP)) {
          alert(
            `
       لقد تجاوزت نسبة الخصم المسموح بها
       نسبة الخصم المسموح بها : ${parseFloat(permistionInv.SDP)
            }
       `
          );
        }
        else if (permistionInv.APDC === 2 && permistionInv.DSOI == 1 && parseFloat(newData.discount) > parseFloat(permistionInv.SDV)) {
          alert(
            `
       لقد تجاوزت مبلغ الخصم المسموح بها
       مبلغ الخصم المسموح بة : ${parseFloat(permistionInv.SDV)
            }
       `
          );
        }
        else if (permistionInv.APDC === 3 && permistionInv.DSOI === 1 &&
          ((parseFloat(permistionInv.SDV) != 0 && newData.discount > permistionInv.SDV) ||
            (parseFloat(permistionInv.SDP) != 0 && parseFloat(newData.DiscPers) > parseFloat(permistionInv.SDP)))) {
          alert(
            `
       لقد تجاوزت حد الخصم المسموح بها
         }
       `
          );
        }
        else {
          TableRowUpdate(newData, oldData, resolve);

        }
      }

    } else {
      TableRowUpdate(newData, oldData, resolve);

    }
  };

  const TableRowUpdate = (newData, oldData, resolve) => {
    let resDisCountU = 0,
      restotJustSumU = 0,
      restaxvalU = 0,
      resNetU = 0,
      decPerces = 0,
      tot_before_vat_after_desc = 0,
      tot_before_vat_with_tab3val = 0,
      tot_before_only = 0,
      tot_before_new = 0,
      newtotJust;

    // let i = {
    //   newPrice: Number(newData.new_exchange_price),
    //   newDiscount: Number(newData.discount),
    //   newVal: Number(newData.val1),
    //   newDisc: Number(newData.DiscPers),

    // };

    if (newData.new_exchange_price === "") newData.new_exchange_price = 1;
    if (newData.discount === "") newData.discount = 0;
    if (newData.val1 === "") newData.val1 = 1;
    if (newData.DiscPers === "") newData.DiscPers = 0;

    newtotJust = (parseFloat(newData.new_exchange_price) * parseFloat(newData.val1));

    if (parseFloat(newData.DiscPers) == 0 && parseFloat(newData.discount) == 0) {

      resDisCountU = (

        parseFloat(newData.DiscPers / 100) *
        parseFloat(newData.new_exchange_price) *
        parseFloat(newData.val1)
      ).toFixed(2);

    } else if (parseFloat(newData.DiscPers) !== 0 && parseFloat(newData.discount) == 0) {

      resDisCountU = (

        parseFloat(newData.DiscPers / 100) *
        parseFloat(newData.new_exchange_price) *
        parseFloat(newData.val1)
      );

    } else if (parseFloat(newData.DiscPers) !== 0 && parseFloat(newData.discount) !== 0) {

      resDisCountU = (

        parseFloat(newData.DiscPers / 100) *
        parseFloat(newData.new_exchange_price) *
        parseFloat(newData.val1)
      );

    }
    else if (parseFloat(newData.DiscPers) == 0 && parseFloat(newData.discount) !== 0) {

      resDisCountU = parseFloat(newData.discount);
    }
    else {
      resDisCountU = parseFloat(newData.discount);
    }

    restotJustSumU = parseFloat(
      (parseFloat(newData.new_exchange_price) * parseFloat(newData.val1)) - resDisCountU
    );
    decPerces = (
      (parseFloat(newData.totJust) - parseFloat(restotJustSumU)) / (parseFloat(newData.totJust) * 100)

    )
    restaxvalU = maths(
      parseFloat(restotJustSumU),
      parseFloat(newData.taxperc),
      "taxval"
    );
    resNetU = maths(
      parseFloat(restotJustSumU),
      parseFloat(newData.taxperc),
      "Net"
    );

    tot_before_vat_after_desc = maths(
      parseFloat(restotJustSumU),
      parseFloat(newData.taxperc),
      "before_vat"
    );
    if (newData?.tab3val_sub > 0 && permistionInv?.USETOBACO) {
      tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
        (parseFloat(25) * newData.val1) : parseFloat(tot_before_vat_after_desc).toFixed(2);

      let tot_before = (parseFloat(tot_before_vat_after_desc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

      restaxvalU = mathsTab3val(
        parseFloat(tot_before),
        parseFloat(newData.taxperc),
        "taxval"
      );

      resNetU = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_before_vat_after_desc)
        + parseFloat(restaxvalU)).toFixed(2);
    }
    console.log("the old data is", oldData);
    console.log("the new data is", newData);
    newData = {
      /* to show */
      // unitame: LetvalueCurrUnits.name, /*  - الـوحدة name */
      unitame: newData.unitame /*  - الـوحدة name */,
      symbol: newData.symbol /*  - إسم الصنف  */,
      /* to maaths */
      /* float - الإجمالي */
      // totJust: newData.new_exchange_price * newData.val1,
      totJust: newtotJust,
      /* float - الإجمالي بعد الخصم */
      totAfterDisc: tot_before_vat_after_desc,

      tot_before_vat_after_d: tot_before_vat_after_desc,

      tab3val_sub: tot_before_vat_with_tab3val,
      tab3Val: tot_before_vat_with_tab3val,
      // totAfterDisc: newData.val1 * newData.new_exchange_price - newData.discount,
      /* to go */

      currency_from: newData.currency_from /* float - id الصنف */,
      unit: newData.unit /* int - الـوحدة id */,
      /* float - الكمية */
      val1: newData.val1,
      // new _val1:newData.new _val1,
      /* float - العبوة */
      val: newData.val,
      // new _val:newData.val,
      /* float - الـسعر */
      new_exchange_price: newData.new_exchange_price,
      // all_new_exchange_price: newData.new_exchange_price,
      /* float - الخصم مبلغ _ قيمة الخصم  مبلغ*/
      discount: resDisCountU,
      DiscPers: newData.DiscPers == "" ? 0 : newData.DiscPers,
      // new _DiscPers: newData.DiscPers,
      /* float -  ضريبة القيمة المضافة نسبة */
      taxperc: newData.taxperc,
      // new _taxperc: newData.taxperc,
      /* float - إجمالي قيمة المضافة  */


      taxval: restaxvalU,
      // new _taxval: (newData.totJust-newData.discount)*newData.taxperc/100,
      /* float - الصافي */

      // netAmountSub: resNetU,
      netAmountSub: resNetU,
      // netAmo untSub: ((restotJustSumU - resDisCountU)+((restotJustSumU-resDisCountU)*newData.taxperc/100)).toFixed(2),
      barcode: newData.barcode /*  - الباركود */,
      sub_center: 0 /* int -  */,
      sub_branch: sto.branchi /* int - الفرع */,
      notes: newData.notes /* string - ملاحضة */,
      sale_price: newData.sale_price /* string - سعر الببيع */,
      tot_before_vat_after_d: tot_before_vat_after_desc,
      UnitsTable: newData.UnitsTable,
      defUnit: newData.defUnit,
      no: newData.no,
      editAbleVal: false,
      editAblePrice: false,
      editAbleUnit: false,
      editAbleTax: false,
      editAbleDescM: false,
      editAbleDescP: false,
      editAbleDescNote: false,
      Qtys: oldData?.Qtys,
      type: 1,

    };
    const dataUpdate = [...isdata];
    const index = oldData.tableData.id;
    dataUpdate[index] = newData;
    setIsData([...dataUpdate]);
    handSums(dataUpdate);
    resolve();
  };


  const hRowDelete = (event, rowData) => {
    let dataDelete = [...isdata];

    rowData.forEach((rd) => {
      dataDelete = dataDelete.filter((t) => t.tableData.id !== rd.tableData.id);
    });

    setIsData([...dataDelete]);
    // 
    // setIsData(dataDelete);
    handSums(dataDelete);

    if (dataDelete.length === 0) {
      setIsData([]);
      setInvDisc(insh.InvDisc);
      toDoIdata("minus", "");
      setIData({
        ...idata, netAmount: 0,
        amountOfVat: 0,
        amountWithVat: 0,
        tot_purch: 0,
        totAfterDisc: 0,
        amountOfVats: 0,
        cash_part: 0,
        agel_part: 0,
        bank_part: 0,
        network_part: 0,
        Pay_mouny: 0,
        tot_sale: 0,
        Remaining: 0,
        tab3Val: 0,
        taxperc: 0,
        netAmount: 0,
        amountAfterDisc: 0,
        minus: 0,
        discounts: 0,
        amountBefordisc: 0,
      });
      setPayment({
        ...payment,
        paidup: 0,
        stay: 0,
      });
      setRemains({
        ...remains,
        cashPart: 0,
        agelPart: 0,
        networkPart: 0,
        bankPart: 0,
        empPart: 0,
      });
      setExSub(0);
    }
    setExSub(dataDelete.length);
  };

  const pinAutosValue = async (Tbl, id) => {
    if (Tbl === "Safe")
      AutoOptions.Safes.map((x) => {
        if (x.id == id) setValueSafes(x);
      });
    else if (Tbl === "Stock")
      AutoOptions.Stocks.map((x) => {
        if (x.id == id) setValueStock(x);
      });
    else if (Tbl === "omla")
      gets.omlats.map((x) => {
        if (x.id == id) setOmlaValue(x);
      });
    else if (Tbl === "Customer")
      optionsCustomers.map((x) => {
        if (x.id == id) setValueCustomers(x);
      });
    else if (Tbl === "salesmen")
      gets.salesmen.map((x) => {
        if (x.id == id) setValueSalesmen(x);
      });
    else if (Tbl === "costcenter")
      gets.costcenters.map((x) => {
        if (x.id == id) setValueCostcenter(x);
      });
    else if (Tbl === "Bank")
      AutoOptions.Banks.map((x) => {
        if (x.i == id) setValueBank(x);
      });
    else if (Tbl === "BankPMD")
      AutoOptions.Banks.map((x) => {
        if (x.id == id) setValueBankPMD(x);
      });
    else if (Tbl === "Bank2PMD")
      AutoOptions.Banks.map((x) => {
        if (x.id == id) setValueBankTransPMD(x);
      });
    else if (Tbl === "EmployeePMD")
      gets.Employees.map((x) => {
        if (x.id == id) setValueEmployePMD(x);
      });
    // }).catch(error => { })
  };

  const [numberbarcode, setNumberbarcode] = useState("");
  const [isBarcode, setIsBarcode] = useState(false);
  const [isApiConnect, setIsApiConnect] = useState(true);

  // useEffect(() => {
  //   if (isBarcode) {
  //     getrowDataCurrencie();
  //     setNumberbarcode("");
  //   }
  // }, [isBarcode]);

  const [barcoding, setBarcoding] = useState(false);

  const [multiCodeList, setMultiCodeList] = useState([]);
  const SearchActivityReports = {
    barcode: '',
    curr: {},
    symbol: '',
    barcodeS: '',
    groupS: { id: -1, name: "الكل ", parentId: -1 },
    groupSe: { id: -1, name: "الكل ", parentId: -1 },
    group: { id: -1, name: "الكل", parentId: -1 },
    currS: {},
    barcodeNormal: "",
    isData: false,

  };



  const [rptParams, setRptParams] = useState(SearchActivityReports);


  const [code, setCode] = useState([]);

  const onChangeData = (propName) => (event) => {
    if (propName == "barcode") {
      let value = event.target.value;
      setRptParams({ ...rptParams, [propName]: event.target.value });
    } else {
      setRptParams({ ...rptParams, [propName]: event.target.value });
    }
  };

  const onChangeAutoDataSubCurr = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue });
    if (newValue.id === "" || newValue.id == null) {

    } else {
      getBarcodeMulti(newValue.barcode);
    }
  };

  const [groupsOptions, setGroupsOptions] = useState(() => {
    return [{ id: -1, name: "الكل", parentId: -1 }, ...AutoOptions.groups];
  });
  const onChangeAutoDataG = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue, groupSe: newValue });
    if (newValue.id == null) {
      setGroupsSubs([]);
    } else {
      var subGroup = AutoOptions.groupsSub.filter((obj) => obj.parentId == newValue.id);
      setGroupsSubs([...subGroup]);
    }
    viewHandle(newValue.id);
  };
  const onChangeAutoDataSub = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue, groupSe: newValue });
    viewHandle(newValue.id);

  };
  const onChangeSearchD = (event) => {
    if (checked.autoOrStaticck == true) {
      event.preventDefault();
      event.stopPropagation();
      getBarcodeMulti(rptParams?.barcodeS);
    } else {
      event.preventDefault();
      event.stopPropagation();
      GetItemSearch(rptParams?.barcodeS);
    }
  };
  const onChangeDataA = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
    //event.stopPropagation();
  };
  const [fetching, setFetching] = useState(false);
  const viewHandle = async (group_id) => {

    if (rptParams.barcodeS == null && group_id == null && rptParams.symbol == null) {

    } else {
      if (stor.invsType === 7) {
        setcuRows([]);
        setFetching(true);
        await axios
          .get(
            uri +
            `RptSafes/ItemsSearchMake?currShow=${-1}
      &&curr_type=${-1}
  &&groupid=${group_id}
  &&take=${50}
  &&item_code=${rptParams?.barcodeS}
  &&item_name=${rptParams?.symbol}
  &&emp=${sto.empi}`
          )
          .then((res) => {
            setcuRows(res.data);
            setFetching(false);
          })
          .catch((err) => {
            setFetching(false);
            //console.log(err);
            setcuRows([]);
          });
      } else if (stor.invsType === 8) {
        setcuRows([]);
        setFetching(true);
        await axios
          .get(
            uri +
            `RptSafes/ItemsSearchKhams?currShow=${-1}
      &&curr_type=${-1}
  &&groupid=${group_id}
  &&take=${50}
  &&item_code=${rptParams?.barcodeS}
  &&item_name=${rptParams?.symbol}
  &&emp=${sto.empi}`
          )
          .then((res) => {
            setcuRows(res.data);
            setFetching(false);
          })
          .catch((err) => {
            setFetching(false);
            //console.log(err);
            setcuRows([]);
          });
      }
      else {
        setcuRows([]);
        setFetching(true);
        await axios
          .get(
            uri +
            `RptSafes/ItemsInvSearch?currShow=${-1}
      &&curr_type=${-1}
  &&groupid=${group_id}
  &&take=${50}
  &&item_code=${rptParams?.barcodeS}
  &&item_name=${rptParams?.symbol}
  &&emp=${sto.empi}
  &&procInvType=${setting.PrTy_InPr}
  &&safe=${valueSafes.id}`
          )
          .then((res) => {
            setcuRows(res.data);
            setFetching(false);
          })
          .catch((err) => {
            // setFetching(false);
            //console.log(err);
            //setcuRows([]);
            viewItemsHandle(group_id);
          });
      }
    }
  };


  const viewItemsHandle = async (group_id) => {

    if (rptParams.barcodeS == null && group_id == null && rptParams.symbol == null) {

    } else {
      if (stor.invsType === 7) {
        setcuRows([]);
        setFetching(true);
        await axios
          .get(
            uri +
            `RptSafes/ItemsSearchMake?currShow=${-1}
      &&curr_type=${-1}
  &&groupid=${group_id}
  &&take=${50}
  &&item_code=${rptParams?.barcodeS}
  &&item_name=${rptParams?.symbol}
  &&emp=${sto.empi}`
          )
          .then((res) => {
            setcuRows(res.data);
            setFetching(false);
          })
          .catch((err) => {
            setFetching(false);
            //console.log(err);
            setcuRows([]);
          });
      } else {
        setcuRows([]);
        setFetching(true);
        await axios
          .get(
            uri +
            `RptSafes/ItemsSearch?currShow=${-1}
      &&curr_type=${-1}
  &&groupid=${group_id}
  &&take=${50}
  &&item_code=${rptParams?.barcodeS}
  &&item_name=${rptParams?.symbol}
  &&emp=${sto.empi}`
          )
          .then((res) => {
            setcuRows(res.data);
            setFetching(false);
          })
          .catch((err) => {
            setFetching(false);
            //console.log(err);
            setcuRows([]);
          });
      }
    }
  };


  const [groupsSubs, setGroupsSubs] = useState([]);
  const [symbolSearch, setSymbolSearch] = useState({});
  const [custData, setCustData] = useState({});
  const [newItemsAdd, setNewItemsAdd] = useState({ id: "", barcode: "" });
  const [newItems, setNewItems] = useState({});



  const GetItemSearch = async (itemcode) => {

    let item = null;

    if (itemcode == null) {

    } else {

      await axios
        .get(
          uri +
          `RptSales/CurrCodes?currCode=${itemcode}
            &&emp=${sto.empi}`
        )
        .then((res) => {
          item = res.data?.barcodes[0];
        })
        .catch((err) => {
          toast.error("لا يوجد صنف لهذا الباركود");
          console.log(err);
        });
      if (item != null) {
        await getListSearch(item);
      } else {
        toast.error("لا يوجد صنف لهذا الباركود");
      }
    }
  };

  const getListSearch = (dataItem) => {
    // eds-changes
    var nameGroup = AutoOptions.groups.find((x) => x.id === dataItem.group_id);

    setcuRows(
      // dataItem.map((sub) => {
      [
        {
          ...dataItem,
          namG: nameGroup,
          sale_price: dataItem.sale,
          purch_price: dataItem.purch,
          img: null,
        }]
    );

  }
  const onChangeSearch = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    if (permistionInv?.USEMEZAN === true) {
      getBarcodeMezan(rptParams?.barcode);
    } else {
      getBarcodeMulti(rptParams?.barcode);
    }
  };
  const getBarcodeMezan = async (itemcode) => {
    let item = null;
    let mezan = null;
    let ibance = null;
    let units = null;
    let defaultUnits = null;
    if (itemcode == "null") {

    } else {
      await axios
        .get(
          uri +
          `RptSales/ItemsCodesMezan?currCode=${itemcode}
            &&emp=${sto.empi}&&safe=${valueSafes.id}`
        )
        .then((res) => {

          defaultUnits = res.data?.unitsSub[0];
          units = res.data?.unitsSub;
          item = res.data?.barcodes[0];
          mezan = res.data?.mezan[0];
          ibance = res.data?.balance[0].Qtys ?? 0;
        })
        .catch((err) => {
          if (item == null) {
            getcustitem(itemcode);
          }
          console.log(err);
        });
      if (item != null) {
        let totValbef = 0.0;
        for (let m = 0; m < isdata.length; m++) {
          if (item.curr == isdata[m].currency_from)
            totValbef += (isdata[m].val1 * isdata[m].val);
        };
        let oldVal = Number(ibance) - totValbef;
        setRptParams({ ...rptParams, barcode: '', barcodeS: '' });
        if (permistionInv.SIM == false &&
          oldVal < 1 && item.ctype != 4 &&
          (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
          alert(
            `
            الكمية المدخلة للصنف أكبر من رصيد المخزن
            الكمية الاجمالية المدخلة : ${(parseFloat(1) * parseFloat(item?.perc)) + oldVal
            }
            رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
            }
            `
          );
        } else {
          await barcodeaddMezan({ ...item }, { ...mezan }, { ...defaultUnits }, units, ibance);

        }
      } else {
        toast.error("لا يوجد صنف لهذا الباركود");
      }
    }
  };

  const barcodeaddMezan = (dataCode, mezan, defaultUnits, units, ibance) => {
    setRowUpdate({});
    let pricei = 0.0;
    let totJust = 0.0;
    let taxval = 0.0;
    let taxperc = 0.0;
    let diaperc = 0.0;
    let dismount = 0.0;
    let valperc = 0.0;
    let tot_before_vat_with_tab3val = 0.0;

    if (setting.PrTy_InPr === "22") {
      taxperc = 0.0;
      pricei = parseFloat(dataCode?.purch).toFixed(2);
    } else if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
      pricei = mezan.isMizan === true && mezan.usePrice === true ? parseFloat(mezan.price) : parseFloat(dataCode?.sale);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    }
    else {
      pricei = parseFloat(dataCode?.purch);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    };
    if (valueCustomers?.disc_perc > 0 || valueCustomers?.discount > 0) {
      if (valueCustomers?.disc_perc > 0) {
        dataCode.discount = valueCustomers?.disc_perc;
        dataCode.amount_disc = 0;
      } else if (valueCustomers?.discount > 0) {
        dataCode.discount = 0;
        dataCode.amount_disc = valueCustomers?.discount;
      }
    }

    let valQ = (mezan.isMizan === true && mezan.usePrice === false) ? parseFloat(mezan.val1) : parseFloat(1);

    totJust = (parseFloat(pricei) * parseFloat(valQ)).toFixed(2);
    taxval = ((parseFloat(totJust) * parseFloat(dataCode.tax)) / 100).toFixed(2);


    let i = {
      amount_disc: Number(dataCode.amount_disc),
      discount: Number(dataCode.discount),
    };
    diaperc = (parseFloat(i.discount)).toFixed(2);
    dismount = (parseFloat(i.amount_disc)).toFixed(2);

    if (parseFloat(dismount) > parseFloat(pricei)) dismount = 0;
    valperc = (parseFloat(dataCode.perc)).toFixed(2);


    let errorList = [];
    let restaxvalA = 0,
      resNetA = 0,

      restotJustSumA = 0,
      restotJustAfterDiscSumA = 0,
      resDiscPerA = 0,
      resDisCountA = 0,
      tot_befor_vat_after_disc = 0;

    restotJustSumA = parseFloat(totJust);

    if (permistionInv.DSOB == true) {
      if (checked.discRateck === true) {
        //  alert('in if')
        resDiscPerA = parseFloat(invDisc.rate);
        resDisCountA = (
          parseFloat(invDisc.rate / 100) * parseFloat(totJust)
        ).toFixed(2);

        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(resDisCountA);
      } else if (checked.discMinusck === true) {
        resDiscPerA = (
          (parseFloat(idata.minus) / parseFloat(totJust)) *
          100
        ).toFixed(2);
        resDisCountA = (
          parseFloat(resDiscPerA / 100) * parseFloat(totJust)
        ).toFixed(2);
      }

    } else {
      if (diaperc > 0) {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);
        resDiscPerA = parseFloat(diaperc);
        resDisCountA = (
          parseFloat(diaperc / 100) * parseFloat(totJust)
        ).toFixed(2);

      } else if (dismount > 0) {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);

        let desc_perc = (
          (dismount * 100) /
          parseFloat(totJust)
        );
        resDiscPerA = parseFloat(desc_perc);
        resDisCountA = (
          parseFloat(resDiscPerA / 100) * parseFloat(totJust)
        ).toFixed(2);

      } else {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);
        resDiscPerA = parseFloat(diaperc);
        resDisCountA = (
          parseFloat(diaperc / 100) * parseFloat(totJust)
        ).toFixed(2);
      }
    }



    restotJustAfterDiscSumA =
      parseFloat(totJust) - parseFloat(resDisCountA);


    restaxvalA = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "taxval"
    );

    tot_befor_vat_after_disc = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "before_vat"
    );


    resNetA = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "Net"
    );

    if (dataCode?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
      tot_before_vat_with_tab3val = (parseFloat(tot_befor_vat_after_disc) < parseFloat(25)) ?
        parseFloat(25) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

      let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

      restaxvalA = mathsTab3val(
        parseFloat(tot_before),
        parseFloat(taxperc),
        "taxval"
      );

      resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
    }

    dataCode = {
      /* to show */
      minPrice: dataCode.mPrice,
      PricePu: dataCode.purch,
      unitame: dataCode.unitName /*  - الـوحدة name */,
      symbol: dataCode.symbol /*  - إسم الصنف  */,
      /* to maaths */
      /* int -  الإجمالي */
      totJust: restotJustSumA,
      /* int - إجمالي الخصم بعد الخصم */
      totAfterDisc: tot_befor_vat_after_disc,

      tot_before_vat_after_d: tot_befor_vat_after_disc,
      sale_price: mezan.isMizan === true ? parseFloat(mezan.price) : parseFloat(dataCode?.sale),

      tab3val_sub: tot_before_vat_with_tab3val,
      tab3Val: tot_before_vat_with_tab3val,

      /* to go */
      // currency_from: parseInt(subInfo.id), /* float - id الصنف */
      currency_from: parseInt(dataCode.curr) /* float - id الصنف */,
      unit: parseInt(dataCode.unit) /* int - الـوحدة id */,
      /* float - الكمية */
      val1: parseFloat(valQ),
      // new _val1:parseFloat(subInfo.new _val1),
      /* float - العبوة */
      val: parseFloat(valperc),
      // new _val:parseFloat(subInfo.perc),
      /* float - الـسعر */
      new_exchange_price: parseFloat(pricei),
      // all_new_exchange_price: parseFloat(subInfo.Price),
      /* float - الخصم  مبلغ*/
      discount: resDisCountA,
      /* float - %  خصم نسبة */
      DiscPers: resDiscPerA,
      /* float -  ضريبة القيمة المضافة نسبة */
      taxperc: parseFloat(taxperc),
      /* float - إجمالي قيمة المضافة  */
      taxval: parseFloat(restaxvalA),
      netAmountSub: (parseFloat(restaxvalA) + parseFloat(tot_befor_vat_after_disc)).toFixed(2),
      barcode: mezan.isMizan === true ? parseFloat(mezan.itemBarcode) : dataCode.barcode /*  - الباركود */,
      sub_center: 0 /* int -  */,
      sub_branch: sto.branchi /* int - الفرع */,

      unitame: dataCode.unitName,
      sale_price: parseFloat(dataCode.sale),
      // DiscPers: parseFloat(diaperc),
      // discount: parseFloat(dataCode.amount_disc),
      discount: resDisCountA,
      DiscPers: resDiscPerA,
      taxperc: parseFloat(taxperc),
      UnitsTable: units,
      defUnit: defaultUnits,
      no: isdata?.length,
      editAbleVal: false,
      editAblePrice: false,
      editAbleUnit: false,
      editAbleTax: false,
      editAbleDescM: false,
      editAbleDescP: false,
      editAbleDescNote: false,
      Qtys: ibance,
      type: dataCode.ctype,
    };
    if (errorList.length < 1) {
      //no error
      let add = 0;

      const updateItem = isdata.find((obj) => obj.barcode.toString() === dataCode.barcode.toString()
        && obj.new_exchange_price === dataCode.new_exchange_price);

      if (permistionInv?.NOREP === true) {
        let dataToAdd = [...isdata];
        dataToAdd.push(dataCode);
        setIsData(dataToAdd);
        handSums(dataToAdd);
        setExSub(dataToAdd.length);
        add = 1;

      }
      else {
        if (updateItem?.no != null && mezan.isMizan === false) {
          let add = 1;
          let multiplier = (parseFloat(updateItem?.val1) + parseFloat(add)).toFixed(2);
          if (!isNaN(multiplier)) {

            let tot = parseFloat(multiplier * updateItem.new_exchange_price);

            let desc_mount = (
              parseFloat(tot) *
              (updateItem.DiscPers / 100)
            );
            let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

            let taxMount = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "taxval"
            );
            let betTax = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "before_vat"
            );

            let resNetA = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "Net"
            );
            if (parseFloat(updateItem?.tab3val_sub) > 0) {
              let tot_before_new = maths(
                parseFloat(pricei),
                parseFloat(updateItem.taxperc),
                "before_vat"
              );
              tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

              let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

              taxMount = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(updateItem.taxperc),
                "taxval"
              );

              resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                + parseFloat(taxMount)).toFixed(2);
            }
            const newData = {
              ...updateItem,
              val1: multiplier,
              totJust: tot,
              totAfterDisc: betTax,
              taxval: taxMount,
              netAmountSub: resNetA,
              discount: desc_mount,
              tab3val_sub: tot_before_vat_with_tab3val,
              tab3Val: tot_before_vat_with_tab3val,
            };

            const index = updateItem?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = { ...newData };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
          }
        } else {
          let dataToAdd = [...isdata];
          dataToAdd.push(dataCode);
          setIsData(dataToAdd);
          handSums(dataToAdd);
          setExSub(dataToAdd.length);
          add = 1;

        }

      }
    } else {
      // resolve();
    }
  };
  const getFormExcelData = async () => {
    const dataDown = excelData.map((sub, i) => {

      return {
        barcode: sub.الباركود !== null ? sub?.الباركود : sub?.barcode,
        new_exchange_price: sub?.السعر !== null ? sub?.السعر : sub?.price == null ? 0 : sub?.price,
        val1: sub?.الكمية !== null ? sub?.الكمية : sub?.val == null ? 1 : sub?.val,
        expense: sub.الاعباء !== null ? sub?.الاعباء : sub?.expense == null ? 0 : sub?.expense,
        discount: sub?.الخصم !== null ? sub?.الخصم : sub?.discount == null ? 0 : sub?.discount,

      };
    });
    const tb = {
      wait: true,
      ExcelInv: true,
      parms: {
        safe: valueSafes?.id,
        branch: sto.branchi,
        _Data: dataDown,
        bol1: permiCuCo.CWVat,
        sProTyInvPro: setting.PrTy_InPr,
      },
    };

    axios
      .post(uri + "GetD", tb)
      .then((res) => {
        const dataItems = res.data.excelInv.map((row, i) => {
          return {
            ...row,
            UnitsTable: [],
            defUnit: {},
            no: i,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            tab3val_sub: row?.tab3Val ?? 0,
            tab3Val: row?.tab3Val ?? 0,
            type: 1,
          };
        });

        setIsData(dataItems);
        handSums(dataItems);
        setExSub(dataItems.length);
        setValue(0);

      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getBarcodeMulti = async (itemcode) => {
    let item = null;
    let ibance = 0.0;
    let units = null;
    let defaultUnits = null;

    if (itemcode == "null") {

    } else {

      if (stor.invsType === 7) {
        await axios
          .get(
            uri +
            `RptSales/CurrCodesMake?currCode=${itemcode}
            &&emp=${sto.empi}&&safe=${valueSafes.id}`
          )
          .then((res) => {
            item = res.data?.barcodes[0];
            units = res.data?.unitsSub;
            defaultUnits = res.data?.unitsSub[0];
            units = res.data?.unitsSub;
            ibance = res.data?.balance[0].Qtys ?? 0;
          })
          .catch((err) => {
            toast.error("لا يوجد صنف لهذا الباركود");
            console.log(err);
          });
        if (item != null) {
          setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
          await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
          // setIsBarcode(true);
        } else {
          toast.error("لا يوجد صنف لهذا الباركود");
        }
      }
      else {
        if (permistionInv?.CUSTPRICE && stor.invsType != 5) {
          await axios
            .get(
              uri +
              `RptSales/ItemsCodesCust?currCode=${itemcode}
            &&emp=${sto.empi}&&cust_id=${valueCustomers.id}&&invType=${setting.PrTy_InPr}
            &&safe=${valueSafes.id}`
            )
            .then((res) => {
              defaultUnits = res.data?.unitsSub[0];
              units = res.data?.unitsSub;
              item = res.data?.barcodes[0];
              ibance = res.data?.balance[0]?.Qtys ?? 0;
            })
            .catch((err) => {
              // toast.error("لا يوجد صنف لهذا الباركود");
              if (item == null) {
                getcustitem(itemcode);
              }
            });
          if (item != null) {
            let totValbef = 0.0;
            for (let m = 0; m < isdata.length; m++) {
              if (item.curr == isdata[m].currency_from)
                totValbef += (isdata[m].val1 * isdata[m].val);
            };
            let oldVal = Number(ibance) - totValbef;

            setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
            if (permistionInv.SIM == false &&
              oldVal < 1 && item.ctype != 4 &&
              (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
              alert(
                `
                الكمية المدخلة للصنف أكبر من رصيد المخزن
                الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(item?.perc))
                }
                رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
                }
                `
              );
            } else {
              await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
            }
            // setIsBarcode(true);
          } else {
            toast.error("لا يوجد صنف لهذا الباركود");
          }
        }
        else {
          if (permistionInv?.LEVELPRICES > 0 && (stor.invsType == 0 || stor.invsType == 1)) {
            await axios
              .get(
                uri +
                `RptSales/ItemsPriceLevel?currCode=${itemcode}
          &&emp=${sto.empi}&&branch=${sto.branchi}&&invType=${setting.PrTy_InPr}
          &&safe=${valueSafes.id}&&cust_id=${valueCustomers.id}&&level=${permistionInv?.LEVELPRICES}`
              )
              .then((res) => {
                defaultUnits = res.data?.unitsSub[0];
                units = res.data?.unitsSub;
                item = res.data?.barcodes[0];
                ibance = res.data?.balance[0].Qtys ?? 0;
              })
              .catch((err) => {
                console.log(err);
              });
            if (item != null) {
              let totValbef = 0.0;
              for (let m = 0; m < isdata.length; m++) {
                if (item.curr == isdata[m].currency_from)
                  totValbef += (isdata[m].val1 * isdata[m].val);
              };
              let oldVal = Number(ibance) - totValbef;

              setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
              if (permistionInv.SIM == false &&
                oldVal < 1 && item.ctype != 4 &&
                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                alert(
                  `
              الكمية المدخلة للصنف أكبر من رصيد المخزن
              الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(item?.perc))
                  }
              رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
                  }
              `
                );
              } else {
                await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
              }
              // setIsBarcode(true);
            } else {
              toast.error("لا يوجد صنف لهذا الباركود");
            }
          }
          else {
            await axios
              .get(
                uri +
                `RptSafes/CurrCodesUnitsSub?currCode=${itemcode}
          &&emp=${sto.empi}
          &&safe=${valueSafes.id}`
              )
              .then((res) => {
                defaultUnits = res.data?.unitsSub[0];
                units = res.data?.unitsSub;
                item = res.data?.barcodes[0];
                ibance = res.data?.balance[0].Qtys ?? 0;
              })
              .catch((err) => {
                // toast.error("لا يوجد صنف لهذا الباركود");
                console.log(err);
              });
            if (item != null) {
              let totValbef = 0.0;
              for (let m = 0; m < isdata.length; m++) {
                if (item.curr == isdata[m].currency_from)
                  totValbef += (isdata[m].val1 * isdata[m].val);
              };
              let oldVal = Number(ibance) - totValbef;

              setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
              if (permistionInv.SIM == false &&
                oldVal < 1 && item.ctype != 4 &&
                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                alert(
                  `
              الكمية المدخلة للصنف أكبر من رصيد المخزن
              الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(item?.perc))
                  }
              رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
                  }
              `
                );
              } else {
                await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
              }
              // setIsBarcode(true);
            } else {
              toast.error("لا يوجد صنف لهذا الباركود");
            }
          }

        }
      }
    }


  };

  const onChangeAutoCurrNormal = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue });

    if (newValue.id === "" || newValue.id == null) {

    } else {
      getBarcodeMultiNormal(newValue.barcode, true);
    }
  };

  const onChangeSearchNormal = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    getBarcodeMultiNormal(rptParams?.barcodeNormal, true);
  };
  const autocompleteref = useRef(null);

  const keepautocompletFocus = () => {
    if (autocompleteref.current) {
      autocompleteref.current.querySelector("input")?.focus();
    }
  };
  const getBarcodeMultiNormal = async (itemcode, status) => {
    let item = null;
    let ibance = 0.0;
    let units = null;
    let defaultUnits = null;
    if (itemcode == "null") {

    } else {

      if (stor.invsType === 7) {
        await axios
          .get(
            uri +
            `RptSales/CurrCodesMake?currCode=${itemcode}
            &&emp=${sto.empi}&&safe=${valueSafes.id}`
          )
          .then((res) => {
            item = res.data?.barcodes[0];
            units = res.data?.unitsSub;
            defaultUnits = res.data?.unitsSub[0];
            units = res.data?.unitsSub;
            ibance = res.data?.balance[0].Qtys ?? 0;
          })
          .catch((err) => {
            toast.error("لا يوجد صنف لهذا الباركود");
            console.log(err);
          });
        if (item != null) {
          const valueItems = GetItemFromOptions(item.curr, AutoOptions.InvItems);

          setRptParams({ ...rptParams, barcodeS: '', curr: valueItems });
          await getNormalData({ ...item }, { ...defaultUnits }, units, ibance);
          // setIsBarcode(true);
          if (status)
            document.getElementById("val11").focus();

        } else {
          toast.error("لا يوجد صنف لهذا الباركود");
          if (status) keepautocompletFocus();
        }
      }
      else {
        if (permistionInv?.CUSTPRICE && stor.invsType != 5) {
          await axios
            .get(
              uri +
              `RptSales/ItemsCodesCust?currCode=${itemcode}
            &&emp=${sto.empi}&&cust_id=${valueCustomers.id}&&invType=${setting.PrTy_InPr}
            &&safe=${valueSafes.id}`
            )
            .then((res) => {
              defaultUnits = res.data?.unitsSub[0];
              units = res.data?.unitsSub;
              item = res.data?.barcodes[0];
              ibance = res.data?.balance[0]?.Qtys ?? 0;
            })
            .catch((err) => {
              // toast.error("لا يوجد صنف لهذا الباركود");

            });
          if (item != null) {
            let totValbef = 0.0;
            for (let m = 0; m < isdata.length; m++) {
              if (item.curr == isdata[m].currency_from)
                totValbef += (isdata[m].val1 * isdata[m].val);
            };
            let oldVal = Number(ibance) - totValbef;
            const valueItems = GetItemFromOptions(item.curr, AutoOptions.InvItems);

            setRptParams({ ...rptParams, barcodeS: '', curr: valueItems });
            await getNormalData({ ...item }, { ...defaultUnits }, units, ibance);
            if (status) document.getElementById("val11").focus();
          } else {
            toast.error("لا يوجد صنف لهذا الباركود");
            if (status) keepautocompletFocus();
          }
        }
        else {
          if (permistionInv?.LEVELPRICES > 0 && (stor.invsType == 0 || stor.invsType == 1)) {
            await axios
              .get(
                uri +
                `RptSales/ItemsPriceLevel?currCode=${itemcode}
          &&emp=${sto.empi}&&branch=${sto.branchi}&&invType=${setting.PrTy_InPr}
          &&safe=${valueSafes.id}&&cust_id=${valueCustomers.id}&&level=${permistionInv?.LEVELPRICES}`
              )
              .then((res) => {
                defaultUnits = res.data?.unitsSub[0];
                units = res.data?.unitsSub;
                item = res.data?.barcodes[0];
                ibance = res.data?.balance[0].Qtys ?? 0;
              })
              .catch((err) => {
                console.log(err);
              });
            if (item != null) {
              let totValbef = 0.0;
              for (let m = 0; m < isdata.length; m++) {
                if (item.curr == isdata[m].currency_from)
                  totValbef += (isdata[m].val1 * isdata[m].val);
              };
              let oldVal = Number(ibance) - totValbef;

              setRptParams({ ...rptParams, barcode: '', barcodeS: '' });
              if (permistionInv.SIM == false &&
                oldVal < 1 && item.ctype != 4 &&
                (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                alert(
                  `
              الكمية المدخلة للصنف أكبر من رصيد المخزن
              الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(item?.perc))
                  }
              رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
                  }
              `
                );
              } else {
                const valueItems = GetItemFromOptions(item.curr, AutoOptions.InvItems);
                setRptParams({ ...rptParams, barcode: '', curr: valueItems });
                await getNormalData({ ...item }, { ...defaultUnits }, units, ibance);
                if (status) document.getElementById("val11").focus();
              }
              // setIsBarcode(true);
            } else {
              toast.error("لا يوجد صنف لهذا الباركود");
            }
          }
          else {
            await axios
              .get(
                uri +
                `RptSafes/CurrCodesUnitsSub?currCode=${itemcode}
          &&emp=${sto.empi}
          &&safe=${valueSafes.id}`
              )
              .then((res) => {
                defaultUnits = res.data?.unitsSub[0];
                units = res.data?.unitsSub;
                item = res.data?.barcodes[0];
                ibance = res.data?.balance[0].Qtys ?? 0;
              })
              .catch((err) => {
                // toast.error("لا يوجد صنف لهذا الباركود");
                console.log(err);
              });
            if (item != null) {
              let totValbef = 0.0;
              for (let m = 0; m < isdata.length; m++) {
                if (item.curr == isdata[m].currency_from)
                  totValbef += (isdata[m].val1 * isdata[m].val);
              };
              let oldVal = Number(ibance) - totValbef;
              const valueItems = GetItemFromOptions(item.curr, AutoOptions.InvItems);

              setRptParams({ ...rptParams, barcode: '', curr: valueItems });
              await getNormalData({ ...item }, { ...defaultUnits }, units, ibance);
              if (status) document.getElementById("val11").focus();

            }
            else {
              toast.error("لا يوجد صنف لهذا الباركود");
              if (status) keepautocompletFocus();

            }
          }
        }
      }
    }


  };
  ///---------------------------normal download------------------
  const getNormalData = (dataCode, unitF, Units, ibance) => {
    setItemId(dataCode.curr);

    setCurrUnit(unitF);
    setValueItemsUnits(unitF);
    setOptinsTableUnits(Units);
    setOptionsCurrUnits(Units);
    let pricei = 0.0;
    let totJust = 0.0;
    let taxval = 0.0;
    let taxperc = 0.0;
    let diaperc = 0.0;
    let dismount = 0.0;
    let valperc = 0.0;
    if (setting.PrTy_InPr === "22") {
      taxperc = 0.0;
      pricei = parseFloat(dataCode?.purch).toFixed(2);
    } else if (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12" || setting.PrTy_InPr === "03") {
      pricei = parseFloat(dataCode?.sale);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    }
    else {
      pricei = parseFloat(dataCode?.purch);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    };
    if (valueCustomers?.disc_perc > 0 || valueCustomers?.discount > 0) {
      if (valueCustomers?.disc_perc > 0) {
        dataCode.discount = valueCustomers?.disc_perc;
        let disc_mount = (
          parseFloat(valueCustomers?.disc_perc / 100) * parseFloat(pricei)
        ).toFixed(2);
        dataCode.amount_disc = disc_mount;
      } else if (valueCustomers?.discount > 0) {
        let disc_perc = (
          (parseFloat(valueCustomers?.discount) / parseFloat(pricei)) * 100).toFixed(2);
        dataCode.discount = disc_perc;
        dataCode.amount_disc = valueCustomers?.discount;
      }
    } else {
      dismount = Number(dataCode.amount_disc);
      diaperc = Number(dataCode.discount);

      if (diaperc > 0) {
        dataCode.discount = diaperc;
        let disc_mount = (
          parseFloat(diaperc / 100) * parseFloat(pricei)
        ).toFixed(2);
        dataCode.amount_disc = disc_mount;
      } else if (dismount > 0) {
        let disc_perc = (
          (parseFloat(dismount) / parseFloat(pricei)) * 100).toFixed(2);
        dataCode.discount = disc_perc;
        dataCode.amount_disc = dismount;
      }
    }

    taxval = ((parseFloat(pricei) * parseFloat(dataCode.tax)) / 100).toFixed(2);
    totJust = (parseFloat(pricei)).toFixed(2);
    diaperc = (parseFloat(dataCode.discount ?? 0)).toFixed(2);
    dismount = (parseFloat(dataCode.amount_disc ?? 0)).toFixed(2);
    valperc = (parseFloat(dataCode.perc)).toFixed(2);

    setSubInfo({
      ...subInfo,
      val1: 1,
      is_tab3_curr: dataCode?.is_tab3_curr,
      id: dataCode.curr,
      minPrice: dataCode.mPrice,
      Price: pricei,
      val: dataCode.perc,
      barcode: dataCode.barcode,
      symbol: dataCode.symbol,
      type: dataCode.ctype,
      perc: dataCode.perc,
      taxperc: taxperc,
      totJust: parseFloat(pricei).toFixed(2),
      discount: dismount,
      DiscPers: diaperc,
      taxval: ((pricei * taxperc) / 100).toFixed(2),
      unitame: unitF.unitName,
      jPrice: parseFloat(dataCode.jPrice),
      dPrice: parseFloat(dataCode.dPrice),
      salePrice: parseFloat(dataCode.sale),
      PricePu: parseFloat(dataCode.purch),
      UnitsTable: Units,
      defUnit: unitF,
      no: isdata?.length,
      Qtys: Number(ibance),
    });
    setCounts({ curr: ibance });
  };
  ///---------------------------normal download------------------

  const getcustitem = async (itemcode) => {
    let item = null;
    let ibance = 0.0;
    let units = null;
    let defaultUnits = null;
    await axios
      .get(
        uri +
        `RptSafes/CurrCodesUnitsSub?currCode=${itemcode}
    &&emp=${sto.empi}
    &&safe=${valueSafes.id}`
      )
      .then((res) => {

        item = res.data?.barcodes[0];
        defaultUnits = res.data?.unitsSub[0];
        units = res.data?.unitsSub;
        item = res.data?.barcodes[0];
        ibance = res.data?.balance[0]?.Qtys ?? 0;
      })
      .catch((err) => {
        // toast.error("لا يوجد صنف لهذا الباركود");
        console.log(err);
      });
    if (item != null) {
      let totValbef = 0.0;
      for (let m = 0; m < isdata.length; m++) {
        if (item.curr == isdata[m].currency_from)
          totValbef += (isdata[m].val1 * isdata[m].val);
      };
      let oldVal = Number(ibance) - totValbef;

      setRptParams({ ...rptParams, barcode: '', barcodeS: '' });
      if (permistionInv.SIM == false &&
        oldVal < 1 &&
        (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
        alert(
          `
            الكمية المدخلة للصنف أكبر من رصيد المخزن
            الكمية الاجمالية المدخلة : ${totValbef + (parseFloat(1) * parseFloat(item?.perc))
          }
            رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
          }
            `
        );
      } else {
        await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
      }
      // setIsBarcode(true);
    } else {
      toast.error("لا يوجد صنف لهذا الباركود");
    }
  };

  const getCustomerData = async () => {
    if (valueCustomers?.id == null) {

      alert("ooooo");
    } else {
      await axios
        .get(
          uri +
          `RptSales/getCustData?custId=${valueCustomers?.id}`
        )
        .then((res) => {

          setCustData(res.data?.custData[0]);
        })
        .catch((err) => {
          toast.error("لا يوجد بيانات لهذا العميل ");
          console.log(err);
        });

      if (custData != null) {
        handleOpenCustomerData();
      } else {
        toast.error("لا يوجد بيانات لهذا العميل ");
      }
    }
  };
  const getNewItamsData = async () => {
    const tb = {
      wait: true,
      other: true,
      parms: {
        tname: "curr",
        branch: sto.branchi,
      },
    };

    axios
      .post(uri + "GetD", tb)
      .then((res) => {
        setNewItemsAdd({
          ...newItemsAdd,
          id: res.data.other.lastid, barcode: res.data.other.barcode,
        });
        handleOpenItems();
      })
      .catch((error) => {
      });
  };

  function GetEmpFromOptions(id, options) {
    const index = options?.findIndex((op) => op.unit == id);
    return options[index];
  }

  const barcodeadd = (dataCode, defaultUnit, Units, Qtys) => {
    setRowUpdate({});
    let pricei = 0.0;
    let totJust = 0.0;
    let taxval = 0.0;
    let taxperc = 0.0;
    let diaperc = 0.0;
    let dismount = 0.0;
    let valperc = 0.0;
    let tot_before_vat_with_tab3val = 0.0;
    if (setting.PrTy_InPr === "22") {
      taxperc = 0.0;
      pricei = parseFloat(dataCode?.purch).toFixed(2);
    } else if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
      pricei = parseFloat(dataCode?.sale);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    }
    else {
      pricei = parseFloat(dataCode?.purch);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    };
    if (valueCustomers?.disc_perc > 0 || valueCustomers?.discount > 0) {
      if (valueCustomers?.disc_perc > 0) {
        dataCode.discount = valueCustomers?.disc_perc;
        dataCode.amount_disc = 0;
      } else if (valueCustomers?.discount > 0) {
        dataCode.discount = 0;
        dataCode.amount_disc = valueCustomers?.discount;
      }
    }

    taxval = ((parseFloat(pricei) * parseFloat(dataCode.tax)) / 100).toFixed(2);
    totJust = (parseFloat(pricei)).toFixed(2);

    let i = {
      amount_disc: Number(dataCode.amount_disc),
      discount: Number(dataCode.discount),
    };
    diaperc = (parseFloat(i.discount)).toFixed(2);
    dismount = (parseFloat(i.amount_disc)).toFixed(2);
    if (parseFloat(dismount) > parseFloat(pricei)) dismount = 0;
    valperc = (parseFloat(dataCode.perc)).toFixed(2);

    let errorList = [];
    let restaxvalA = 0,
      resNetA = 0,

      restotJustSumA = 0,
      restotJustAfterDiscSumA = 0,
      resDiscPerA = 0,
      resDisCountA = 0,
      tot_befor_vat_after_disc = 0;

    restotJustSumA = parseFloat(totJust);

    if (permistionInv.DSOB == true) {
      if (checked.discRateck === true) {
        //  alert('in if')
        resDiscPerA = parseFloat(invDisc.rate);
        resDisCountA = (
          parseFloat(invDisc.rate / 100) * parseFloat(totJust)
        ).toFixed(2);

        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(resDisCountA);
      } else if (checked.discMinusck === true) {
        resDiscPerA = (
          (parseFloat(idata.minus) / parseFloat(totJust)) *
          100
        ).toFixed(2);
        resDisCountA = (
          parseFloat(resDiscPerA / 100) * parseFloat(totJust)
        ).toFixed(2);
      }

    } else {
      if (diaperc > 0) {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);
        resDiscPerA = parseFloat(diaperc);
        resDisCountA = (
          parseFloat(diaperc / 100) * parseFloat(totJust)
        ).toFixed(2);

      } else if (dismount > 0) {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);

        let desc_perc = (
          (dismount * 100) /
          parseFloat(totJust)
        );
        resDiscPerA = parseFloat(desc_perc);
        resDisCountA = (
          parseFloat(resDiscPerA / 100) * parseFloat(totJust)
        ).toFixed(2);

      } else {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);
        resDiscPerA = parseFloat(diaperc);
        resDisCountA = (
          parseFloat(diaperc / 100) * parseFloat(totJust)
        ).toFixed(2);
      }

    }



    restotJustAfterDiscSumA =
      parseFloat(totJust) - parseFloat(resDisCountA);


    restaxvalA = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "taxval"
    );

    tot_befor_vat_after_disc = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "before_vat"
    );
    resNetA = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "Net"
    );

    if (dataCode?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
      tot_before_vat_with_tab3val = (parseFloat(tot_befor_vat_after_disc) < parseFloat(25)) ?
        parseFloat(25) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

      let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

      restaxvalA = mathsTab3val(
        parseFloat(tot_before),
        parseFloat(taxperc),
        "taxval"
      );

      resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
    }

    dataCode = {
      /* to show */
      minPrice: dataCode.mPrice,
      PricePu: dataCode.purch,
      unitame: dataCode.unitName /*  - الـوحدة name */,
      symbol: dataCode.symbol /*  - إسم الصنف  */,
      /* to maaths */
      /* int -  الإجمالي */
      totJust: restotJustSumA,
      /* int - إجمالي الخصم بعد الخصم */
      totAfterDisc: tot_befor_vat_after_disc,

      tot_before_vat_after_d: tot_befor_vat_after_disc,
      sale_price: parseFloat(dataCode?.sale),

      tab3val_sub: tot_before_vat_with_tab3val,
      tab3Val: tot_before_vat_with_tab3val,
      /* to go */
      // currency_from: parseInt(subInfo.id), /* float - id الصنف */
      currency_from: parseInt(dataCode.curr) /* float - id الصنف */,
      unit: parseInt(dataCode.unit) /* int - الـوحدة id */,
      /* float - الكمية */
      val1: parseFloat(1),
      // new _val1:parseFloat(subInfo.new _val1),
      /* float - العبوة */
      val: parseFloat(valperc),
      // new _val:parseFloat(subInfo.perc),
      /* float - الـسعر */
      new_exchange_price: parseFloat(pricei),
      // all_new_exchange_price: parseFloat(subInfo.Price),
      /* float - الخصم  مبلغ*/
      discount: resDisCountA,
      /* float - %  خصم نسبة */
      DiscPers: resDiscPerA,
      /* float -  ضريبة القيمة المضافة نسبة */
      taxperc: parseFloat(taxperc),
      /* float - إجمالي قيمة المضافة  */
      taxval: parseFloat(restaxvalA),
      netAmountSub: parseFloat(resNetA).toFixed(2),
      barcode: dataCode.barcode /*  - الباركود */,
      sub_center: 0 /* int -  */,
      sub_branch: sto.branchi /* int - الفرع */,

      unitame: dataCode.unitName,
      sale_price: parseFloat(dataCode.sale),
      // DiscPers: parseFloat(diaperc),
      // discount: parseFloat(dataCode.amount_disc),
      discount: resDisCountA,
      DiscPers: resDiscPerA,
      taxperc: parseFloat(taxperc),
      Qtys: Qtys ?? 0,
      UnitsTable: Units,
      defUnit: defaultUnit,
      no: isdata?.length,
      editAbleVal: false,
      editAblePrice: false,
      editAbleUnit: false,
      editAbleTax: false,
      editAbleDescM: false,
      editAbleDescP: false,
      editAbleDescNote: false,
      type: dataCode.ctype,
    };
    if (errorList.length < 1) {
      //no error
      let add = 0;

      const updateItem = isdata.find((obj) => obj.barcode.toString() === dataCode.barcode.toString()
        && obj.new_exchange_price === dataCode.new_exchange_price);

      if (permistionInv?.NOREP === true) {
        let dataToAdd = [...isdata];
        dataToAdd.push(dataCode);
        setIsData(dataToAdd);
        handSums(dataToAdd);
        setExSub(dataToAdd.length);
        add = 1;

      }
      else {
        if (updateItem?.no != null) {
          let add = 1;
          let multiplier = (parseFloat(updateItem?.val1) + parseFloat(add)).toFixed(2);
          if (!isNaN(multiplier)) {

            let tot = parseFloat(multiplier * updateItem.new_exchange_price);
            let desc_mount = (
              parseFloat(tot) *
              (updateItem.DiscPers / 100)
            );
            let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

            let taxMount = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "taxval"
            );
            let betTax = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "before_vat"
            );

            let resNetA = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "Net"
            );

            if (parseFloat(updateItem?.tab3val_sub) > 0) {
              let tot_before_new = maths(
                parseFloat(pricei),
                parseFloat(updateItem.taxperc),
                "before_vat"
              );
              tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

              let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

              taxMount = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(updateItem.taxperc),
                "taxval"
              );

              resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                + parseFloat(taxMount)).toFixed(2);
            }
            const newData = {
              ...updateItem,
              val1: multiplier,
              totJust: tot,
              totAfterDisc: betTax,
              taxval: taxMount,
              netAmountSub: resNetA,
              discount: desc_mount,
              tab3val_sub: tot_before_vat_with_tab3val,
              tab3Val: tot_before_vat_with_tab3val,
            };

            const index = updateItem?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = { ...newData };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
          }
        } else {
          let dataToAdd = [...isdata];
          dataToAdd.push(dataCode);
          setIsData(dataToAdd);
          handSums(dataToAdd);
          setExSub(dataToAdd.length);
          add = 1;

        }

      }
    } else {
      // resolve();
    }
  };
  const checkItemsBalance = async () => {
    let balanceItems = null;
    const tb = {
      wait: true,
      checksItems: true,
      parms: {
        safe: valueSafes?.id,
        branch: sto.branchi,
        _Data: isdata,
      },
    };

    axios
      .post(uri + "GetD", tb)
      .then((res) => {
        balanceItems = isdata.map((sub) => {
          const blncData = res?.data?.itemsBalance.find((obj) => obj.currency_from === sub.currency_from);
          let realBalnce = 0;
          let qnt = blncData?.Qtys ?? 0;
          let itemVal = (parseFloat(sub.val) * parseFloat(sub.val1)).toFixed(2)
          realBalnce = (parseFloat(qnt) - parseFloat(itemVal)).toFixed(2);
          return {
            ...sub,
            Qtys: blncData?.Qtys ?? 0,
            realBalnce: parseFloat(realBalnce),
          };
        });
        getCheckItems(balanceItems);

      })
      .catch((error) => {
        console.log(error);
        transformSale();
      });
  };

  const getCheckItems = (balanceItems) => {
    var newData = balanceItems.filter((obj) => parseFloat(obj.realBalnce) < 0);
    if (newData != null) {
      if (newData.length == 0) {
        transformSale();
      } else {
        handOSnack({
          vertical: "top",
          horizontal: "center",
          severit: "warning",
          text: "Check For Items Balance ..You Don't Have permission For Sale in minus",
          time: 2000,
        });
      }
    }
  };
  const transformDone = () => {
    if (permistionInv.SIM == false) {
      checkItemsBalance();
    } else {
      transformSale();
    }
  };


  const transformSale = () => {
    his.replace({
      pathname: `/Invoces`,
      state: transToSal,
    });
    GetConvertingInv(
      location.state.setting.iformid,
      "02"
    );
    setIData({
      ...idata,
      date: moment(new Date()).format("YYYY-MM-DD")
    });
    location.state.setting = transToSal.setting;
    setSetting(location.state.setting);
    location.state.stor = transToSal.stor;
    setStor(location.state.stor);
    setOr({ ...or, postput: "toPost" });
  };
  const transformDonePurch = () => {
    his.replace({
      pathname: `/Invoces`,
      state: transToPurch,
    });
    GetConvertingInv(
      location.state.setting.iformid,
      "01"
    );
    setIData({
      ...idata,
      date: moment(new Date()).format("YYYY-MM-DD")
    });
    location.state.setting = transToPurch.setting;
    setSetting(location.state.setting);
    location.state.stor = transToPurch.stor;
    setStor(location.state.stor);

    setOr({ ...or, postput: "toPost" });
  };

  const onClickButton = async (procId, type) => {
    const tb = {
      ButtonSearch: true,
      parms: {
        tname: type,
        branch: sto.branchi,
        iprocid: procId,
        sProTyInvPro: setting.PrTy_InPr,
      },
    };

    axios
      .post(uri + "GetD", tb)
      .then((res) => {
        setProcIdSearch(res.data?.procId_inv?.id);
        if (res.data?.procId_inv.id > 0) {
          setOr({ ...or, postput: "toPut", PrAC: 0 });
          showChosedInv(false, res.data.procId_inv.id, false);
          setIsClick({ ...ished, hed: true });
          if (setting.PrTy_InPr === "02") {
            setIshedden(true);
          } else {
            setIshedden(permistionInv.Up == true ? false : true);
          }
        }

      })
      .catch((error) => {
      });
  };



  const showChosedInv = async (t, val, fromReturn) => {
    if (setting.PrTy_InPr === "03" || setting.PrTy_InPr === "04") {
      if (!isHedden) {
        setIsOpenUpdate(true);
      }
    };
    const tbs = {
      View_Inv_reseloving: true,
      View_Inv_Expenses: setting.PrTy_InPr === "01" ? true : false,
      parms: {
        iprocid: val,
        bol1: permiCuCo.CWVat,
        sProTyInvPro: setting.PrTy_InPr,
      },
      autos: {},
    };
    const alt = { View_Inv_reseloving: true };

    const al = Object.entries(alt).reduce((u, [n, v]) => {
      u[`${n}` + `${t ? "t" : ""}`] = v;
      return u;
    }, {});
    const alts = { ...al, ...tbs };
    await axios
      .post(uri + "Res", alts)
      .then((res) => {
        //console.log('res.data'); console.log(res.data);
        setCarOptions({
          ...carOptions,
          CarModel: res.data.inv?.CarModel,
          CarYear: res.data.inv?.CarYear,
          CarType: res.data.inv?.CarType,
          CarStructure: res.data.inv?.CarStructure,
          CarVactor: res.data.inv?.CarVactor,
          CarColor: res.data.inv?.CarColor,
          CarPlatNum: res.data.inv?.CarPlatNum,
        });


        if (fromReturn) {
          setIData({
            ...res.data.inv, date: moment(new Date()).format("YYYY-MM-DD"),
            Due_date: res.data.inv?.Due_date == null ? "" : moment(res.data.inv?.Due_date).format("YYYY-MM-DD"),
            Delivery_date: res.data.inv?.Delivery_date == null ? "" : moment(res.data.inv?.Delivery_date).format("YYYY-MM-DD"),
          });
        } else {
          setIData({
            ...res.data.inv,
            Due_date: res.data.inv?.Due_date === null ? null : moment(res.data.inv?.Due_date).format("YYYY-MM-DD"),
            Delivery_date: res.data.inv?.Delivery_date === null ? null : moment(res.data.inv?.Delivery_date).format("YYYY-MM-DD"),
          });
        }
        console.log("the res data inve is", res.data.inv);
        // .then(resSub => {
        const dataItems = res.data.invS.map((row, i) => {
          return {
            ...row,
            UnitsTable: [],
            defUnit: {},
            no: i,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            tab3val_sub: row?.tab3Val ?? 0,
            Qtys: 0,
            tab3Val: row?.tab3Val ?? 0,
            type: 1,

          };
        });

        setIsData(dataItems);
        // setIsData(res.data.invS);
        setPayment({
          ...payment,
          paidup: res.data.inv?.Pay_mouny,
          stay: res.data.inv?.Remaining,
        });
        setRemains({
          ...remains,
          cashPart: res.data.inv?.cash_part,
          agelPart: res.data.inv?.agel_part,
          networkPart: res.data.inv?.network_part,
          bankPart: res.data.inv?.bank_part,
          empPart: res.data.inv?.emp_part,
        });
        setSums({
          ...sums,
          val1: res.data.invS.reduce(
            (totalVal1, sub) => totalVal1 + sub.val1,
            0
          ),
        });

        res.data.inv.inv_type === 1
          ? setValueType(AutoOptions.types[0])
          : setValueType(AutoOptions.types[1]);
        pinAutosValue("Safe", res.data.inv.safe);

        pinAutosValue("Stock", res.data.inv.stock);
        pinAutosValue("Customer", res.data.inv.cust_id);
        /* Autos options */
        if (res.data.inv.salesman != -1)
          pinAutosValue("salesmen", res.data.inv.salesman);
        else {
          setValueSalesmen(AutoOptions?.salesuser);
        }
        if (res.data.inv.center != -1)
          pinAutosValue("costcenter", res.data.inv.center);
        else {
          setValueCostcenter(AutoOptions?.centerUser);
        }
        let letNetworkck = false,
          letCashck = false,
          letcashORnetworksw = false;
        if (res.data.inv.pay_type === 1) {
          setValueBank(insh.AutoBank);
          letCashck = true;
          letcashORnetworksw = false;
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: false,
            DeleIcon: true,
          });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });
        }
        else if (res.data.inv.pay_type === 2) {
          letNetworkck = true;
          letcashORnetworksw = true;
          setUiElement({ ...uiElement, bank: false, DeleIcon: true });
          const text = transForm("network").toString();
          setLbl({ ...lbl, chashNetwork: text });
          pinAutosValue("Bank", res.data.inv.bank);
        }
        else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.cash_part) > 0) {
          setValueBank(insh.AutoBank);
          letCashck = true;
          letcashORnetworksw = false;
          setSwitchState({ ...switchState, cashORnetworksw: false });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: false,
            DeleIcon: true,
          });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });
        }
        else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.network_part) > 0) {
          letNetworkck = true;
          letcashORnetworksw = true;
          setUiElement({ ...uiElement, bank: false, DeleIcon: true });

          setValueBank(res.data.inv.bank);
          const text = transForm("network").toString();
          setLbl({ ...lbl, chashNetwork: text });
          pinAutosValue("Bank", res.data.inv.bank);
        }
        else if (res.data.inv.pay_type === -1 && res.data.inv.Pay_mouny === 0) {
          // setValueStock(AutoOptions.Stocks[0]);
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: true,
            stock: true,
            DeleIcon: true,
          });
          setValueBank(insh.AutoBank);
        }
        else {
          // setValueStock(AutoOptions.Stocks[0]);
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: true,
            stock: true,
            DeleIcon: true,
          });
          setValueBank(insh.AutoBank);
        }

        setInfoInv({
          id: res.data.inv.id,
          InvId_Return:
            res.data.inv.InvId_Return != null
              ? res.data.inv.InvId_Return
              : infoInv.InvId_Return,
        });

        /* ======= S in PMD ======= */
        /* checked AND Autos */
        let cash_p = false,
          network_p = false,
          agel_p = false,
          bank_p = false,
          emp_p = false;

        if (res.data.inv.cash_part !== null || res.data.inv.cash_part === 0) {
          cash_p = true;
        }

        if (
          res.data.inv.network_part !== null ||
          res.data.inv.network_part === 0
        ) {
          // g etAutosOptions('Bank',res.data.inv.bank,'NWinPMD');
          pinAutosValue("BankPMD", res.data.inv.bank);
          network_p = true;
        } else {
          setValueBankPMD(insh.AutoBank);
        }

        if (res.data.inv.agel_part !== null || res.data.inv.agel_part === 0) {
          agel_p = true;
        }

        if (res.data.inv.bank_part !== null || res.data.inv.bank_part === 0) {
          // g etAutosOptions('Bank',res.data.inv.bank,'Bk2inPMD');
          pinAutosValue("Bank2PMD", res.data.inv.bank);
          bank_p = true;
        }

        if (res.data.inv.emp_part !== null || res.data.inv.emp_part === 0) {
          // g etAutosOptions('Employee',res.data.inv.emp,'EmpinPMD');
          pinAutosValue("EmployeePMD", res.data.inv.emp);
          emp_p = true;
        }

        setSwitchState({ ...switchState, cashORnetworksw: letcashORnetworksw });
        setChecked({
          ...checked,

          // in UP
          cashck: letCashck,
          networkck: letNetworkck,
          // in PMD
          cash_partck: cash_p,
          network_partck: network_p,
          agel_partck: agel_p,
          bank_partck: bank_p,
          emp_partck: emp_p,
        });

        /* ======= E in PMD ======= */
        setPermiElm({ ...permiElm, SaUp: permiElm.Up });
        // set discount values
        fcHandSumsToinvDisc(res.data.inv?.amountBefordisc, res.data.inv?.minus);
        if (setting.PrTy_InPr === "01" && res?.data?.InvExpenses?.length > 0) {
          getExpensesInv(res?.data?.InvExpenses);
        }
        setValue(0);
        handCloseDw();
      })
      .catch((error) => {
        /*console.log('no res');*/
      });
  };

  const getExpensesInv = (subData) => {
    setExpenseList(
      subData.map((sub, i) => {
        const account = AutoOptions?.Accindex.find((obj) => obj.id === sub.Expense_Acc_no);
        const defOmla = gets?.omlats.find((obj) => obj.id === sub.omla);

        return {
          ...sub,
          omlaName: defOmla.name,
          exchange: defOmla.exchange,
          acc_name: account.name,
          name: account.name,
          editOmla: false,
          edit_acc_no: false,
          editNotes: false,
          editValue: false,
          defAcc_no: {},
          defOmla: {},
          no: i,
        };
      }));


  };

  useEffect(() => {
    showDialogInv();
  }, []);

  const showDialogInv = async () => {

    if (props.isDialog === true) {
      setOr({ ...or, postput: "toPut", PrAC: 0 });

      if (props.invData.ProcType_InvProc === "02" || props.invData.ProcType_InvProc === "12") {
        setIshedden(true);
      } else {
        setIshedden(permistionInv.Up == true ? false : true);
      }
      if (props.invData.ProcType_InvProc === "03" || props.invData.ProcType_InvProc === "04") {
        if (!isHedden) {
          setIsOpenUpdate(true);
        }
      };
      let t = false;
      const tbs = {
        View_Inv_reseloving: true,
        View_Inv_Expenses: props.invData.ProcType_InvProc === "01" ? true : false,
        parms: {
          iprocid: props.invData.proc_id,
          bol1: permiCuCo.CWVat,
          sProTyInvPro: props.invData.ProcType_InvProc,
        },
        autos: {},
      };
      const alt = { View_Inv_reseloving: true };

      const al = Object.entries(alt).reduce((u, [n, v]) => {
        u[`${n}` + `${t ? "t" : ""}`] = v;
        return u;
      }, {});
      const alts = { ...al, ...tbs };
      await axios
        .post(uri + "Res", alts)
        .then((res) => {
          //console.log('res.data'); console.log(res.data);
          setIData({
            ...res.data.inv,
            time: moment(res.data.inv.date).format(" h:mm A"),
          });
          console.log("the res data inve is", res.data.inv);
          // .then(resSub => {
          // setIData(res.data.inv);
          const dataItems = res.data.invS.map((row, i) => {
            return {
              ...row,
              UnitsTable: [],
              defUnit: {},
              no: i,
              editAbleVal: false,
              editAblePrice: false,
              editAbleUnit: false,
              editAbleTax: false,
              editAbleDescM: false,
              editAbleDescP: false,
              editAbleDescNote: false,
              tab3val_sub: row?.tab3Val ?? 0,
              Qtys: 0,
              tab3Val: row?.tab3Val ?? 0,
              type: 1,

            };
          });

          setIsData(dataItems);
          // setIsData(res.data.invS);
          setPayment({
            ...payment,
            paidup: res.data.inv?.Pay_mouny,
            stay: res.data.inv?.Remaining,
          });
          setRemains({
            ...remains,
            cashPart: res.data.inv?.cash_part,
            agelPart: res.data.inv?.agel_part,
            networkPart: res.data.inv?.network_part,
            bankPart: res.data.inv?.bank_part,
            empPart: res.data.inv?.emp_part,
          });
          setSums({
            ...sums,
            val1: res.data.invS.reduce(
              (totalVal1, sub) => totalVal1 + sub.val1,
              0
            ),
          });

          res.data.inv.inv_type === 1
            ? setValueType(AutoOptions.types[0])
            : setValueType(AutoOptions.types[1]);
          pinAutosValue("Safe", res.data.inv.safe);

          pinAutosValue("Stock", res.data.inv.stock);
          pinAutosValue("Customer", res.data.inv.cust_id);
          /* Autos options */
          if (res.data.inv.salesman != -1)
            pinAutosValue("salesmen", res.data.inv.salesman);
          else {
            setValueSalesmen(AutoOptions?.salesuser);
          }
          if (res.data.inv.center != -1)
            pinAutosValue("costcenter", res.data.inv.center);
          else {
            setValueCostcenter(AutoOptions?.centerUser);
          }
          let letNetworkck = false,
            letCashck = false,
            letcashORnetworksw = false;
          if (res.data.inv.pay_type === 1) {
            setValueBank(insh.AutoBank);
            letCashck = true;
            letcashORnetworksw = false;
            setUiElement({
              ...uiElement,
              bank: true,
              payMethod: false,
              DeleIcon: true,
            });
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
          }
          else if (res.data.inv.pay_type === 2) {
            letNetworkck = true;
            letcashORnetworksw = true;
            setUiElement({ ...uiElement, bank: false, DeleIcon: true });
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            pinAutosValue("Bank", res.data.inv.bank);
          }
          else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.cash_part) > 0) {
            setValueBank(insh.AutoBank);
            letCashck = true;
            letcashORnetworksw = false;
            setSwitchState({ ...switchState, cashORnetworksw: false });
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
            setUiElement({
              ...uiElement,
              bank: true,
              payMethod: false,
              DeleIcon: true,
            });
            setLbl({ ...lbl, chashNetwork: transForm("cash") });
          }
          else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.network_part) > 0) {
            letNetworkck = true;
            letcashORnetworksw = true;
            setUiElement({ ...uiElement, bank: false, DeleIcon: true });

            setValueBank(res.data.inv.bank);
            const text = transForm("network").toString();
            setLbl({ ...lbl, chashNetwork: text });
            pinAutosValue("Bank", res.data.inv.bank);
          }
          else if (res.data.inv.pay_type === -1 && res.data.inv.Pay_mouny === 0) {
            // setValueStock(AutoOptions.Stocks[0]);
            setUiElement({
              ...uiElement,
              bank: true,
              payMethod: true,
              stock: true,
              DeleIcon: true,
            });
            setValueBank(insh.AutoBank);
          }
          else {
            // setValueStock(AutoOptions.Stocks[0]);
            setUiElement({
              ...uiElement,
              bank: true,
              payMethod: true,
              stock: true,
              DeleIcon: true,
            });
            setValueBank(insh.AutoBank);
          }

          setInfoInv({
            id: res.data.inv.id,
            InvId_Return:
              res.data.inv.InvId_Return != null
                ? res.data.inv.InvId_Return
                : infoInv.InvId_Return,
          });

          /* ======= S in PMD ======= */
          /* checked AND Autos */
          let cash_p = false,
            network_p = false,
            agel_p = false,
            bank_p = false,
            emp_p = false;

          if (res.data.inv.cash_part !== null || res.data.inv.cash_part === 0) {
            cash_p = true;
          }

          if (
            res.data.inv.network_part !== null ||
            res.data.inv.network_part === 0
          ) {
            // g etAutosOptions('Bank',res.data.inv.bank,'NWinPMD');
            pinAutosValue("BankPMD", res.data.inv.bank);
            network_p = true;
          } else {
            setValueBankPMD(insh.AutoBank);
          }

          if (res.data.inv.agel_part !== null || res.data.inv.agel_part === 0) {
            agel_p = true;
          }

          if (res.data.inv.bank_part !== null || res.data.inv.bank_part === 0) {
            // g etAutosOptions('Bank',res.data.inv.bank,'Bk2inPMD');
            pinAutosValue("Bank2PMD", res.data.inv.bank);
            bank_p = true;
          }

          if (res.data.inv.emp_part !== null || res.data.inv.emp_part === 0) {
            // g etAutosOptions('Employee',res.data.inv.emp,'EmpinPMD');
            pinAutosValue("EmployeePMD", res.data.inv.emp);
            emp_p = true;
          }

          setSwitchState({ ...switchState, cashORnetworksw: letcashORnetworksw });
          setChecked({
            ...checked,

            // in UP
            cashck: letCashck,
            networkck: letNetworkck,
            // in PMD
            cash_partck: cash_p,
            network_partck: network_p,
            agel_partck: agel_p,
            bank_partck: bank_p,
            emp_partck: emp_p,
          });

          /* ======= E in PMD ======= */
          setPermiElm({ ...permiElm, SaUp: permiElm.Up });
          // set discount values
          fcHandSumsToinvDisc(res.data.inv?.amountBefordisc, res.data.inv?.minus);
          if (props.invData.ProcType_InvProc === "01" && res?.data?.InvExpenses?.length > 0) {
            getExpensesInv(res?.data?.InvExpenses);
          };
          handCloseDw();

        })
        .catch((error) => {
        });
    }
  };
  const showChosedInvt = async (t, val) => {
    const tbs = { parms: { iprocid: val, bol1: permiCuCo.CWVat }, autos: {} };
    const alt = { View_Inv_reseloving: true };
    const al = Object.entries(alt).reduce((u, [n, v]) => {
      u[`${n}` + `${t ? "t" : ""}`] = v;
      return u;
    }, {});
    const alts = { ...al, ...tbs };

    await axios
      .post(uri + "Res", alts)
      .then((res) => {
        setIData({
          ...res.data.inv, date: moment(new Date()).format("YYYY-MM-DD"),
          Due_date: res.data.inv?.Due_date == null ? "" : moment(res.data.inv?.Due_date).format("YYYY-MM-DD"),
          Delivery_date: res.data.inv?.Delivery_date == null ? "" : moment(res.data.inv?.Delivery_date).format("YYYY-MM-DD"),
        });
        const dataItems = res.data.invS.map((row, i) => {
          return {
            ...row,
            UnitsTable: [],
            defUnit: {},
            no: i,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            tab3val_sub: row?.tab3Val ?? 0,
            Qtys: 0,
            tab3Val: row?.tab3Val ?? 0,
            type: 1,

          };
        });

        setIsData(dataItems);
        setPayment({
          ...payment,
          paidup: res.data.inv?.Pay_mouny,
          stay: res.data.inv?.Remaining,
        });
        setRemains({
          ...remains,
          cashPart: res.data.inv?.cash_part,
          agelPart: res.data.inv?.agel_part,
          networkPart: res.data.inv?.network_part,
          empPart: res.data.inv?.emp_part,
          bankPart: res.data.inv?.bank_part,

        });
        setSums({
          ...sums,
          val1: res.data.invS.reduce(
            (totalVal1, sub) => totalVal1 + sub.val1,
            0
          ),
        });
        setStor({ ...stor, comt: val });
        res.data.inv.inv_type == 1
          ? setValueType(AutoOptions.types[0])
          : setValueType(AutoOptions.types[1]);
        pinAutosValue("Safe", res.data.inv.safe);
        pinAutosValue("Stock", res.data.inv.stock);
        pinAutosValue("Customer", res.data.inv.cust_id);



        /* Autos options */
        if (res.data.inv.salesman != -1)
          pinAutosValue("salesmen", res.data.inv.salesman);
        else {

          setValueSalesmen(AutoOptions?.salesuser);
        }
        if (res.data.inv.center != -1)
          pinAutosValue("costcenter", res.data.inv.center);
        else {
          setValueCostcenter(AutoOptions?.centerUser);
        }
        let letNetworkck = false,
          letCashck = false,
          letcashORnetworksw = false;
        if (res.data.inv.pay_type == 1) {
          setValueBank(insh.AutoBank);
          letCashck = true;
          letcashORnetworksw = false;

          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: false,
            DeleIcon: true,
          });
        } else if (res.data.inv.pay_type == 2) {
          letNetworkck = true;
          letcashORnetworksw = true;
          setUiElement({ ...uiElement, bank: false, DeleIcon: true });
          setLbl({ ...lbl, chashNetwork: transForm("network") });
          pinAutosValue("Bank", res.data.inv.bank);
        }
        else if (res.data.inv.pay_type == -1 && parseFloat(res.data.inv.cash_part) > 0) {
          setValueBank(insh.AutoBank);
          letCashck = true;
          letcashORnetworksw = false;
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: false,
            DeleIcon: true,
          });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });
        }
        else if (res.data.inv.pay_type == -1 && parseFloat(res.data.inv.network_part) > 0) {
          letNetworkck = true;
          letcashORnetworksw = true;
          setUiElement({ ...uiElement, bank: false, DeleIcon: true });
          const text = transForm("network").toString();
          setLbl({ ...lbl, chashNetwork: text });
          pinAutosValue("Bank", res.data.inv.bank);
        }
        else if (res.data.inv.pay_type == -1 && parseFloat(res.data.inv.Pay_mouny) == 0) {
          setValueStock(AutoOptions.Stocks[0]);
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: true,
            stock: true,
            DeleIcon: true,
          });
          setValueBank(insh.AutoBank);
        }
        else {
          setValueStock(AutoOptions.Stocks[0]);
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: true,
            stock: true,
            DeleIcon: true,
          });
          setValueBank(insh.AutoBank);
        }
        setInfoInv({
          id: res.data.inv.id,
          InvId_Return:
            res.data.inv.InvId_Return != null
              ? res.data.inv.InvId_Return
              : infoInv.InvId_Return,
        });

        /* ======= S in PMD ======= */
        /* checked AND Autos */
        let cash_p = false,
          network_p = false,
          agel_p = false,
          bank_p = false,
          emp_p = false;

        if (res.data.inv.cash_part !== null || res.data.inv.cash_part === 0) {
          cash_p = true;
        }

        if (
          res.data.inv.network_part !== null ||
          res.data.inv.network_part === 0
        ) {
          pinAutosValue("BankPMD", res.data.inv.bank);
          network_p = true;
        } else {
          setValueBankPMD(insh.AutoBank);
        }

        if (res.data.inv.agel_part !== null || res.data.inv.agel_part === 0) {
          agel_p = true;
        }

        if (res.data.inv.bank_part !== null || res.data.inv.bank_part === 0) {
          pinAutosValue("Bank2PMD", res.data.inv.bank);
          bank_p = true;
        }

        if (res.data.inv.emp_part !== null || res.data.inv.emp_part === 0) {
          pinAutosValue("EmployeePMD", res.data.inv.emp);
          emp_p = true;
        }

        setSwitchState({ ...switchState, cashORnetworksw: letcashORnetworksw });
        setChecked({
          ...checked,
          // in UP
          cashck: letCashck,
          networkck: letNetworkck,
          // in PMD
          cash_partck: cash_p,
          network_partck: network_p,
          agel_partck: agel_p,
          bank_partck: bank_p,
          emp_partck: emp_p,
        });

        /* ======= E in PMD ======= */
        setPermiElm({ ...permiElm, SaUp: permiElm.Up });
        handCloseDwt();
        setValue(0);
      })
      .catch((error) => {
        /*console.log('no res');*/
      });
  };

  const [voucherDialog, setVoucherDialog] = useState({
    isOpen: false,
    data: "",
    onSucsess: "",
    onEnd: ""
  });


  const blurPaid2 = (pay) => {
    if (parseFloat(pay) > parseFloat(idata.netAmount)) {
      let valueVcher = (pay - parseFloat(idata.netAmount)).toFixed(2);
      //event.stopPropagation();
      setVoucherDialog({
        isOpen: true,
        data: {
          ...idata, id: infoInv.id,
          omlaId: omlaValue.id,
          exchange: omlaValue.exchange,
          valueOfVoucher: valueVcher
        },
        onSuccess: () => {
          // toDiloa
          setVoucherDialog({ ...voucherDialog, isOpen: false });
          toDoIdata("notes", "Receipt voucher for the amount:" + valueVcher);
        },

      });
      payment.paidupPMDcn = parseFloat(idata.netAmount);
      payment.stayPMDcn = payment.stay;
      payment.paidup = idata.netAmount;
      payment.stay = 0;
      //setPayment({ ...payment, paidup: parseFloat(idata.netAmount), stay: 0 });
    }
  };

  const changPayment = (prop) => (event) => {

    if (prop === "paidup") {

      let total = (parseFloat(idata.netAmount) - event.target.value).toFixed(2);
      // toDiloag
      payment.paidupPMDcn = event.target.value;
      payment.stayPMDcn = payment.stay;
      setPayment({ ...payment, paidup: event.target.value, stay: total });
      setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

      if (valueType.id === 1) {

        if (switchState.cashORnetworksw == false) {
          setUiElement({
            ...uiElement,
            stock: false,
            payMethod: false,
            bank: true,
          });

          setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

          const reet = reInshAuto(0, "");
          setValueBank(reet);
          setValueStock(AutoOptions.Stocks[0]);
          setSwitchState({ ...switchState, cashORnetworksw: false });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });
        } else if (switchState.cashORnetworksw == true) {
          setRemains({ ...remains, cashPart: 0, agelPart: total, bankPart: 0, networkPart: event.target.value });

          setUiElement({
            ...uiElement,
            stock: true,
            payMethod: false,
            bank: false,
          });

          setSwitchState({ ...switchState, cashORnetworksw: true });
          setLbl({ ...lbl, chashNetwork: transForm("network") });
        }
        else {
          setUiElement({
            ...uiElement,
            stock: false,
            payMethod: false,
            bank: true,
          });

          setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

          const reet = reInshAuto(0, "");
          setValueBank(reet);
          setValueStock(AutoOptions.Stocks[0]);
          setSwitchState({ ...switchState, cashORnetworksw: false });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });

        }


      }

    } else if (prop === "paidupPMDcn") {
      payment.stayPMDcn = (
        event.target.value - parseFloat(idata.netAmount)
      ).toFixed(2);
      setPayment({ ...payment, [prop]: event.target.value });
    }
  };

  const MathChckedIdata = (prop, val) => {
    let res = Number(val);
    res += idata.cash_part;
    setIData({ ...idata, [prop]: "", cash_part: res });
  };

  const MathChangIdata = (prop, val) => {
    let ii = {
      totinv: Number(idata.netAmount),
      res: Number(val),
      sum: Number(0),
    };
    let i = {
      cashPart: Number(remains.cashPart),
      networkPart: Number(remains.networkPart),
      agelPart: Number(remains.agelPart),
      bankPart: Number(remains.bankPart),
      empPart: Number(remains.empPart),
    };
    let kind = "";
    const otherField = Object.keys(i).filter((f) => f !== prop);
    const remainaing = ii.totinv - ii.res;
    let newValue = { ...i, [prop]: ii.res };
    if (parseFloat(remainaing) < 0) {
      if (remains.isAgel == true && parseFloat(remains.agelPart) > 0 && prop !== "agelPart") {
        newValue[prop] = 0;
        otherField.forEach((f) => (newValue[f] = 0));
        newValue["agelPart"] = ii.totinv;
      } else {
        newValue[prop] = ii.totinv;
        otherField.forEach((f) => (newValue[f] = 0));
      }
    } else {
      newValue[prop] = ii.res;
      if (switchState.cashORnetworksw == false && remains.isCash == true &&
        remains.isAgel == false && prop !== "cashPart") {
        const cashFeild = Object.keys(i).filter((f) => f !== prop && f !== "cashPart");
        let sumOthers = cashFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
        newValue["cashPart"] = ii.totinv - (ii.res) - parseFloat(sumOthers);
      }
      else if (switchState.cashORnetworksw === true && remains.isNetwork == true
        && remains.isAgel == false && prop !== "networkPart") {
        const networkFeild = Object.keys(i).filter((f) => f !== prop && f !== "networkPart");
        let sumOthers = networkFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
        newValue["networkPart"] = ii.totinv - (ii.res) - parseFloat(sumOthers);
      } else if (remains.isAgel == true && parseFloat(remains.agelPart) > 0 && prop !== "agelPart") {
        const agelFeild = Object.keys(i).filter((f) => f !== prop && f !== "agelPart");
        let sumOthers = agelFeild.reduce((acc, f) => acc + parseFloat(i[f]) || 0, 0);
        if (ii.res >= ii.totinv) {
          newValue[prop] = 0;
          newValue["agelPart"] = ii.totinv;
        } else {
          newValue["agelPart"] = ii.totinv - (ii.res) - parseFloat(sumOthers);
        }
      }
    }
    let all = newValue.cashPart + newValue.agelPart +
      newValue.bankPart + newValue.empPart + newValue.networkPart;
    if (prop === "bankPart" && (idata.bank2 == -1 || idata.bank2 == 0)) {
      idata.bank = AutoOptions.Banks[0].id;
      idata.bank2 = AutoOptions.Banks[0].id;
    };

    setRemains({
      ...remains,
      agelPart: newValue.agelPart,
      bankPart: newValue.bankPart,
      cashPart: newValue.cashPart,
      networkPart: newValue.networkPart,
      empPart: newValue.empPart,
      isCash: parseFloat(newValue.cashPart) > 0 ? true : false,
      isAgel: parseFloat(newValue.agelPart) > 0 ? true : false,
      isNetwork: parseFloat(newValue.networkPart) > 0 ? true : false,
      isBank: parseFloat(newValue.bankPart) > 0 ? true : false,
      isEmp: parseFloat(newValue.empPart) > 0 ? true : false,
      allpart: all,
    });
  };
  const changIdata = (prop) => (event) => {
    if (prop === "cashPart" && remains.isCash === true) {
      MathChangIdata(prop, event.target.value);
    } if (prop === "networkPart" && remains.isNetwork === true) {
      MathChangIdata(prop, event.target.value);
    } else if (prop === "agelPart" && remains.isAgel === true) {
      MathChangIdata(prop, event.target.value);
    } else if (prop === "bankPart" && remains.isBank === true) {
      MathChangIdata(prop, event.target.value);
    }
    else if (prop === "empPart" && remains.isEmp === true) {
      MathChangIdata(prop, event.target.value);
    }
    else if (prop == "check_refno" && remains.isBank == true) {
      toDoIdata(prop, event.target.value);
    } else if (prop == "refno") {
      toDoIdata(prop, event.target.value);
    } else if (prop == "date") {
      toDoIdata(prop, event.target.value);
    } else if (prop == "notes") {
      toDoIdata(prop, event.target.value);
    }
    else if (prop == "Due_date") {
      toDoIdata(prop, event.target.value);
    }
    else if (prop == "Delivery_date") {
      toDoIdata(prop, event.target.value);
    }
  };


  const change_discount_cust = (prop, value) => {
    console.log("the permissions is", permistionInv);

    let ret = null,
      evenTargetValue = null;
    if (isdata.length !== 0) {
      if (prop === "minus") {
        let value_dsc = Number(value);

        if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03")
          evenTargetValue = (
            (value_dsc * 100) /
            parseFloat(idata.tot_sale)
          );
        else
          evenTargetValue = (
            (value_dsc * 100) /
            parseFloat(idata.tot_purch)
          );


        if (permistionInv.SDV !== 0)
          ret = retPrmiSDPandSDV(
            parseFloat(value_dsc),
            permistionInv.SDV,
            "DiscC"
          );

        else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDP, "DiscP");

        if (ret === "") {
          value = "";
          /*invDisc.rate='';*/ afterInvDescount(0, value_dsc);
        } else {
          afterInvDescount(evenTargetValue, value_dsc);
        }
      }
      else if (prop === "rate") {
        let value_perc = Number(value);

        if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03")
          evenTargetValue = (
            parseFloat(idata.tot_sale) *
            (value_perc / 100)
          );
        else
          evenTargetValue = (
            parseFloat(idata.tot_purch) *
            (value_perc / 100)
          );

        if (permistionInv.SDP !== 0)
          ret = retPrmiSDPandSDV(
            parseFloat(value_perc),
            permistionInv.SDP,
            "DiscP"
          );
        else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDV, "DiscC");
        if (ret === "") {
          value = "";
          /*idata.minus='';*/ afterInvDescount(0, evenTargetValue);
        } else {
          afterInvDescount(value_perc, evenTargetValue);
        }
      }
    }
    prop === "minus"
      ? setInvDisc({
        ...invDisc,
        [prop]: value,
        rate: parseFloat(evenTargetValue).toFixed(2),
      })
      : setInvDisc({
        ...invDisc,
        [prop]: value,
        minus: parseFloat(evenTargetValue).toFixed(2),
      });
  };

  const clickChangeCusomers = (newValue) => {
    if (newValue?.discount != null && newValue?.disc_perc != null) {

      if (newValue?.disc_perc > 0) {
        change_discount_cust("rate", newValue?.disc_perc);
      } else if (newValue?.discount > 0) {
        change_discount_cust("minus", newValue?.discount);
      } else if (newValue?.discount == 0 && newValue?.disc_perc == 0) {
        change_discount_cust("rate", 0);
      }
    }
  }

  const changinvDisc = (prop) => (event) => {
    console.log("the permissions is", permistionInv);

    let ret = null,
      evenTargetValue = null;
    if (isdata.length !== 0) {
      if (prop === "minus") {
        let value_dsc = Number(event.target.value);
        if (parseFloat(value_dsc) < 0) return;

        if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03")
          evenTargetValue = (
            (value_dsc * 100) /
            parseFloat(idata.tot_sale)
          );
        else
          evenTargetValue = (
            (value_dsc * 100) /
            parseFloat(idata.tot_purch)
          );


        if (permistionInv.SDV !== 0)
          ret = retPrmiSDPandSDV(
            parseFloat(value_dsc),
            permistionInv.SDV,
            "DiscC"
          );

        else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDP, "DiscP");

        if (ret === "") {
          event.target.value = "";
          /*invDisc.rate='';*/ afterInvDescount(0, value_dsc);
        } else {
          afterInvDescount(evenTargetValue, value_dsc);
        }
      }
      else if (prop === "rate") {
        let value_perc = Number(event.target.value);
        if (parseFloat(value_perc) < 0) return;

        if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03")
          evenTargetValue = (
            parseFloat(idata.tot_sale) *
            (value_perc / 100)
          );
        else
          evenTargetValue = (
            parseFloat(idata.tot_purch) *
            (value_perc / 100)
          );

        if (permistionInv.SDP !== 0)
          ret = retPrmiSDPandSDV(
            parseFloat(value_perc),
            permistionInv.SDP,
            "DiscP"
          );
        else ret = retPrmiSDPandSDV(evenTargetValue, permistionInv.SDV, "DiscC");
        if (ret === "") {
          event.target.value = "";
          /*idata.minus='';*/ afterInvDescount(0, evenTargetValue);
        } else {
          afterInvDescount(value_perc, evenTargetValue);
        }
      }
    }
    prop === "minus"
      ? setInvDisc({
        ...invDisc,
        [prop]: event.target.value,
        rate: parseFloat(evenTargetValue).toFixed(2),
      })
      : setInvDisc({
        ...invDisc,
        [prop]: event.target.value,
        minus: parseFloat(evenTargetValue).toFixed(2),
      });
  };

  const afterInvDescount = (rate, desc_mount) => {
    const isdataU = [...isdata];
    if (rate === "") rate = 0;
    for (let m = 0; m < isdata.length; m++) {
      let percRate = Number(rate);
      isdataU[m].DiscPers = percRate.toFixed(5);
      isdataU[m].barcode = isdata[m].barcode;
      isdataU[m].currency_from = isdata[m].currency_from;
      isdataU[m].discountTotal = ((isdata[m].totJust * percRate) / 100);
      isdataU[m].discount = ((isdata[m].totJust * percRate) / 100).toFixed(5);
      isdataU[m].new_exchange_price = isdata[m].new_exchange_price;
      isdataU[m].sub_branch = isdata[m].sub_branch;
      isdataU[m].sub_center = isdata[m].sub_center;
      isdataU[m].symbol = isdata[m].symbol;
      isdataU[m].totJust = isdata[m].totJust;

      isdataU[m].tot_before_vat_after_d =
        parseFloat(isdataU[m].totJust) - parseFloat(isdataU[m].discount);
      isdataU[m].taxperc = isdata[m].taxperc;

      /* from samer */
      isdataU[m].taxval = maths(
        parseFloat(isdataU[m].tot_before_vat_after_d),
        parseFloat(isdataU[m].taxperc),
        "taxval"
      );
      isdataU[m].netAmountSub = maths(
        parseFloat(isdataU[m].tot_before_vat_after_d),
        parseFloat(isdataU[m].taxperc),
        "Net"
      );
      isdataU[m].totAfterDisc = maths(
        parseFloat(isdataU[m].tot_before_vat_after_d),
        parseFloat(isdataU[m].taxperc),
        "before_vat"
      );

      /* from me */
      // console.log("memememememmemmememmm");
      isdataU[m].totJust = isdata[m].totJust;
      isdataU[m].unit = isdata[m].unit;
      isdataU[m].unitame = isdata[m].unitame;
      isdataU[m].val = isdata[m].val;
      isdataU[m].val1 = isdata[m].val1;
      isdataU[m].tab3Val = subInfo?.is_tab3_curr == 1 ? parseFloat(isdataU[m].tot_before_vat_after_d) : 0;
    }

    SumAfterDesc(isdataU, desc_mount);
    setIsData([...isdataU]);
  };

  const SumAfterDesc = (data, desc_mount) => {
    let val1s = 0,
      tot_sale_or_purch = 0,
      /*tot_sales=0,tot_purchs=0,*/ amountOfVats = 0,
      netAmounts = 0,
      amountAfterDiscs = 0,
      amount_after_disc_before_vat = 0,
      discounts = 0,
      amountWithVats = 0,
      invTab3Val = 0,
      taxpercs;


    for (var m = 0; m < data.length; m++) {
      val1s += parseFloat(data[m].val1);
      tot_sale_or_purch += parseFloat(data[m].totJust);
      taxpercs = data[m].taxperc;
      /* جمالي القيمة المضافة */
      amountOfVats += parseFloat(data[m].taxval);
      netAmounts += parseFloat(data[m].netAmountSub);
      /* إجمالي قبل الضريبة */
      amountAfterDiscs += parseFloat(data[m].totAfterDisc);
      discounts += parseFloat(data[m].discount).toFixed(2);

      // tobacco tax
      invTab3Val += parseFloat(data[m].tab3Val);
      amount_after_disc_before_vat += parseFloat(data[m].totAfterDisc);
    }

    /* في الحالتين */
    /* إجمالي بعد الخصم */
    amountWithVats = (
      parseFloat(tot_sale_or_purch) - parseFloat(desc_mount)
    ).toFixed(2);
    /* يشمل */


    if (permiCuCo.CWVat == 1) {
      amountAfterDiscs = (
        parseFloat(amount_after_disc_before_vat)
      ).toFixed(2);

      amountOfVats = (
        parseFloat(amountWithVats) - parseFloat(amountAfterDiscs)
      ).toFixed(2);

      netAmounts = (
        parseFloat(amountWithVats)
      ).toFixed(2);

    } else {
      /*لا يشمل */
      amountAfterDiscs = (
        parseFloat(amount_after_disc_before_vat)
      ).toFixed(2);

      netAmounts = (
        parseFloat(amountAfterDiscs) + parseFloat(amountOfVats)
      ).toFixed(2);

      amountWithVats = (
        parseFloat(amountAfterDiscs) + parseFloat(amountOfVats)
      ).toFixed(2);


    }



    setSums({ val1: val1s });
    setIData({
      ...idata,
      amountAfterDisc: amountAfterDiscs,
      amountWithVat: amountWithVats,
      tot_sale: tot_sale_or_purch,
      tot_purch: tot_sale_or_purch,
      netAmount: netAmounts,
      amountBefordisc: tot_sale_or_purch,
      amountOfVat: amountOfVats,
      minus: desc_mount,
      tab3Val: invTab3Val,
    });



    fcHandSumsToPayment(netAmounts);

    fcHandSumsToinvDisc(tot_sale_or_purch, discounts);
  };


  const afterGetCurrMathRate = (rate) => {
    const isdataU = [...isdata];
    if (rate === "") rate = 0;
    for (let m = 0; m < isdata.length; m++) {
      isdataU[m].DiscPers = rate;
      isdataU[m].barcode = isdata[m].barcode;
      isdataU[m].currency_from = isdata[m].currency_from;
      isdataU[m].discount = ((isdata[m].totJust * rate) / 100).toFixed(2);
      isdataU[m].new_exchange_price = isdata[m].new_exchange_price;
      isdataU[m].sub_branch = isdata[m].sub_branch;
      isdataU[m].sub_center = isdata[m].sub_center;
      isdataU[m].symbol = isdata[m].symbol;
      isdataU[m].totJust = isdata[m].totJust;


      // isdataU[m].totAfterDisc =
      //   isdata[m].totJust - parseFloat(isdataU[m].discount);

      isdataU[m].tot_before_vat_after_d =
        parseFloat(isdataU[m].totJust) - parseFloat(isdataU[m].discount);
      isdataU[m].taxperc = isdata[m].taxperc;

      /* from samer */
      isdataU[m].taxval = maths(
        parseFloat(isdataU[m].tot_before_vat_after_d),
        parseFloat(isdataU[m].taxperc),
        "taxval"
      );
      isdataU[m].netAmountSub = maths(
        parseFloat(isdataU[m].tot_before_vat_after_d),
        parseFloat(isdataU[m].taxperc),
        "Net"
      );
      isdataU[m].totAfterDisc = maths(
        parseFloat(isdataU[m].tot_before_vat_after_d),
        parseFloat(isdataU[m].taxperc),
        "before_vat"
      );

      /* from me */
      // console.log("memememememmemmememmm");
      isdataU[m].totJust = isdata[m].totJust;
      isdataU[m].unit = isdata[m].unit;
      isdataU[m].unitame = isdata[m].unitame;
      isdataU[m].val = isdata[m].val;
      isdataU[m].val1 = isdata[m].val1;
      isdataU[m].tab3Val = subInfo?.is_tab3_curr == 1 ? parseFloat(isdataU[m].tot_before_vat_after_d) : 0;
    }

    handSums(isdataU);
    setIsData([...isdataU]);
  };

  /* s toggle btn */
  const [toggle, setToggle] = React.useState(null);
  const [pdfToggle, setPdfToggle] = React.useState(null);

  const clickOpenToggle = (event, no = 1) => {
    if (isdata.length !== 0) {
      if (no != 1) setPdfToggle(event.currentTarget);
      else setToggle(event.currentTarget);
    } else {
      handOSnack({
        vertical: "top",
        horizontal: "right",
        severit: "warning",
        text: "يجب تنزيل اصناف أو إختيار فاتورة",
        time: 2000,
      });
    }
  };

  const clickOpenTogglePrint = (event) => {
    if (isdata.length !== 0) {
      setToggle(event.currentTarget);
    } else {
      handOSnack({
        vertical: "top",
        horizontal: "right",
        severit: "warning",
        text: "يجب تنزيل اصناف أو إختيار فاتورة",
        time: 2000,
      });
    }
  };


  const clickCloseToggle = () => {
    setToggle(null);
  };
  /* e toggle btn */
  // ========================================== s Snack

  /* 'error' 'warning' 'info' 'success'
     'top' 'bottom' 'center' 'left' 'right' */
  const [snack, setSnack] = React.useState(insh.Snack);

  const { vertical, horizontal, openSnak } = snack;

  const elmntBtn = (title, icondiv) => {
    return (
      <Button
        variant="contained"
        color="primary"
        size="large"
        style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
        disabled={true}
        startIcon={icondiv}
      >
        {" "}
        {title}
      </Button>
    );
  };

  const elmntIcon = (icondiv, dis) => {
    return (
      <Fab
        size="medium"
        color="primary"
        disabled={dis}
        style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
      >
        {icondiv}
      </Fab>
    );
  };

  const styBtn = {
    dis: { color: "#3b773d", background: "#4fa152" },
    undis: { color: "#fff" },
  };
  const handOSnack = (newState) => {
    setSnack({ openSnak: true, ...newState });
  };

  const handCSnack = (event, reason) => {
    // if (reason === 'clickaway') { return; }
    setSnack({ ...snack, openSnak: false });
  };

  const frontSnack = () => {
    return (
      <div className={clasSN.rootSN}>
        <Toaster />

        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={openSnak}
          autoHideDuration={snack.time}
          onClose={handCSnack}
          key={vertical + horizontal}
          className={clasSN.snackbarSN}
        >
          <Alert onClose={handCSnack} severity={snack.severit}>
            {" "}
            {snack.text}{" "}
          </Alert>
        </Snackbar>
      </div>
    );
  };



  const changChckedYahm = () =>
    alert("يمكنك تغييرها من إعدادات المبيعات في النظام");

  const downNormalItems = () => {
    return (
      <MainInvoiceDownItems {...{
        rptParams,
        subInfo,
        isOpenUpdate,
        isStock,
        isPurches,
        AutoOptions,
        valueItemUnits,
        optionsCurrUnits,
        changAutoCurrUnits,
        setting,
        onChangeSearchNormal,
        onChangeData,
        onChangeAutoCurrNormal,
        changInfo,
        getrowDataCurrencie,
        permistionInv,
        autocompleteref,
        or,
        handleFocus,
      }}
      />

    );
  };

  //----alter1
  const hedInv = () => {
    return (
      <MainInvoiceHeader {...{
        AutoOptions,
        isPurches,
        setting,
        changChckedYahm,
        checked,
        handleOpenCustomer,
        changAutoCustomers
        , optionsCustomers,
        changAutoSalesMen,
        valueSalesmen,
        changAutoCostcenter,
        valueCostcenter,
        idata,
        changAutoType,
        valueType,
        valueSafes,
        changAutoSafes,
        changAutoStock,
        valueStock,
        changAutoBank,
        valueBank,
        changSwitch,
        uiElement,
        switchState,
        lbl,
        claslbl,
        gets,
        onChangeSearch,
        handleFocus,
        onChangeData,
        rptParams,
        setShowPaid,
        exsub,
        handClickInvs,
        infoInv,
        changIdata,
        omlaValue,
        showPaid,
        onChangeAutoDataSubCurr,
        clasCAB,
        changInvs,
        loading,
        toWhere,
        buttonClassnameSavetmp,
        changAutoOmla,
        SaleCheckbox,
        valueCustomers,
        permiCuCo,
        itmTble,
        footerInvoices,
        maxShifts,
        isStock,
        isMake,
        handleOpenItems,
        idSearch,
        setIdSearch,
        isHedden,
        permistionInv,
        getCustomerData,
        showCarOptions,
        setShowCarOptions,
        onChangeCarData,
        carOptions,
        CarItems,
        onChangeAutoCarData,
        isdata,
        onSubmitCar,
        setIsOpenUpdate,
        setIshedden,
        or,
        isOpenUpdate,
        isUpdateDate,
        downNormalItems,
        inputRefAuto,
        getNewItamsData,
        keepDate,
        setKeepDate
      }}
      />

    );
  };

  const itmTble = () => {

    return (
      <>
        <Hidden smUp={["sm"]}>
          <Grid item container className={clasup.rootupMu}
          >
            <Grid item lg={12} md={12} sm={12} xs={12} spacing={1}>
              <MaterialTable
                style={{ boxShadow: "none" }}
                options={{
                  showTitle: false,
                  toolbar: true,
                  search: false,
                  sorting: false,
                  selection: true,
                  searchFieldAlignment: "left",
                  searchFieldVariant: "outlined",
                  showSelectAllCheckbox: false,
                  showTextRowsSelected: false,
                  cellStyle: stElemnt.SubR,
                  headerStyle: isPurches ? stElemnt.SubHPruch : isStock ? stElemnt.SubHSafes : isMake ? stElemnt.SubHMake : stElemnt.SubHMu,
                  pageSize: 5,
                  paginationType: "stepped",
                  showFirstLastPageButtons: false,
                  paging: false,
                  maxBodyHeight: Mtb.minmaxBHSub,
                  minBodyHeight: Mtb.minmaxBHSub,
                }}
                components={{
                  Toolbar: (props) => (
                    <Fragment>
                      <div
                        className={clstoolbar.toolbarWrapper}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "2.7vh",
                        }}
                      >
                        <MTableToolbar
                          {...props}

                          searchFieldStyle={{ height: "2.4vh" }}
                        />
                      </div>
                    </Fragment>
                  ),
                }}

                actions={

                  (!isHedden
                    ?
                    ([
                      {
                        icon: () => <Delete />,
                        tooltip: "حذف الأصناف",
                        onClick: hRowDelete,
                      },
                    ])
                    : or.postput == "toPost" && isHeddenReturn ?
                      ([
                        {
                          icon: () => <Delete />,
                          tooltip: "حذف الأصناف",
                          onClick: hRowDelete,
                        },
                      ])
                      :
                      false
                  )

                }
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h3 style={{ color: "#000" }}></h3>
                    ),
                  },
                  toolbar: [{ searchPlaceholder: "بحث في السجل" }],
                }}
                columns={columnsInvSub}
                data={isdata}
                icons={
                  (!isHedden
                    ?
                    tableIcons
                    : or.postput == "toPost" && isHeddenReturn ? tableIcons :
                      false
                  )
                }


                editable={
                  (!isHedden
                    ?
                    ({
                      onRowUpdate: (newData, oldData) =>
                        new Promise((resolve) => {
                          hRowUpdate(newData, oldData, resolve);
                        })
                    })
                    : or.postput == "toPost" && isHeddenReturn ?
                      ({
                        onRowUpdate: (newData, oldData) =>
                          new Promise((resolve) => {
                            hRowUpdate(newData, oldData, resolve);
                          })
                      }) :

                      false
                  )
                }

              />
            </Grid>
          </Grid>
        </Hidden>
        <Hidden only={["xs"]}>
          {setting.PrTy_InPr === "01" ?
            (
              itmTblePurchase()
            ) :
            (
              <InvItemsTable {...{
                isdata, optionsCurrUnitsTable, setIsData, maths, handSums, isPurches, isStock,
                isMake, permistionInv, handOSnack, setting, setConfirmDialog, isHedden,
                or, isOpenUpdate, setRowUpdate, mathsTab3val
              }}
              />
            )
          }

        </Hidden>

      </>
    );
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeE = (event, newValue) => {
    setValueE(newValue);
  };
  const itmTblePurchase = () => {

    return (
      <>
        <AppBar position="static" style={{ backgroundColor: "fff" }} >
          <Tabs
            style={{ backgroundColor: "#fff" }}
            value={valueE}
            onChange={handleChangeE}
            aria-label="simple tabs example"
          >
            <Tab style={{ fontWeight: "bold", color: "#000" }} label="بيانات الاصناف" {...a11yProps(0)} />
            <Tab style={{ fontWeight: "bold", color: "#000" }} label="اعباء الفاتورة"{...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <TabPanel value={valueE} index={0}>
          <InvItemsTable {...{
            isdata, optionsCurrUnitsTable, setIsData, maths, handSums, isPurches, isStock,
            isMake, permistionInv, handOSnack, setting, setConfirmDialog, isHedden,
            or, isOpenUpdate, setRowUpdate, mathsTab3val
          }}
          />
        </TabPanel>
        <TabPanel value={valueE} index={1}>
          <InvoicesExpenses {...{
            AutoOptions,
            expenseList,
            setExpenseList,
            or, isOpenUpdate,
            gets, setConfirmDialog
          }}
          />
        </TabPanel>



      </>
    );
  };
  const footerInvoices = () => {
    return (
      <InvoiceFooter {...{
        isPurches,
        setting,
        idata,
        valueType,
        uiElement,
        changIdata,
        isStock,
        isMake,
        permistionInv,
        changinvDisc,
        invDisc,
        changClick,
        payment,
        changPayment,
        sums,
        currentUserName,
        isHedden,
        permiCuCo,
        or
      }}
      />

    );
  };

  const footAppbar = () => {
    return (
      <MainInvoiceAppar {...{
        ...props,
        buttonClassnameSave,
        buttonClassnameDelete,
        clasCAB,
        setting,
        loading,
        backHome,
        uiElement,
        success,
        handOpenDw,
        clickOpenToggle,
        isHedden,
        permistionInv,
        style,
        stElemnt,
        clasBA,
        switchState,
        handCOpenCu,
        TransitionUp,
        toWhere,
        toPrint,
        transForm,
        buttonClassnamePrint,
        elmntBtn,
        or,
        stor,
        setPdfToggle,
        generating,
        StyledMenuItem,
        deleteTos,
        transformDone,
        transformDonePurch,
        setConfirmDialog,
        pdfToggle,
        StyledMenu,
        handOpenDwt,
        handNewInv,
        HomeBcode,
        TransitionDown,
        styBtn,
        clickCloseToggle,
        toggle,
        clickOpenTogglePrint,
        isDialog,
        isKham,
        idata,
        AutoOptions,
        sendToZatca,
        isOpenUpdate,
        setIsOpenUpdate,
        onClickButton,
        procIdSearch,
        openButtonsSearch,
        setOpenButtonsSearch,
        isLoading,
        toPrintTemplate,
      }}
      />

    );
  };


  const frontInvs = () => {

    return (
      // <SearchInvoiceModal
      <SearchInvoicesMains
        {...{
          openDw,
          handCloseDw,
          transition,
          showChosedInv,
          invsShow,
          stElemnt,
          style,
          valueTypeFltr,
          gets,
          searchedInvShow,
          setOr,
          or,
          optionsCustomers,
          PcIdIvPc: setting.PrTy_InPr,
          setting,
          setIsClick,
          ished,
          AutoOptions,
          isHedden,
          permistionInv,
          setIshedden,
          isStock,
          isMake,
          isPurches,
        }}
      />
    );
  };

  function ScrollTop(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
      target: window ? window() : undefined,
      disableHysteresis: true,
      threshold: 100,
    });

    const handUp = (event) => {
      const anchor = (event.target.ownerDocument || document).querySelector(
        "#back-to-top-anchor"
      );
      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };

    return (
      <Zoom in={trigger}>
        <div onClick={handUp} role="presentation" className={clasFu.root}>
          {children}
        </div>
      </Zoom>
    );
  }
  ScrollTop.propTypes = {
    children: PropTypes.element.isRequired,
    window: PropTypes.func,
  };




  const frontInvst = () => {
    return (
      <OutstandingInvoice
        {...{
          AutoOptions,
          showChosedInvt,
          setting,
          isPurches,
          isStock,
          outstandData,
          setOutstandData
        }}
      />
    );
  };



  const [scroll, setScroll] = React.useState("paper");

  const CurrFavorite = () => {
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={dialog.fav}
          onClose={handleClDia}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle
            className={clasSM.dialogTitleSM}
            id="customized-dialog-title"
          >
            <Tabs
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              {gets.FavGroup.map((group, i) => (
                <Tab
                  key={i}
                  label={group.name}
                  onClick={() => changFavSlides(group.id)}
                />
              ))}
            </Tabs>
          </DialogTitle>

          <DialogContent dividers={scroll === "paper"}>
            <DialogContentText id="scroll-dialog-description">
              <FavCard
                prop={favGroups}
                onclick={(id, barcode) => BefrowDataCurrencie(id, barcode)}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleClDia("fav", false)} color="primary">
              {transForm("cancel")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const stylesserch = {
    input: {
      "&::placeholder": {
        textOverflow: "ellipsis !important",
        color: "blue",
        fontSize: 10,
      },
    },
  };


  const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  };

  useEffect(() => {

    if (isMobileDevice()) return;
    if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
      (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
    ) return;
    const handleKeyDown = async (event) => {
      if (event.key === 'F6') {
        if (or.postput == "toPut" && permistionInv.Up) {
          event.preventDefault();
          let balanceItems = null;
          const tb = {
            wait: true,
            checksItems: true,
            parms: {
              safe: valueSafes?.id,
              branch: sto.branchi,
              _Data: isdata,
            },
          };

          axios
            .post(uri + "GetD", tb)
            .then((res) => {
              balanceItems = isdata.map((sub) => {
                const blncData = res?.data?.itemsBalance.find((obj) => obj.currency_from === sub.currency_from);
                let valQuantity = (parseFloat(blncData?.Qtys ?? 0) + parseFloat(sub?.val1 * sub?.val)).toFixed(2);
                return {
                  ...sub,
                  Qtys: setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11" ?
                    valQuantity : blncData?.Qtys ?? 0,
                  PricePu: blncData.avgCost,
                  minPrice: blncData.avgCost,
                };
              });
              setIsData([...balanceItems]);
              setIshedden(false);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
      if (event.ctrlKey && event.key === "u") {

        if (or.postput == "toPut" && permistionInv.Up) {
          event.preventDefault();
          let balanceItems = null;
          const tb = {
            wait: true,
            checksItems: true,
            parms: {
              safe: valueSafes?.id,
              branch: sto.branchi,
              _Data: isdata,
            },
          };

          axios
            .post(uri + "GetD", tb)
            .then((res) => {
              balanceItems = isdata.map((sub) => {
                const blncData = res?.data?.itemsBalance.find((obj) => obj.currency_from === sub.currency_from);
                return {
                  ...sub,
                  Qtys: blncData?.Qtys ?? 0,
                  PricePu: blncData.avgCost,
                  minPrice: blncData.avgCost,
                };
              });
              setIsData([...balanceItems]);
              setIshedden(false);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
      if (event.ctrlKey && event.key === "j") {
        event.preventDefault();
        setConfirmDialog({
          isOpen: true,
          onConfirm: () => {
            deleteTos(event);
          },
        })
      }
      if (event.ctrlKey && event.key === "d") {
        if (or.postput == "toPost") {
          event.preventDefault();
          setIsUpdateDate(true);
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isHedden, isdata, or, AutoOptions, setting, isUpdateDate]);

  // const getCheckItems = (balanceItems) => {

  // }

  useEffect(() => {
    if (isMobileDevice()) return;
    if (isLoading) return;

    const handleKeyDown = async (event) => {
      //  if (event.altKey && event.key ==="p"){
      if (event.key === 'F3') {

        event.preventDefault();

        or.PrAC = 1;
        if (isdata.length == 0) {
          handOSnack({
            vertical: "top",
            horizontal: "center",
            severit: "warning",
            text: transForm("most_download_item"),
            time: 2000,
          });
        } else {
          toWhere("print", "e");
        }

      }
      if (event.key === 'F5') {

        event.preventDefault();

        or.PrAC = 3;
        if (isdata.length == 0) {
          handOSnack({
            vertical: "top",
            horizontal: "center",
            severit: "warning",
            text: transForm("most_download_item"),
            time: 2000,
          });
        } else {
          await toWhere("print", "e");
        }

      }
      if (event.key === 'F10') {
        if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
          (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
        ) return;
        if (isLoading) return;

        //if (event.altKey && event.key ==="s"){
        event.preventDefault();
        if (isdata.length == 0) {
          handOSnack({
            vertical: "top",
            horizontal: "center",
            severit: "warning",
            text: transForm("most_download_item"),
            time: 2000,
          });
        } else {
          await toWhere("save", "e");
        }

      }
      if (event.key === 'F11') {

        // if (event.altKey && event.key ==="l"){
        event.preventDefault();
        or.PrAC = 2;

        if (isdata.length == 0) {
          handOSnack({
            vertical: "top",
            horizontal: "center",
            severit: "warning",
            text: transForm("most_download_item"),
            time: 2000,
          });
        } else {
          await toWhere("print", "e");
        }

      }
      if (event.key === 'F2') {
        event.preventDefault();
        or.PrAC = 2;
        if (isdata.length == 0) {
          handOSnack({
            vertical: "top",
            horizontal: "center",
            severit: "warning",
            text: transForm("most_download_item"),
            time: 2000,
          });
        } else {
          await toPrintCashOrNetwork("print", "e", 1, false);
        }

      } if (event.key === 'F7') {
        event.preventDefault();
        or.PrAC = 2;
        if (isdata.length == 0) {
          handOSnack({
            vertical: "top",
            horizontal: "center",
            severit: "warning",
            text: transForm("most_download_item"),
            time: 2000,
          });
        } else {
          await toPrintCashOrNetwork("print", "e", 1, true);
        }

      }

    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };

  }, [idata, isdata, remains, payment, or, setting, isLoading, AutoOptions]);

  useEffect(() => {

    if (setting.PrTy_InPr == "12" || setting.PrTy_InPr == "11") {
      if (setting.PrTy_InPr == "12") {
        if (AutoOptions?.StepTwo?.id == 1) {
          setIshedden(true);
          setIsheddenReturn(true);
        } else {

        }
      }
      if (!permistionInv?.ALLOWRETURN) {
        setIshedden(true);
        setIsheddenReturn(true);
      }
    }
  }, [setting, permistionInv, isHedden]);



  const [awaitingMultiply, setAwaitingMultiply] = useState(false);
  const [buffer, setBuffer] = useState("");
  const [electedItemIndesk, setSelectedItemIndesk] = useState(null);
  useEffect(() => {
    if (isMobileDevice()) return;
    if (or.postput == "toPut" && !isOpenUpdate) return;
    if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
      (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
    ) return;
    if (isdata.length == 0) return;
    if (rptParams.barcode !== "" && rptParams.barcode !== null) return;

    const handleKeyDown = async (event) => {

      if (event.key === "*") {
        setAwaitingMultiply(true);
        setBuffer("");
        return;
      }

      if (awaitingMultiply) {
        if (!isNaN(event.key)) {
          setBuffer((prev) => prev + event.key);
        } else if (event.key === "Enter") {
          const multiplier = parseFloat(buffer);
          if (!isNaN(multiplier) && rowUpdate?.no !== null) {
            let maxQty = parseFloat(permistionInv?.MAXQTY ?? 100000);

            let tot = parseFloat(multiplier * rowUpdate.new_exchange_price);

            let desc_mount = (
              parseFloat(tot) *
              (rowUpdate.DiscPers / 100)
            );

            let totBe = parseFloat((multiplier * rowUpdate.new_exchange_price) - desc_mount);

            let taxMount = maths(
              parseFloat(totBe),
              parseFloat(rowUpdate.taxperc),
              "taxval"
            );
            let betTax = maths(
              parseFloat(totBe),
              parseFloat(rowUpdate.taxperc),
              "before_vat"
            );

            let resNetA = maths(
              parseFloat(totBe),
              parseFloat(rowUpdate.taxperc),
              "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(rowUpdate?.tab3val_sub) > 0) {
              let tot_before_new = maths(
                parseFloat(rowUpdate.new_exchange_price),
                parseFloat(rowUpdate.taxperc),
                "before_vat"
              );
              tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

              let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

              taxMount = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(rowUpdate.taxperc),
                "taxval"
              );

              resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                + parseFloat(taxMount)).toFixed(2);
            }
            let subInfoVal1_perc = multiplier * rowUpdate.val;
            let totValbef = 0.0;
            for (let m = 0; m < isdata.length; m++) {
              if (rowUpdate.currency_from == isdata[m].currency_from && rowUpdate.no != isdata[m]?.no)
                totValbef += (isdata[m].val1 * isdata[m].val);
            };
            let countsCurr = Number(rowUpdate?.Qtys) - Number(totValbef);

            if (permistionInv.SIM == false &&
              countsCurr < subInfoVal1_perc &&
              (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
              setRowUpdate(rowUpdate);
              handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: "الكمية المدخلة للصنف أكبر من رصيد المخزن",
                time: 2000,
              });
            }
            else if (parseFloat(multiplier) > parseFloat(maxQty) &&
              (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
              setRowUpdate(rowUpdate);
              handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: `لقد تجاوزت حد الكمية المسموح فيها... برجاء الذهاب لاعدادات النظام لزيادة الحد: 
                ${maxQty}`,
                time: 2000,
              });
            }
            else {
              const newData = {
                ...rowUpdate,
                val1: multiplier,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
              };

              const index = rowUpdate?.no;
              const dataUpdate = [...isdata];
              dataUpdate[index] = { ...newData };
              setIsData([...dataUpdate]);
              handSums(dataUpdate);
            }

          }
          setAwaitingMultiply(false);
          setBuffer("");
        } else {
          setAwaitingMultiply(false);
          setBuffer("");
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };

  }, [isdata, buffer, awaitingMultiply, idata, rptParams,
    permiCuCo, sums, rowUpdate, AutoOptions, or, setting]);


  useEffect(() => {

    if (isMobileDevice()) return;
    if (isdata.length == 0) return;
    if (or.postput == "toPut" && !isOpenUpdate) return;

    if (rptParams.barcode !== "" && rptParams.barcode !== null) return;
    if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
      (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
    ) return;
    const handleKeyDown = async (event) => {

      if (event.key === "+") {
        const lastRow = rowUpdate?.no != null ? isdata.find((obj) =>
          obj.no === rowUpdate.no) :
          isdata.reduce((max, item) =>
            item.no > max.no ? item : max
          );
        if (isdata.length > 0) {
          event.preventDefault();

          let add = 1;
          let multiplier = (parseFloat(lastRow?.val1) + parseFloat(add)).toFixed(2);
          if (!isNaN(multiplier)) {

            let tot = parseFloat(multiplier * lastRow.new_exchange_price);

            let desc_mount = (
              parseFloat(tot) *
              (lastRow.DiscPers / 100)
            );
            let totBe = parseFloat((multiplier * lastRow.new_exchange_price) - desc_mount);
            let maxQty = parseFloat(permistionInv?.MAXQTY ?? 100000);

            let taxMount = maths(
              parseFloat(totBe),
              parseFloat(lastRow.taxperc),
              "taxval"
            );
            let betTax = maths(
              parseFloat(totBe),
              parseFloat(lastRow.taxperc),
              "before_vat"
            );

            let resNetA = maths(
              parseFloat(totBe),
              parseFloat(lastRow.taxperc),
              "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(lastRow?.tab3val_sub) > 0) {
              let tot_before_new = maths(
                parseFloat(lastRow.new_exchange_price),
                parseFloat(lastRow.taxperc),
                "before_vat"
              );
              tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

              let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

              taxMount = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(lastRow.taxperc),
                "taxval"
              );

              resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                + parseFloat(taxMount)).toFixed(2);
            }
            let subInfoVal1_perc = multiplier * lastRow?.val;

            let totValbef = 0.0;
            for (let m = 0; m < isdata.length; m++) {
              if (lastRow.currency_from == isdata[m].currency_from && lastRow.no != isdata[m]?.no)
                totValbef += (isdata[m].val1 * isdata[m].val);
            };
            let countsCurr = Number(lastRow?.Qtys) - Number(totValbef);
            if (permistionInv.SIM == false &&
              countsCurr < subInfoVal1_perc &&
              (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
              handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: "الكمية المدخلة للصنف أكبر من رصيد المخزن",
                time: 2000,
              });
            } else if (parseFloat(multiplier) > parseFloat(maxQty) &&
              (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
              setRowUpdate(rowUpdate);
              handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: `لقد تجاوزت حد الكمية المسموح فيها... برجاء الذهاب لاعدادات النظام لزيادة الحد: 
              ${maxQty}`,
                time: 2000,
              });
            }
            else {
              const newData = {
                ...lastRow,
                val1: multiplier,
                totJust: tot,
                totAfterDisc: betTax,
                taxval: taxMount,
                netAmountSub: resNetA,
                discount: desc_mount,
                tab3val_sub: tot_before_vat_with_tab3val,
                tab3Val: tot_before_vat_with_tab3val,
              };

              const index = lastRow?.no;
              const dataUpdate = [...isdata];
              dataUpdate[index] = { ...newData };
              setIsData([...dataUpdate]);
              handSums(dataUpdate);
            }

          }

        }
      }
      else if (event.key === "-") {
        const lastRow = rowUpdate?.no != null ? isdata.find((obj) =>
          obj.no === rowUpdate.no) :
          isdata.reduce((max, item) =>
            item.no > max.no ? item : max
          );
        if (isdata.length > 0 && lastRow?.no !== null) {
          event.preventDefault();
          let add = 1;

          let multiplier = 1;
          if (lastRow.val1 > 1) {
            multiplier = (parseFloat(lastRow?.val1) - parseFloat(add)).toFixed(2);
          } else {
            multiplier = parseFloat(lastRow?.val1).toFixed(2);
          }
          if (!isNaN(multiplier)) {

            let tot = parseFloat(multiplier * lastRow.new_exchange_price);
            let desc_mount = (
              parseFloat(tot) *
              (lastRow.DiscPers / 100)
            );
            let totBe = parseFloat((multiplier * lastRow.new_exchange_price) - desc_mount);

            let taxMount = maths(
              parseFloat(totBe),
              parseFloat(lastRow.taxperc),
              "taxval"
            );
            let betTax = maths(
              parseFloat(totBe),
              parseFloat(lastRow.taxperc),
              "before_vat"
            );

            let resNetA = maths(
              parseFloat(totBe),
              parseFloat(lastRow.taxperc),
              "Net"
            );
            let tot_before_vat_with_tab3val = 0;
            if (parseFloat(lastRow?.tab3val_sub) > 0) {
              let tot_before_new = maths(
                parseFloat(lastRow.new_exchange_price),
                parseFloat(lastRow.taxperc),
                "before_vat"
              );
              tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

              let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

              taxMount = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(lastRow.taxperc),
                "taxval"
              );

              resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                + parseFloat(taxMount)).toFixed(2);
            }
            const newData = {
              ...lastRow,
              val1: multiplier,
              totJust: tot,
              totAfterDisc: betTax,
              taxval: taxMount,
              netAmountSub: resNetA,
              discount: desc_mount,
              tab3val_sub: tot_before_vat_with_tab3val,
              tab3Val: tot_before_vat_with_tab3val,
            };

            const index = lastRow?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = { ...newData };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
          }

        }
      }
      else if (event.key === "Delete") {
        const lastRow = rowUpdate?.no != null ? isdata.find((obj) =>
          obj.no === rowUpdate.no) :
          isdata.reduce((max, item) =>
            item.no > max.no ? item : max
          );
        if (isdata?.length > 0 && lastRow.no != null) {
          setConfirmDialog({
            isOpen: true,
            onConfirm: () => {
              var newData = isdata.filter((obj) => obj.no !== lastRow.no);
              const newItems = newData.map((row, i) => {
                return {
                  ...row,
                  no: i,
                };
              });
              setIsData([...newItems]);
              handSums(newData);
              setConfirmDialog(false);
              setRowUpdate({});
            },
          })

        }
      }

    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isdata, idata, permiCuCo, sums, rowUpdate,
    confirmDialog, AutoOptions, or, setting, rptParams]);

  const clickUpdate = () => {
    if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
      (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
    ) return;
    if (!permistionInv.Up) return;
    if (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12") {
      {
        setIshedden(false);
      }
    }
  };
  const frontCurrencis = () => {

    return (
      // <InvoiceItemsModal
      <InvoiceItemsModals
        {...{
          openCuD,
          handleCloseCuD,
          transition,
          switchState,
          groups,
          groupsSub,
          changSlides,
          changAutoss,
          subInfo,
          cuRows,
          permiCuCo,
          setting,
          changAutoPricePay,
          valuePricePay,
          changAutoCurrUnits,
          changInfo,
          optionsPricePay,
          optionsCurrUnits,
          checked,
          changSwitch,
          _onDetected,
          changChcked,
          getrowDataCurrencie,
          stElemnt,
          counts,
          permistionInv,
          rptParams,
          onChangeSearchD,
          AutoOptions,
          isPurches,
          onChangeData,
          onChangeDataA,
          onChangeAutoDataG,
          groupsSubs,
          onChangeAutoDataSub,
          onRowClicks,
          viewHandle,
          groupsOptions,
          handleOpenItems,
          isStock,
          isMake,
          valueItemUnits,
          valueCurrUnits,

        }}
      />
    );
  };

  if (!isApiConnect) return <ReConnect />;

  return showSc ? (
    <BackdropScI />
  ) : (
    <div
      style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }} >
      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <Grid
          container
          justifyContent="center"
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <div style={{ backgroundColor: "fff" }}>
              <AppBar position="static" style={{ backgroundColor: "fff" }} >
                <Tabs
                  style={{
                    backgroundColor: isPurches ? colors.blue[50] : colors.green[50],
                    textAlign: "center",
                    fontSize: 20,
                    width: "100%",
                    direction: "rtl"
                  }}
                  value={value}
                  onChange={handleChange}
                  aria-label="simple tabs example"
                >
                  <Tab
                    onDoubleClick={(event) => clickUpdate()}
                    style={{ fontWeight: "bold", color: "#000" }} label={setting.PrTy_InPr === "02" ? transForm('sales_invoice') : setting.PrTy_InPr === "12" ? transForm('return_sales')
                      : setting.PrTy_InPr === "01" ? transForm('purchase_invoice') : setting.PrTy_InPr === "11" ? transForm('return_purchase') :
                        setting.PrTy_InPr === "03" ? transForm("quotation") : setting.PrTy_InPr === "04" ? transForm("purchase_order") :
                          setting.PrTy_InPr === "22" ? transForm("first_stock") : setting.PrTy_InPr === "33" ? transForm("made_Order") : setting.titleHed}
                    {...a11yProps(0)} />
                  {!props.isDialog &&
                    (

                      <Tab style={{ fontWeight: "bold", color: "#000" }} label={transForm("invoice-search")}{...a11yProps(1)} />
                    )}
                  {!props.isDialog &&
                    (

                      <Tab style={{ fontWeight: "bold", color: "#000" }} label={transForm("out-billing")}{...a11yProps(2)} />
                    )}
                  {!props.isDialog &&
                    (

                      <Tab style={{ fontWeight: "bold", color: "#000" }} label="استيراد من اكسل"{...a11yProps(3)} />
                    )}
                </Tabs>
              </AppBar>

              <TabPanel value={value} index={0} keepMounted>
                <div
                  style={{ direction: i18next.language == "ar" ? "ltr" : "rtl" }}
                >
                  {frontSnack()}
                  {footAppbar()}
                  {hedInv()}
                  {frontInvs()}
                  {/* {frontInvst()} */}
                  {frontCurrencis()}
                  {/* s currFavD */} {CurrFavorite()} {/* e currFavD */}
                  {
                    allow.c ? (
                      <CustomersDialog
                        open={isOpenCustomer}
                        type={location.state.setting.cusType}
                        onClose={() => {
                          setIsOpenCustomer(false);
                          // reloadGet();
                        }}
                        onSave={(custData) => {
                          setIsOpenCustomer(false);
                          reLoadCust(custData);
                        }}

                      />
                    ) : null}
                  {
                    allow.cud ? (
                      <CustomerDialogData
                        open={isOpenCustomerData}
                        type={location.state.setting.cusType}
                        onClose={() => {
                          setIsOpenCustomerData(false);
                          // reloadGet();
                        }}
                        onSave={(updateData) => {
                          setIsOpenCustomerData(false);
                          reUpdateCust(updateData);
                        }}
                        custData={custData}
                      />
                    ) : null}

                  {
                    allow.it ? (
                      <ItemsDialog
                        open={isOpenItems}
                        onClose={() => {
                          setIsOpenItems(false);
                        }}
                        itemdata={newItemsAdd}
                      />
                    ) : null}
                  <DeleteConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                  />
                  <ExtVoucherDialog
                    voucherDialog={voucherDialog}
                    setVoucherDialog={setVoucherDialog}
                  />
                  <PaidWindowForm
                    {... {
                      idata,
                      remains,
                      setRemains,
                      invDisc,
                      payment,
                      changPayment,
                      buttonClassnameSavePMD,
                      toDB, loading,
                      handClosePMD,
                      style,
                      gets,
                      openPMD,
                      valueEmployePMD,
                      transition,
                      clasAo,
                      valueBankPMD,
                      changAutoBankPMD,
                      changIdata,
                      changAutoEmployee,
                      valueType,
                      setIData,
                      valueAutoBankPaid,
                      valueBanksPaid
                    }}
                  />



                </div>
              </TabPanel>

              <TabPanel value={value} index={1} keepMounted>
                <SearchInvoiceScreean
                  {...{
                    openDw,
                    handCloseDw,
                    transition,
                    showChosedInv,
                    invsShow,
                    stElemnt,
                    style,
                    valueTypeFltr,
                    gets,
                    searchedInvShow,
                    setOr,
                    or,
                    optionsCustomers,
                    PcIdIvPc: setting.PrTy_InPr,
                    setting,
                    setIsClick,
                    ished,
                    AutoOptions,
                    isHedden,
                    permistionInv,
                    setIshedden,
                    isStock,
                    isMake,
                    isPurches,
                    invsSearchTable,
                    setInvsSearchTable,
                    setValue
                  }}
                />
              </TabPanel>

              <TabPanel value={value} index={2} keepMounted>
                {frontInvst()}
              </TabPanel>
              <TabPanel value={value} index={3} keepMounted>
                {/* <b>استيراد من اكسل</b> */}
                <ImportExcel
                  {...{
                    isPurches: isPurches,
                    isStock: isStock,
                    isItem: false,
                    isSales: !isPurches && !isStock && !isMake ? true : false,
                    getFormExcelData,
                    excelData,
                    setExcelData
                  }}
                />
              </TabPanel>
            </div>
          </Grid>
        </Grid>

      </Typography>
    </div>
  );
}
